"use strict";

var _regeneratorRuntime = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseVKApi_1 = require("../api/BaseVKApi");

var VKApi =
/*#__PURE__*/
function (_BaseVKApi_1$BaseVKAp) {
  _inherits(VKApi, _BaseVKApi_1$BaseVKAp);

  function VKApi() {
    _classCallCheck(this, VKApi);

    return _possibleConstructorReturn(this, _getPrototypeOf(VKApi).apply(this, arguments));
  }

  _createClass(VKApi, [{
    key: "usersGet",

    /**
     * Returns detailed information on users.
     *
     * @param {{
     *   user_ids: (string[]|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UsersGetResponse>}
     */
    value: function usersGet(params) {
      var _this = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _super("call").call(this, "users.get", params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Returns a list of users matching the search criteria.
     *
     * @param {{
     *   q: (string|undefined),
     *   sort: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   city: (number|undefined),
     *   country: (number|undefined),
     *   hometown: (string|undefined),
     *   university_country: (number|undefined),
     *   university: (number|undefined),
     *   university_year: (number|undefined),
     *   university_faculty: (number|undefined),
     *   university_chair: (number|undefined),
     *   sex: (number|undefined),
     *   status: (number|undefined),
     *   age_from: (number|undefined),
     *   age_to: (number|undefined),
     *   birth_day: (number|undefined),
     *   birth_month: (number|undefined),
     *   birth_year: (number|undefined),
     *   online: (boolean|undefined),
     *   has_photo: (boolean|undefined),
     *   school_country: (number|undefined),
     *   school_city: (number|undefined),
     *   school_class: (number|undefined),
     *   school: (number|undefined),
     *   school_year: (number|undefined),
     *   religion: (string|undefined),
     *   interests: (string|undefined),
     *   company: (string|undefined),
     *   position: (string|undefined),
     *   group_id: (number|undefined),
     *   from_list: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UsersSearchResponse>}
     */

  }, {
    key: "usersSearch",
    value: function usersSearch(params) {
      var _this2 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this2);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _super("call").call(this, "users.search", params));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Returns information whether a user installed the application.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UsersIsAppUserResponse>}
     */

  }, {
    key: "usersIsAppUser",
    value: function usersIsAppUser(params) {
      var _this3 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this3);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _super("call").call(this, "users.isAppUser", params));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Returns a list of IDs of users and communities followed by the user.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   extended: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UsersGetSubscriptionsResponse>}
     */

  }, {
    key: "usersGetSubscriptions",
    value: function usersGetSubscriptions(params) {
      var _this4 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this4);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", _super("call").call(this, "users.getSubscriptions", params));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Returns a list of IDs of followers of the user in question, sorted by date added, most recent first.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UsersGetFollowersResponse>}
     */

  }, {
    key: "usersGetFollowers",
    value: function usersGetFollowers(params) {
      var _this5 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this5);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", _super("call").call(this, "users.getFollowers", params));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Reports (submits a complain about) a user.
     *
     * @param {{
     *   user_id: (number),
     *   type: (string),
     *   comment: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "usersReport",
    value: function usersReport(params) {
      var _this6 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this6);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", _super("call").call(this, "users.report", params));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * Checks a user's phone number for correctness.
     *
     * @param {{
     *   phone: (string),
     *   client_id: (number|undefined),
     *   client_secret: (string),
     *   auth_by_phone: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "authCheckPhone",
    value: function authCheckPhone(params) {
      var _this7 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this7);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", _super("call").call(this, "auth.checkPhone", params));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Allows to restore account access using a code received via SMS. " This method is only available for apps with [vk.com/dev/auth_direct|Direct authorization] access. "
     *
     * @param {{
     *   phone: (string),
     *   last_name: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AuthRestoreResponse>}
     */

  }, {
    key: "authRestore",
    value: function authRestore(params) {
      var _this8 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this8);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", _super("call").call(this, "auth.restore", params));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Returns a list of posts on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   domain: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   filter: (string|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallGetResponse>}
     */

  }, {
    key: "wallGet",
    value: function wallGet(params) {
      var _this9 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this9);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", _super("call").call(this, "wall.get", params));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Allows to search posts on user or community walls.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   domain: (string|undefined),
     *   query: (string|undefined),
     *   owners_only: (boolean|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallSearchResponse>}
     */

  }, {
    key: "wallSearch",
    value: function wallSearch(params) {
      var _this10 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this10);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", _super("call").call(this, "wall.search", params));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Creates an empty photo album.
     *
     * @param {{
     *   title: (string),
     *   group_id: (number|undefined),
     *   description: (string|undefined),
     *   privacy_view: (string[]|undefined),
     *   privacy_comment: (string[]|undefined),
     *   upload_by_admins_only: (boolean|undefined),
     *   comments_disabled: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosCreateAlbumResponse>}
     */

  }, {
    key: "photosCreateAlbum",
    value: function photosCreateAlbum(params) {
      var _this11 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this11);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", _super("call").call(this, "photos.createAlbum", params));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
    /**
     * Edits information about a photo album.
     *
     * @param {{
     *   album_id: (number),
     *   title: (string|undefined),
     *   description: (string|undefined),
     *   owner_id: (number|undefined),
     *   privacy_view: (string[]|undefined),
     *   privacy_comment: (string[]|undefined),
     *   upload_by_admins_only: (boolean|undefined),
     *   comments_disabled: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosEditAlbum",
    value: function photosEditAlbum(params) {
      var _this12 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this12);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", _super("call").call(this, "photos.editAlbum", params));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * Returns a list of a user's or community's photo albums.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   album_ids: (number[]|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   need_system: (boolean|undefined),
     *   need_covers: (boolean|undefined),
     *   photo_sizes: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetAlbumsResponse>}
     */

  }, {
    key: "photosGetAlbums",
    value: function photosGetAlbums(params) {
      var _this13 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this13);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", _super("call").call(this, "photos.getAlbums", params));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * Returns a list of a user's or community's photos.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   album_id: (string|undefined),
     *   photo_ids: (string[]|undefined),
     *   rev: (boolean|undefined),
     *   extended: (boolean|undefined),
     *   feed_type: (string|undefined),
     *   feed: (number|undefined),
     *   photo_sizes: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetResponse>}
     */

  }, {
    key: "photosGet",
    value: function photosGet(params) {
      var _this14 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this14);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", _super("call").call(this, "photos.get", params));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
    /**
     * Returns the number of photo albums belonging to a user or community.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetAlbumsCountResponse>}
     */

  }, {
    key: "photosGetAlbumsCount",
    value: function photosGetAlbumsCount(params) {
      var _this15 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this15);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", _super("call").call(this, "photos.getAlbumsCount", params));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
    /**
     * Returns information about photos by their IDs.
     *
     * @param {{
     *   photos: (string[]),
     *   extended: (boolean|undefined),
     *   photo_sizes: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetByIdResponse>}
     */

  }, {
    key: "photosGetById",
    value: function photosGetById(params) {
      var _this16 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this16);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", _super("call").call(this, "photos.getById", params));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
    /**
     * Returns the server address for photo upload.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   album_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetUploadServerResponse>}
     */

  }, {
    key: "photosGetUploadServer",
    value: function photosGetUploadServer(params) {
      var _this17 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this17);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", _super("call").call(this, "photos.getUploadServer", params));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
    /**
     * Returns the server address for owner cover upload.
     *
     * @param {{
     *   group_id: (number),
     *   crop_x: (number|undefined),
     *   crop_y: (number|undefined),
     *   crop_x2: (number|undefined),
     *   crop_y2: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BaseGetUploadServerResponse>}
     */

  }, {
    key: "photosGetOwnerCoverPhotoUploadServer",
    value: function photosGetOwnerCoverPhotoUploadServer(params) {
      var _this18 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this18);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", _super("call").call(this, "photos.getOwnerCoverPhotoUploadServer", params));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
    /**
     * Returns an upload server address for a profile or community photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetOwnerPhotoUploadServerResponse>}
     */

  }, {
    key: "photosGetOwnerPhotoUploadServer",
    value: function photosGetOwnerPhotoUploadServer(params) {
      var _this19 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this19);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", _super("call").call(this, "photos.getOwnerPhotoUploadServer", params));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
    /**
     * Returns an upload link for chat cover pictures.
     *
     * @param {{
     *   chat_id: (number),
     *   crop_x: (number|undefined),
     *   crop_y: (number|undefined),
     *   crop_width: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetUploadServerResponse>}
     */

  }, {
    key: "photosGetChatUploadServer",
    value: function photosGetChatUploadServer(params) {
      var _this20 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this20);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", _super("call").call(this, "photos.getChatUploadServer", params));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
    /**
     * Returns the server address for market photo upload.
     *
     * @param {{
     *   group_id: (number),
     *   main_photo: (boolean|undefined),
     *   crop_x: (number|undefined),
     *   crop_y: (number|undefined),
     *   crop_width: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetMarketUploadServerResponse>}
     */

  }, {
    key: "photosGetMarketUploadServer",
    value: function photosGetMarketUploadServer(params) {
      var _this21 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this21);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", _super("call").call(this, "photos.getMarketUploadServer", params));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
    /**
     * Returns the server address for market album photo upload.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BaseGetUploadServerResponse>}
     */

  }, {
    key: "photosGetMarketAlbumUploadServer",
    value: function photosGetMarketAlbumUploadServer(params) {
      var _this22 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this22);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", _super("call").call(this, "photos.getMarketAlbumUploadServer", params));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
    /**
     * Saves market photos after successful uploading.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   photo: (string),
     *   server: (number),
     *   hash: (string),
     *   crop_data: (string|undefined),
     *   crop_hash: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveMarketPhotoResponse>}
     */

  }, {
    key: "photosSaveMarketPhoto",
    value: function photosSaveMarketPhoto(params) {
      var _this23 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this23);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", _super("call").call(this, "photos.saveMarketPhoto", params));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
    /**
     * Saves cover photo after successful uploading.
     *
     * @param {{
     *   hash: (string),
     *   photo: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveOwnerCoverPhotoResponse>}
     */

  }, {
    key: "photosSaveOwnerCoverPhoto",
    value: function photosSaveOwnerCoverPhoto(params) {
      var _this24 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this24);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", _super("call").call(this, "photos.saveOwnerCoverPhoto", params));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
    /**
     * Saves market album photos after successful uploading.
     *
     * @param {{
     *   group_id: (number),
     *   photo: (string),
     *   server: (number),
     *   hash: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveMarketAlbumPhotoResponse>}
     */

  }, {
    key: "photosSaveMarketAlbumPhoto",
    value: function photosSaveMarketAlbumPhoto(params) {
      var _this25 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this25);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", _super("call").call(this, "photos.saveMarketAlbumPhoto", params));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    }
    /**
     * Saves a profile or community photo. Upload URL can be got with the [vk.com/dev/photos.getOwnerPhotoUploadServer|photos.getOwnerPhotoUploadServer] method.
     *
     * @param {{
     *   server: (string|undefined),
     *   hash: (string|undefined),
     *   photo: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveOwnerPhotoResponse>}
     */

  }, {
    key: "photosSaveOwnerPhoto",
    value: function photosSaveOwnerPhoto(params) {
      var _this26 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this26);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", _super("call").call(this, "photos.saveOwnerPhoto", params));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
    /**
     * Saves a photo to a user's or community's wall after being uploaded.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   group_id: (number|undefined),
     *   photo: (string),
     *   server: (number|undefined),
     *   hash: (string|undefined),
     *   latitude: (number|undefined),
     *   longitude: (number|undefined),
     *   caption: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveWallPhotoResponse>}
     */

  }, {
    key: "photosSaveWallPhoto",
    value: function photosSaveWallPhoto(params) {
      var _this27 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this27);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", _super("call").call(this, "photos.saveWallPhoto", params));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
    /**
     * Returns the server address for photo upload onto a user's wall.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetWallUploadServerResponse>}
     */

  }, {
    key: "photosGetWallUploadServer",
    value: function photosGetWallUploadServer(params) {
      var _this28 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this28);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", _super("call").call(this, "photos.getWallUploadServer", params));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
    /**
     * Returns the server address for photo upload in a private message for a user.
     *
     * @param {{
     *   peer_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetMessagesUploadServerResponse>}
     */

  }, {
    key: "photosGetMessagesUploadServer",
    value: function photosGetMessagesUploadServer(params) {
      var _this29 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this29);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", _super("call").call(this, "photos.getMessagesUploadServer", params));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
    /**
     * Saves a photo after being successfully uploaded. URL obtained with [vk.com/dev/photos.getMessagesUploadServer|photos.getMessagesUploadServer] method.
     *
     * @param {{
     *   photo: (string),
     *   server: (number|undefined),
     *   hash: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveMessagesPhotoResponse>}
     */

  }, {
    key: "photosSaveMessagesPhoto",
    value: function photosSaveMessagesPhoto(params) {
      var _this30 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this30);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", _super("call").call(this, "photos.saveMessagesPhoto", params));

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
    /**
     * Reports (submits a complaint about) a photo.
     *
     * @param {{
     *   owner_id: (number),
     *   photo_id: (number),
     *   reason: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosReport",
    value: function photosReport(params) {
      var _this31 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this31);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31() {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", _super("call").call(this, "photos.report", params));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    }
    /**
     * Reports (submits a complaint about) a comment on a photo.
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   reason: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosReportComment",
    value: function photosReportComment(params) {
      var _this32 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this32);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", _super("call").call(this, "photos.reportComment", params));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }
    /**
     * Returns a list of photos.
     *
     * @param {{
     *   q: (string|undefined),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   sort: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   radius: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSearchResponse>}
     */

  }, {
    key: "photosSearch",
    value: function photosSearch(params) {
      var _this33 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this33);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33() {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                return _context33.abrupt("return", _super("call").call(this, "photos.search", params));

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));
    }
    /**
     * Returns a list of user IDs or detailed information about a user's friends.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   order: (string|undefined),
     *   list_id: (number|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetResponse>}
     */

  }, {
    key: "friendsGet",
    value: function friendsGet(params) {
      var _this34 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this34);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                return _context34.abrupt("return", _super("call").call(this, "friends.get", params));

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
    /**
     * Returns a list of user IDs of a user's friends who are online.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   list_id: (number|undefined),
     *   online_mobile: (boolean|undefined),
     *   order: (string|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetOnlineResponse>}
     */

  }, {
    key: "friendsGetOnline",
    value: function friendsGetOnline(params) {
      var _this35 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this35);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                return _context35.abrupt("return", _super("call").call(this, "friends.getOnline", params));

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }
    /**
     * Returns a list of user IDs of the mutual friends of two users.
     *
     * @param {{
     *   source_uid: (number|undefined),
     *   target_uid: (number|undefined),
     *   target_uids: (number[]|undefined),
     *   order: (string|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetMutualResponse>}
     */

  }, {
    key: "friendsGetMutual",
    value: function friendsGetMutual(params) {
      var _this36 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this36);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                return _context36.abrupt("return", _super("call").call(this, "friends.getMutual", params));

              case 1:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    }
    /**
     * Returns a list of user IDs of the current user's recently added friends.
     *
     * @param {{
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetRecentResponse>}
     */

  }, {
    key: "friendsGetRecent",
    value: function friendsGetRecent(params) {
      var _this37 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this37);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37() {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", _super("call").call(this, "friends.getRecent", params));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    }
    /**
     * Returns information about the current user's incoming and outgoing friend requests.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   need_mutual: (boolean|undefined),
     *   out: (boolean|undefined),
     *   sort: (number|undefined),
     *   need_viewed: (boolean|undefined),
     *   suggested: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetRequestsResponse>}
     */

  }, {
    key: "friendsGetRequests",
    value: function friendsGetRequests(params) {
      var _this38 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this38);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                return _context38.abrupt("return", _super("call").call(this, "friends.getRequests", params));

              case 1:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
    /**
     * Approves or creates a friend request.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   text: (string|undefined),
     *   follow: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsAddResponse>}
     */

  }, {
    key: "friendsAdd",
    value: function friendsAdd(params) {
      var _this39 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this39);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                return _context39.abrupt("return", _super("call").call(this, "friends.add", params));

              case 1:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    }
    /**
     * Edits the friend lists of the selected user.
     *
     * @param {{
     *   user_id: (number),
     *   list_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "friendsEdit",
    value: function friendsEdit(params) {
      var _this40 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this40);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40() {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                return _context40.abrupt("return", _super("call").call(this, "friends.edit", params));

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
    /**
     * Declines a friend request or deletes a user from the current user's friend list.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsDeleteResponse>}
     */

  }, {
    key: "friendsDelete",
    value: function friendsDelete(params) {
      var _this41 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this41);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                return _context41.abrupt("return", _super("call").call(this, "friends.delete", params));

              case 1:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    }
    /**
     * Returns a list of the user's friend lists.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   return_system: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetListsResponse>}
     */

  }, {
    key: "friendsGetLists",
    value: function friendsGetLists(params) {
      var _this42 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this42);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42() {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", _super("call").call(this, "friends.getLists", params));

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    }
    /**
     * Creates a new friend list for the current user.
     *
     * @param {{
     *   name: (string),
     *   user_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsAddListResponse>}
     */

  }, {
    key: "friendsAddList",
    value: function friendsAddList(params) {
      var _this43 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this43);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", _super("call").call(this, "friends.addList", params));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));
    }
    /**
     * Edits a friend list of the current user.
     *
     * @param {{
     *   name: (string|undefined),
     *   list_id: (number),
     *   user_ids: (number[]|undefined),
     *   add_user_ids: (number[]|undefined),
     *   delete_user_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "friendsEditList",
    value: function friendsEditList(params) {
      var _this44 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this44);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee44() {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", _super("call").call(this, "friends.editList", params));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));
    }
    /**
     * Deletes a friend list of the current user.
     *
     * @param {{
     *   list_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "friendsDeleteList",
    value: function friendsDeleteList(params) {
      var _this45 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this45);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45() {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                return _context45.abrupt("return", _super("call").call(this, "friends.deleteList", params));

              case 1:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
    }
    /**
     * Returns a list of IDs of the current user's friends who installed the application.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetAppUsersResponse>}
     */

  }, {
    key: "friendsGetAppUsers",
    value: function friendsGetAppUsers(params) {
      var _this46 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this46);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46() {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                return _context46.abrupt("return", _super("call").call(this, "friends.getAppUsers", params));

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    }
    /**
     * Returns a list of the current user's friends whose phone numbers, validated or specified in a profile, are in a given list.
     *
     * @param {{
     *   phones: (string[]|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetByPhonesResponse>}
     */

  }, {
    key: "friendsGetByPhones",
    value: function friendsGetByPhones(params) {
      var _this47 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this47);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", _super("call").call(this, "friends.getByPhones", params));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
    }
    /**
     * Marks all incoming friend requests as viewed.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "friendsDeleteAllRequests",
    value: function friendsDeleteAllRequests(params) {
      var _this48 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this48);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                return _context48.abrupt("return", _super("call").call(this, "friends.deleteAllRequests", params));

              case 1:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    }
    /**
     * Returns a list of profiles of users whom the current user may know.
     *
     * @param {{
     *   filter: (string[]|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsGetSuggestionsResponse>}
     */

  }, {
    key: "friendsGetSuggestions",
    value: function friendsGetSuggestions(params) {
      var _this49 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this49);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49() {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", _super("call").call(this, "friends.getSuggestions", params));

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    }
    /**
     * Checks the current user's friendship status with other specified users.
     *
     * @param {{
     *   user_ids: (number[]),
     *   need_sign: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsAreFriendsResponse>}
     */

  }, {
    key: "friendsAreFriends",
    value: function friendsAreFriends(params) {
      var _this50 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this50);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee50() {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                return _context50.abrupt("return", _super("call").call(this, "friends.areFriends", params));

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));
    }
    /**
     * Returns a list of friends matching the search criteria.
     *
     * @param {{
     *   user_id: (number),
     *   q: (string|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FriendsSearchResponse>}
     */

  }, {
    key: "friendsSearch",
    value: function friendsSearch(params) {
      var _this51 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this51);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee51() {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                return _context51.abrupt("return", _super("call").call(this, "friends.search", params));

              case 1:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));
    }
    /**
     * Gets a list of comments for the page added through the [vk.com/dev/Comments|Comments widget].
     *
     * @param {{
     *   widget_api_id: (number|undefined),
     *   url: (string|undefined),
     *   page_id: (string|undefined),
     *   order: (string|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WidgetsGetCommentsResponse>}
     */

  }, {
    key: "widgetsGetComments",
    value: function widgetsGetComments(params) {
      var _this52 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this52);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee52() {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                return _context52.abrupt("return", _super("call").call(this, "widgets.getComments", params));

              case 1:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));
    }
    /**
     * Gets a list of application/site pages where the [vk.com/dev/Comments|Comments widget] or [vk.com/dev/Like|Like widget] is installed.
     *
     * @param {{
     *   widget_api_id: (number|undefined),
     *   order: (string|undefined),
     *   period: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WidgetsGetPagesResponse>}
     */

  }, {
    key: "widgetsGetPages",
    value: function widgetsGetPages(params) {
      var _this53 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this53);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee53() {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                return _context53.abrupt("return", _super("call").call(this, "widgets.getPages", params));

              case 1:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
    }
    /**
     * Allows to hide stories from chosen sources from current user's feed.
     *
     * @param {{
     *   owners_ids: (number[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "storiesBanOwner",
    value: function storiesBanOwner(params) {
      var _this54 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this54);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                return _context54.abrupt("return", _super("call").call(this, "stories.banOwner", params));

              case 1:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    }
    /**
     * Allows to delete story.
     *
     * @param {{
     *   owner_id: (number),
     *   story_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "storiesDelete",
    value: function storiesDelete(params) {
      var _this55 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this55);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee55() {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                return _context55.abrupt("return", _super("call").call(this, "stories.delete", params));

              case 1:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));
    }
    /**
     * Returns stories available for current user.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetResponse>}
     */

  }, {
    key: "storiesGet",
    value: function storiesGet(params) {
      var _this56 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this56);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee56() {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", _super("call").call(this, "stories.get", params));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));
    }
    /**
     * Returns list of sources hidden from current user's feed.
     *
     * @param {{
     *   extended: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetBannedResponse>}
     */

  }, {
    key: "storiesGetBanned",
    value: function storiesGetBanned(params) {
      var _this57 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this57);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee57() {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                return _context57.abrupt("return", _super("call").call(this, "stories.getBanned", params));

              case 1:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
    }
    /**
     * Returns story by its ID.
     *
     * @param {{
     *   stories: (string[]),
     *   extended: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetByIdResponse>}
     */

  }, {
    key: "storiesGetById",
    value: function storiesGetById(params) {
      var _this58 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this58);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee58() {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                return _context58.abrupt("return", _super("call").call(this, "stories.getById", params));

              case 1:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
    }
    /**
     * Returns URL for uploading a story with photo.
     *
     * @param {{
     *   add_to_news: (boolean|undefined),
     *   user_ids: (number[]|undefined),
     *   reply_to_story: (string|undefined),
     *   link_text: (string|undefined),
     *   link_url: (string|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetPhotoUploadServerResponse>}
     */

  }, {
    key: "storiesGetPhotoUploadServer",
    value: function storiesGetPhotoUploadServer(params) {
      var _this59 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this59);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee59() {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                return _context59.abrupt("return", _super("call").call(this, "stories.getPhotoUploadServer", params));

              case 1:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));
    }
    /**
     * Returns replies to the story.
     *
     * @param {{
     *   owner_id: (number),
     *   story_id: (number),
     *   access_key: (string|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetRepliesResponse>}
     */

  }, {
    key: "storiesGetReplies",
    value: function storiesGetReplies(params) {
      var _this60 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this60);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee60() {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                return _context60.abrupt("return", _super("call").call(this, "stories.getReplies", params));

              case 1:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));
    }
    /**
     * Returns stories available for current user.
     *
     * @param {{
     *   owner_id: (number),
     *   story_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetStatsResponse>}
     */

  }, {
    key: "storiesGetStats",
    value: function storiesGetStats(params) {
      var _this61 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this61);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee61() {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                return _context61.abrupt("return", _super("call").call(this, "stories.getStats", params));

              case 1:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));
    }
    /**
     * Allows to receive URL for uploading story with video.
     *
     * @param {{
     *   add_to_news: (boolean|undefined),
     *   user_ids: (number[]|undefined),
     *   reply_to_story: (string|undefined),
     *   link_text: (string|undefined),
     *   link_url: (string|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetVideoUploadServerResponse>}
     */

  }, {
    key: "storiesGetVideoUploadServer",
    value: function storiesGetVideoUploadServer(params) {
      var _this62 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this62);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee62() {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                return _context62.abrupt("return", _super("call").call(this, "stories.getVideoUploadServer", params));

              case 1:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));
    }
    /**
     * Returns a list of story viewers.
     *
     * @param {{
     *   owner_id: (number),
     *   story_id: (number),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StoriesGetViewersResponse>}
     */

  }, {
    key: "storiesGetViewers",
    value: function storiesGetViewers(params) {
      var _this63 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this63);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee63() {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                return _context63.abrupt("return", _super("call").call(this, "stories.getViewers", params));

              case 1:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));
    }
    /**
     * Hides all replies in the last 24 hours from the user to current user's stories.
     *
     * @param {{
     *   owner_id: (number),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "storiesHideAllReplies",
    value: function storiesHideAllReplies(params) {
      var _this64 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this64);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee64() {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                return _context64.abrupt("return", _super("call").call(this, "stories.hideAllReplies", params));

              case 1:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));
    }
    /**
     * Hides the reply to the current user's story.
     *
     * @param {{
     *   owner_id: (number),
     *   story_id: (number),
     *   access_key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "storiesHideReply",
    value: function storiesHideReply(params) {
      var _this65 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this65);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee65() {
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                return _context65.abrupt("return", _super("call").call(this, "stories.hideReply", params));

              case 1:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));
    }
    /**
     * Allows to show stories from hidden sources in current user's feed.
     *
     * @param {{
     *   owners_ids: (number[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "storiesUnbanOwner",
    value: function storiesUnbanOwner(params) {
      var _this66 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this66);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee66() {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                return _context66.abrupt("return", _super("call").call(this, "stories.unbanOwner", params));

              case 1:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));
    }
    /**
     * Returns payment balance of the application in hundredth of a vote.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SecureGetAppBalanceResponse>}
     */

  }, {
    key: "secureGetAppBalance",
    value: function secureGetAppBalance(params) {
      var _this67 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this67);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee67() {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                return _context67.abrupt("return", _super("call").call(this, "secure.getAppBalance", params));

              case 1:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));
    }
    /**
     * Shows history of votes transaction between users and the application.
     *
     * @param {{
     *   type: (number|undefined),
     *   uid_from: (number|undefined),
     *   uid_to: (number|undefined),
     *   date_from: (number|undefined),
     *   date_to: (number|undefined),
     *   limit: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SecureGetTransactionsHistoryResponse>}
     */

  }, {
    key: "secureGetTransactionsHistory",
    value: function secureGetTransactionsHistory(params) {
      var _this68 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this68);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee68() {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                return _context68.abrupt("return", _super("call").call(this, "secure.getTransactionsHistory", params));

              case 1:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));
    }
    /**
     * Shows a list of SMS notifications sent by the application using [vk.com/dev/secure.sendSMSNotification|secure.sendSMSNotification] method.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   date_from: (number|undefined),
     *   date_to: (number|undefined),
     *   limit: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SecureGetSMSHistoryResponse>}
     */

  }, {
    key: "secureGetSMSHistory",
    value: function secureGetSMSHistory(params) {
      var _this69 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this69);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee69() {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                return _context69.abrupt("return", _super("call").call(this, "secure.getSMSHistory", params));

              case 1:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));
    }
    /**
     * Sends 'SMS' notification to a user's mobile device.
     *
     * @param {{
     *   user_id: (number),
     *   message: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "secureSendSMSNotification",
    value: function secureSendSMSNotification(params) {
      var _this70 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this70);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee70() {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                return _context70.abrupt("return", _super("call").call(this, "secure.sendSMSNotification", params));

              case 1:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));
    }
    /**
     * Sends notification to the user.
     *
     * @param {{
     *   user_ids: (number[]|undefined),
     *   user_id: (number|undefined),
     *   message: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SecureSendNotificationResponse>}
     */

  }, {
    key: "secureSendNotification",
    value: function secureSendNotification(params) {
      var _this71 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this71);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee71() {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                return _context71.abrupt("return", _super("call").call(this, "secure.sendNotification", params));

              case 1:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));
    }
    /**
     * Sets a counter which is shown to the user in bold in the left menu.
     *
     * @param {{
     *   counters: (string[]|undefined),
     *   user_id: (number|undefined),
     *   counter: (number|undefined),
     *   increment: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "secureSetCounter",
    value: function secureSetCounter(params) {
      var _this72 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this72);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee72() {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                return _context72.abrupt("return", _super("call").call(this, "secure.setCounter", params));

              case 1:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));
    }
    /**
     * Returns one of the previously set game levels of one or more users in the application.
     *
     * @param {{
     *   user_ids: (number[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SecureGetUserLevelResponse>}
     */

  }, {
    key: "secureGetUserLevel",
    value: function secureGetUserLevel(params) {
      var _this73 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this73);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee73() {
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                return _context73.abrupt("return", _super("call").call(this, "secure.getUserLevel", params));

              case 1:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));
    }
    /**
     * Allows to receive data for the connection to Streaming API.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StreamingGetServerUrlResponse>}
     */

  }, {
    key: "streamingGetServerUrl",
    value: function streamingGetServerUrl(params) {
      var _this74 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this74);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee74() {
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                return _context74.abrupt("return", _super("call").call(this, "streaming.getServerUrl", params));

              case 1:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));
    }
    /**
     * Returns a value of variable with the name set by key parameter.
     *
     * @param {{
     *   key: (string|undefined),
     *   keys: (string[]|undefined),
     *   user_id: (number|undefined),
     *   global: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StorageGetResponse>}
     */

  }, {
    key: "storageGet",
    value: function storageGet(params) {
      var _this75 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this75);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee75() {
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                return _context75.abrupt("return", _super("call").call(this, "storage.get", params));

              case 1:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));
    }
    /**
     * Saves a value of variable with the name set by 'key' parameter.
     *
     * @param {{
     *   key: (string),
     *   value: (string|undefined),
     *   user_id: (number|undefined),
     *   global: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "storageSet",
    value: function storageSet(params) {
      var _this76 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this76);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee76() {
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                return _context76.abrupt("return", _super("call").call(this, "storage.set", params));

              case 1:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));
    }
    /**
     * Returns the names of all variables.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   global: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StorageGetKeysResponse>}
     */

  }, {
    key: "storageGetKeys",
    value: function storageGetKeys(params) {
      var _this77 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this77);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee77() {
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                return _context77.abrupt("return", _super("call").call(this, "storage.getKeys", params));

              case 1:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));
    }
    /**
     * Returns a list of orders.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   test_mode: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OrdersGetResponse>}
     */

  }, {
    key: "ordersGet",
    value: function ordersGet(params) {
      var _this78 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this78);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee78() {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                return _context78.abrupt("return", _super("call").call(this, "orders.get", params));

              case 1:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));
    }
    /**
     * Returns information about orders by their IDs.
     *
     * @param {{
     *   order_id: (number|undefined),
     *   order_ids: (number[]|undefined),
     *   test_mode: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OrdersGetByIdResponse>}
     */

  }, {
    key: "ordersGetById",
    value: function ordersGetById(params) {
      var _this79 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this79);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee79() {
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                return _context79.abrupt("return", _super("call").call(this, "orders.getById", params));

              case 1:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this);
      }));
    }
    /**
     * Changes order status.
     *
     * @param {{
     *   order_id: (number),
     *   action: (string),
     *   app_order_id: (number|undefined),
     *   test_mode: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OrdersChangeStateResponse>}
     */

  }, {
    key: "ordersChangeState",
    value: function ordersChangeState(params) {
      var _this80 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this80);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee80() {
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                return _context80.abrupt("return", _super("call").call(this, "orders.changeState", params));

              case 1:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   user_id: (number),
     *   votes: (string[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OrdersGetAmountResponse>}
     */

  }, {
    key: "ordersGetAmount",
    value: function ordersGetAmount(params) {
      var _this81 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this81);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee81() {
        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                return _context81.abrupt("return", _super("call").call(this, "orders.getAmount", params));

              case 1:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));
    }
    /**
     * Saves photos after successful uploading.
     *
     * @param {{
     *   album_id: (number|undefined),
     *   group_id: (number|undefined),
     *   server: (number|undefined),
     *   photos_list: (string|undefined),
     *   hash: (string|undefined),
     *   latitude: (number|undefined),
     *   longitude: (number|undefined),
     *   caption: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosSaveResponse>}
     */

  }, {
    key: "photosSave",
    value: function photosSave(params) {
      var _this82 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this82);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee82() {
        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                return _context82.abrupt("return", _super("call").call(this, "photos.save", params));

              case 1:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));
    }
    /**
     * Allows to copy a photo to the "Saved photos" album
     *
     * @param {{
     *   owner_id: (number),
     *   photo_id: (number),
     *   access_key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosCopyResponse>}
     */

  }, {
    key: "photosCopy",
    value: function photosCopy(params) {
      var _this83 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this83);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee83() {
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                return _context83.abrupt("return", _super("call").call(this, "photos.copy", params));

              case 1:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));
    }
    /**
     * Edits the caption of a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   caption: (string|undefined),
     *   latitude: (number|undefined),
     *   longitude: (number|undefined),
     *   place_str: (string|undefined),
     *   foursquare_id: (string|undefined),
     *   delete_place: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosEdit",
    value: function photosEdit(params) {
      var _this84 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this84);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee84() {
        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                return _context84.abrupt("return", _super("call").call(this, "photos.edit", params));

              case 1:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this);
      }));
    }
    /**
     * Moves a photo from one album to another.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   target_album_id: (number),
     *   photo_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosMove",
    value: function photosMove(params) {
      var _this85 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this85);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee85() {
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                return _context85.abrupt("return", _super("call").call(this, "photos.move", params));

              case 1:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this);
      }));
    }
    /**
     * Makes a photo into an album cover.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   album_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosMakeCover",
    value: function photosMakeCover(params) {
      var _this86 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this86);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee86() {
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                return _context86.abrupt("return", _super("call").call(this, "photos.makeCover", params));

              case 1:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));
    }
    /**
     * Reorders the album in the list of user albums.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   album_id: (number),
     *   before: (number|undefined),
     *   after: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosReorderAlbums",
    value: function photosReorderAlbums(params) {
      var _this87 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this87);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee87() {
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                return _context87.abrupt("return", _super("call").call(this, "photos.reorderAlbums", params));

              case 1:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));
    }
    /**
     * Reorders the photo in the list of photos of the user album.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   before: (number|undefined),
     *   after: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosReorderPhotos",
    value: function photosReorderPhotos(params) {
      var _this88 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this88);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee88() {
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                return _context88.abrupt("return", _super("call").call(this, "photos.reorderPhotos", params));

              case 1:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));
    }
    /**
     * Returns a list of photos belonging to a user or community, in reverse chronological order.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   extended: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   photo_sizes: (boolean|undefined),
     *   no_service_albums: (boolean|undefined),
     *   need_hidden: (boolean|undefined),
     *   skip_hidden: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetAllResponse>}
     */

  }, {
    key: "photosGetAll",
    value: function photosGetAll(params) {
      var _this89 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this89);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee89() {
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                return _context89.abrupt("return", _super("call").call(this, "photos.getAll", params));

              case 1:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));
    }
    /**
     * Returns a list of photos in which a user is tagged.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   sort: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetUserPhotosResponse>}
     */

  }, {
    key: "photosGetUserPhotos",
    value: function photosGetUserPhotos(params) {
      var _this90 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this90);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee90() {
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                return _context90.abrupt("return", _super("call").call(this, "photos.getUserPhotos", params));

              case 1:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));
    }
    /**
     * Deletes a photo album belonging to the current user.
     *
     * @param {{
     *   album_id: (number),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosDeleteAlbum",
    value: function photosDeleteAlbum(params) {
      var _this91 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this91);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee91() {
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                return _context91.abrupt("return", _super("call").call(this, "photos.deleteAlbum", params));

              case 1:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));
    }
    /**
     * Deletes a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosDelete",
    value: function photosDelete(params) {
      var _this92 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this92);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee92() {
        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                return _context92.abrupt("return", _super("call").call(this, "photos.delete", params));

              case 1:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this);
      }));
    }
    /**
     * Restores a deleted photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosRestore",
    value: function photosRestore(params) {
      var _this93 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this93);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee93() {
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                return _context93.abrupt("return", _super("call").call(this, "photos.restore", params));

              case 1:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));
    }
    /**
     * Confirms a tag on a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (string),
     *   tag_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosConfirmTag",
    value: function photosConfirmTag(params) {
      var _this94 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this94);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee94() {
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                return _context94.abrupt("return", _super("call").call(this, "photos.confirmTag", params));

              case 1:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this);
      }));
    }
    /**
     * Returns a list of comments on a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   need_likes: (boolean|undefined),
     *   start_comment_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   sort: (string|undefined),
     *   access_key: (string|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetCommentsResponse>}
     */

  }, {
    key: "photosGetComments",
    value: function photosGetComments(params) {
      var _this95 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this95);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee95() {
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                return _context95.abrupt("return", _super("call").call(this, "photos.getComments", params));

              case 1:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this);
      }));
    }
    /**
     * Returns a list of comments on a specific photo album or all albums of the user sorted in reverse chronological order.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   album_id: (number|undefined),
     *   need_likes: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetAllCommentsResponse>}
     */

  }, {
    key: "photosGetAllComments",
    value: function photosGetAllComments(params) {
      var _this96 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this96);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee96() {
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                return _context96.abrupt("return", _super("call").call(this, "photos.getAllComments", params));

              case 1:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));
    }
    /**
     * Adds a new comment on the photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   from_group: (boolean|undefined),
     *   reply_to_comment: (number|undefined),
     *   sticker_id: (number|undefined),
     *   access_key: (string|undefined),
     *   guid: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosCreateCommentResponse>}
     */

  }, {
    key: "photosCreateComment",
    value: function photosCreateComment(params) {
      var _this97 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this97);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee97() {
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                return _context97.abrupt("return", _super("call").call(this, "photos.createComment", params));

              case 1:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));
    }
    /**
     * Deletes a comment on the photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosDeleteCommentResponse>}
     */

  }, {
    key: "photosDeleteComment",
    value: function photosDeleteComment(params) {
      var _this98 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this98);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee98() {
        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                return _context98.abrupt("return", _super("call").call(this, "photos.deleteComment", params));

              case 1:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));
    }
    /**
     * Restores a deleted comment on a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosRestoreCommentResponse>}
     */

  }, {
    key: "photosRestoreComment",
    value: function photosRestoreComment(params) {
      var _this99 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this99);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee99() {
        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                return _context99.abrupt("return", _super("call").call(this, "photos.restoreComment", params));

              case 1:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));
    }
    /**
     * Edits a comment on a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosEditComment",
    value: function photosEditComment(params) {
      var _this100 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this100);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee100() {
        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                return _context100.abrupt("return", _super("call").call(this, "photos.editComment", params));

              case 1:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this);
      }));
    }
    /**
     * Returns a list of tags on a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   access_key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetTagsResponse>}
     */

  }, {
    key: "photosGetTags",
    value: function photosGetTags(params) {
      var _this101 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this101);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee101() {
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                return _context101.abrupt("return", _super("call").call(this, "photos.getTags", params));

              case 1:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));
    }
    /**
     * Adds a tag on the photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   user_id: (number),
     *   x: (number|undefined),
     *   y: (number|undefined),
     *   x2: (number|undefined),
     *   y2: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosPutTagResponse>}
     */

  }, {
    key: "photosPutTag",
    value: function photosPutTag(params) {
      var _this102 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this102);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee102() {
        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                return _context102.abrupt("return", _super("call").call(this, "photos.putTag", params));

              case 1:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));
    }
    /**
     * Removes a tag from a photo.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   photo_id: (number),
     *   tag_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "photosRemoveTag",
    value: function photosRemoveTag(params) {
      var _this103 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this103);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee103() {
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                return _context103.abrupt("return", _super("call").call(this, "photos.removeTag", params));

              case 1:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));
    }
    /**
     * Returns a list of photos with tags that have not been viewed.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PhotosGetNewTagsResponse>}
     */

  }, {
    key: "photosGetNewTags",
    value: function photosGetNewTags(params) {
      var _this104 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this104);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee104() {
        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                return _context104.abrupt("return", _super("call").call(this, "photos.getNewTags", params));

              case 1:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));
    }
    /**
     * Returns a list of posts from user or community walls by their IDs.
     *
     * @param {{
     *   posts: (string[]),
     *   extended: (boolean|undefined),
     *   copy_history_depth: (number|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallGetByIdResponse>}
     */

  }, {
    key: "wallGetById",
    value: function wallGetById(params) {
      var _this105 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this105);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee105() {
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                return _context105.abrupt("return", _super("call").call(this, "wall.getById", params));

              case 1:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this);
      }));
    }
    /**
     * Adds a new post on a user wall or community wall. Can also be used to publish suggested or scheduled posts.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   friends_only: (boolean|undefined),
     *   from_group: (boolean|undefined),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   services: (string|undefined),
     *   signed: (boolean|undefined),
     *   publish_date: (number|undefined),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   place_id: (number|undefined),
     *   post_id: (number|undefined),
     *   guid: (string|undefined),
     *   mark_as_ads: (boolean|undefined),
     *   close_comments: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallPostResponse>}
     */

  }, {
    key: "wallPost",
    value: function wallPost(params) {
      var _this106 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this106);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee106() {
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                return _context106.abrupt("return", _super("call").call(this, "wall.post", params));

              case 1:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));
    }
    /**
     * Allows to create hidden post which will not be shown on the community's wall and can be used for creating an ad with type "Community post".
     *
     * @param {{
     *   owner_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   signed: (boolean|undefined),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   place_id: (number|undefined),
     *   guid: (string|undefined),
     *   link_button: (string|undefined),
     *   link_title: (string|undefined),
     *   link_image: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallPostAdsStealthResponse>}
     */

  }, {
    key: "wallPostAdsStealth",
    value: function wallPostAdsStealth(params) {
      var _this107 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this107);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee107() {
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                return _context107.abrupt("return", _super("call").call(this, "wall.postAdsStealth", params));

              case 1:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));
    }
    /**
     * Reposts (copies) an object to a user wall or community wall.
     *
     * @param {{
     *   object: (string),
     *   message: (string|undefined),
     *   group_id: (number|undefined),
     *   mark_as_ads: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallRepostResponse>}
     */

  }, {
    key: "wallRepost",
    value: function wallRepost(params) {
      var _this108 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this108);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee108() {
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                return _context108.abrupt("return", _super("call").call(this, "wall.repost", params));

              case 1:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));
    }
    /**
     * Returns information about reposts of a post on user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallGetRepostsResponse>}
     */

  }, {
    key: "wallGetReposts",
    value: function wallGetReposts(params) {
      var _this109 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this109);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee109() {
        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                return _context109.abrupt("return", _super("call").call(this, "wall.getReposts", params));

              case 1:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));
    }
    /**
     * Edits a post on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number),
     *   friends_only: (boolean|undefined),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   services: (string|undefined),
     *   signed: (boolean|undefined),
     *   publish_date: (number|undefined),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   place_id: (number|undefined),
     *   mark_as_ads: (boolean|undefined),
     *   close_comments: (boolean|undefined),
     *   poster_bkg_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallEdit",
    value: function wallEdit(params) {
      var _this110 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this110);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee110() {
        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                return _context110.abrupt("return", _super("call").call(this, "wall.edit", params));

              case 1:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));
    }
    /**
     * Allows to edit hidden post.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   signed: (boolean|undefined),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   place_id: (number|undefined),
     *   link_button: (string|undefined),
     *   link_title: (string|undefined),
     *   link_image: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallEditAdsStealth",
    value: function wallEditAdsStealth(params) {
      var _this111 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this111);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee111() {
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                return _context111.abrupt("return", _super("call").call(this, "wall.editAdsStealth", params));

              case 1:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));
    }
    /**
     * Deletes a post from a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallDelete",
    value: function wallDelete(params) {
      var _this112 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this112);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee112() {
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                return _context112.abrupt("return", _super("call").call(this, "wall.delete", params));

              case 1:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));
    }
    /**
     * Restores a post deleted from a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallRestore",
    value: function wallRestore(params) {
      var _this113 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this113);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee113() {
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                return _context113.abrupt("return", _super("call").call(this, "wall.restore", params));

              case 1:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));
    }
    /**
     * Pins the post on wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallPin",
    value: function wallPin(params) {
      var _this114 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this114);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee114() {
        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                return _context114.abrupt("return", _super("call").call(this, "wall.pin", params));

              case 1:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this);
      }));
    }
    /**
     * Unpins the post on wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallUnpin",
    value: function wallUnpin(params) {
      var _this115 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this115);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee115() {
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                return _context115.abrupt("return", _super("call").call(this, "wall.unpin", params));

              case 1:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, this);
      }));
    }
    /**
     * Returns a list of comments on a post on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number|undefined),
     *   need_likes: (boolean|undefined),
     *   start_comment_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   sort: (string|undefined),
     *   preview_length: (number|undefined),
     *   extended: (boolean|undefined),
     *   fields: (string[]|undefined),
     *   comment_id: (number|undefined),
     *   thread_items_count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallGetCommentsResponse>}
     */

  }, {
    key: "wallGetComments",
    value: function wallGetComments(params) {
      var _this116 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this116);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee116() {
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                return _context116.abrupt("return", _super("call").call(this, "wall.getComments", params));

              case 1:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, this);
      }));
    }
    /**
     * Adds a comment to a post on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   post_id: (number),
     *   from_group: (number|undefined),
     *   message: (string|undefined),
     *   reply_to_comment: (number|undefined),
     *   attachments: (string[]|undefined),
     *   sticker_id: (number|undefined),
     *   guid: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.WallCreateCommentResponse>}
     */

  }, {
    key: "wallCreateComment",
    value: function wallCreateComment(params) {
      var _this117 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this117);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee117() {
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                return _context117.abrupt("return", _super("call").call(this, "wall.createComment", params));

              case 1:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, this);
      }));
    }
    /**
     * Edits a comment on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallEditComment",
    value: function wallEditComment(params) {
      var _this118 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this118);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee118() {
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                return _context118.abrupt("return", _super("call").call(this, "wall.editComment", params));

              case 1:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, this);
      }));
    }
    /**
     * Deletes a comment on a post on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallDeleteComment",
    value: function wallDeleteComment(params) {
      var _this119 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this119);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee119() {
        return _regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                return _context119.abrupt("return", _super("call").call(this, "wall.deleteComment", params));

              case 1:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119, this);
      }));
    }
    /**
     * Restores a comment deleted from a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallRestoreComment",
    value: function wallRestoreComment(params) {
      var _this120 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this120);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee120() {
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                return _context120.abrupt("return", _super("call").call(this, "wall.restoreComment", params));

              case 1:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, this);
      }));
    }
    /**
     * Reports (submits a complaint about) a post on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number),
     *   post_id: (number),
     *   reason: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallReportPost",
    value: function wallReportPost(params) {
      var _this121 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this121);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee121() {
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                return _context121.abrupt("return", _super("call").call(this, "wall.reportPost", params));

              case 1:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));
    }
    /**
     * Reports (submits a complaint about) a comment on a post on a user wall or community wall.
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   reason: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "wallReportComment",
    value: function wallReportComment(params) {
      var _this122 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this122);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee122() {
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                return _context122.abrupt("return", _super("call").call(this, "wall.reportComment", params));

              case 1:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122, this);
      }));
    }
    /**
     * Returns data required to show the status of a user or community.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StatusGetResponse>}
     */

  }, {
    key: "statusGet",
    value: function statusGet(params) {
      var _this123 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this123);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee123() {
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                return _context123.abrupt("return", _super("call").call(this, "status.get", params));

              case 1:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, this);
      }));
    }
    /**
     * Sets a new status for the current user.
     *
     * @param {{
     *   text: (string|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "statusSet",
    value: function statusSet(params) {
      var _this124 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this124);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee124() {
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                return _context124.abrupt("return", _super("call").call(this, "status.set", params));

              case 1:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124, this);
      }));
    }
    /**
     * Completes the lead started by user.
     *
     * @param {{
     *   vk_sid: (string),
     *   secret: (string),
     *   comment: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LeadsCompleteResponse>}
     */

  }, {
    key: "leadsComplete",
    value: function leadsComplete(params) {
      var _this125 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this125);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee125() {
        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                return _context125.abrupt("return", _super("call").call(this, "leads.complete", params));

              case 1:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125, this);
      }));
    }
    /**
     * Creates new session for the user passing the offer.
     *
     * @param {{
     *   lead_id: (number),
     *   secret: (string),
     *   uid: (number|undefined),
     *   aid: (number|undefined),
     *   test_mode: (boolean|undefined),
     *   force: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LeadsStartResponse>}
     */

  }, {
    key: "leadsStart",
    value: function leadsStart(params) {
      var _this126 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this126);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee126() {
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                return _context126.abrupt("return", _super("call").call(this, "leads.start", params));

              case 1:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126, this);
      }));
    }
    /**
     * Returns lead stats data.
     *
     * @param {{
     *   lead_id: (number),
     *   secret: (string|undefined),
     *   date_start: (string|undefined),
     *   date_end: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LeadsGetStatsResponse>}
     */

  }, {
    key: "leadsGetStats",
    value: function leadsGetStats(params) {
      var _this127 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this127);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee127() {
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                return _context127.abrupt("return", _super("call").call(this, "leads.getStats", params));

              case 1:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, this);
      }));
    }
    /**
     * Returns a list of last user actions for the offer.
     *
     * @param {{
     *   offer_id: (number),
     *   secret: (string),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   status: (number|undefined),
     *   reverse: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LeadsGetUsersResponse>}
     */

  }, {
    key: "leadsGetUsers",
    value: function leadsGetUsers(params) {
      var _this128 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this128);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee128() {
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                return _context128.abrupt("return", _super("call").call(this, "leads.getUsers", params));

              case 1:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, this);
      }));
    }
    /**
     * Checks if the user can start the lead.
     *
     * @param {{
     *   lead_id: (number),
     *   test_result: (number|undefined),
     *   test_mode: (boolean|undefined),
     *   auto_start: (boolean|undefined),
     *   age: (number|undefined),
     *   country: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LeadsCheckUserResponse>}
     */

  }, {
    key: "leadsCheckUser",
    value: function leadsCheckUser(params) {
      var _this129 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this129);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee129() {
        return _regeneratorRuntime.wrap(function _callee129$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                return _context129.abrupt("return", _super("call").call(this, "leads.checkUser", params));

              case 1:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee129, this);
      }));
    }
    /**
     * Counts the metric event.
     *
     * @param {{
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LeadsMetricHitResponse>}
     */

  }, {
    key: "leadsMetricHit",
    value: function leadsMetricHit(params) {
      var _this130 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this130);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee130() {
        return _regeneratorRuntime.wrap(function _callee130$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                return _context130.abrupt("return", _super("call").call(this, "leads.metricHit", params));

              case 1:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee130, this);
      }));
    }
    /**
     * Returns information about a wiki page.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   page_id: (number|undefined),
     *   global: (boolean|undefined),
     *   site_preview: (boolean|undefined),
     *   title: (string|undefined),
     *   need_source: (boolean|undefined),
     *   need_html: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesGetResponse>}
     */

  }, {
    key: "pagesGet",
    value: function pagesGet(params) {
      var _this131 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this131);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee131() {
        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                return _context131.abrupt("return", _super("call").call(this, "pages.get", params));

              case 1:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, this);
      }));
    }
    /**
     * Saves the text of a wiki page.
     *
     * @param {{
     *   text: (string|undefined),
     *   page_id: (number|undefined),
     *   group_id: (number|undefined),
     *   user_id: (number|undefined),
     *   title: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesSaveResponse>}
     */

  }, {
    key: "pagesSave",
    value: function pagesSave(params) {
      var _this132 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this132);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee132() {
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                return _context132.abrupt("return", _super("call").call(this, "pages.save", params));

              case 1:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132, this);
      }));
    }
    /**
     * Saves modified read and edit access settings for a wiki page.
     *
     * @param {{
     *   page_id: (number),
     *   group_id: (number|undefined),
     *   user_id: (number|undefined),
     *   view: (number|undefined),
     *   edit: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesSaveAccessResponse>}
     */

  }, {
    key: "pagesSaveAccess",
    value: function pagesSaveAccess(params) {
      var _this133 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this133);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee133() {
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                return _context133.abrupt("return", _super("call").call(this, "pages.saveAccess", params));

              case 1:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133, this);
      }));
    }
    /**
     * Returns a list of all previous versions of a wiki page.
     *
     * @param {{
     *   page_id: (number),
     *   group_id: (number|undefined),
     *   user_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesGetHistoryResponse>}
     */

  }, {
    key: "pagesGetHistory",
    value: function pagesGetHistory(params) {
      var _this134 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this134);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee134() {
        return _regeneratorRuntime.wrap(function _callee134$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                return _context134.abrupt("return", _super("call").call(this, "pages.getHistory", params));

              case 1:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee134, this);
      }));
    }
    /**
     * Returns a list of wiki pages in a group.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesGetTitlesResponse>}
     */

  }, {
    key: "pagesGetTitles",
    value: function pagesGetTitles(params) {
      var _this135 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this135);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee135() {
        return _regeneratorRuntime.wrap(function _callee135$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                return _context135.abrupt("return", _super("call").call(this, "pages.getTitles", params));

              case 1:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee135, this);
      }));
    }
    /**
     * Returns the text of one of the previous versions of a wiki page.
     *
     * @param {{
     *   version_id: (number),
     *   group_id: (number|undefined),
     *   user_id: (number|undefined),
     *   need_html: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesGetVersionResponse>}
     */

  }, {
    key: "pagesGetVersion",
    value: function pagesGetVersion(params) {
      var _this136 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this136);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee136() {
        return _regeneratorRuntime.wrap(function _callee136$(_context136) {
          while (1) {
            switch (_context136.prev = _context136.next) {
              case 0:
                return _context136.abrupt("return", _super("call").call(this, "pages.getVersion", params));

              case 1:
              case "end":
                return _context136.stop();
            }
          }
        }, _callee136, this);
      }));
    }
    /**
     * Returns HTML representation of the wiki markup.
     *
     * @param {{
     *   text: (string),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PagesParseWikiResponse>}
     */

  }, {
    key: "pagesParseWiki",
    value: function pagesParseWiki(params) {
      var _this137 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this137);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee137() {
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                return _context137.abrupt("return", _super("call").call(this, "pages.parseWiki", params));

              case 1:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137, this);
      }));
    }
    /**
     * Allows to clear the cache of particular 'external' pages which may be attached to VK posts.
     *
     * @param {{
     *   url: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "pagesClearCache",
    value: function pagesClearCache(params) {
      var _this138 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this138);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee138() {
        return _regeneratorRuntime.wrap(function _callee138$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                return _context138.abrupt("return", _super("call").call(this, "pages.clearCache", params));

              case 1:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee138, this);
      }));
    }
    /**
     * Returns information specifying whether a user is a member of a community.
     *
     * @param {{
     *   group_id: (string),
     *   user_id: (number|undefined),
     *   user_ids: (number[]|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsIsMemberResponse>}
     */

  }, {
    key: "groupsIsMember",
    value: function groupsIsMember(params) {
      var _this139 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this139);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee139() {
        return _regeneratorRuntime.wrap(function _callee139$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                return _context139.abrupt("return", _super("call").call(this, "groups.isMember", params));

              case 1:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee139, this);
      }));
    }
    /**
     * Returns information about communities by their IDs.
     *
     * @param {{
     *   group_ids: (string[]|undefined),
     *   group_id: (string|undefined),
     *   fields: (Models.GroupsFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetByIdResponse>}
     */

  }, {
    key: "groupsGetById",
    value: function groupsGetById(params) {
      var _this140 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this140);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee140() {
        return _regeneratorRuntime.wrap(function _callee140$(_context140) {
          while (1) {
            switch (_context140.prev = _context140.next) {
              case 0:
                return _context140.abrupt("return", _super("call").call(this, "groups.getById", params));

              case 1:
              case "end":
                return _context140.stop();
            }
          }
        }, _callee140, this);
      }));
    }
    /**
     * Returns a list of the communities to which a user belongs.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   extended: (boolean|undefined),
     *   filter: (Models.GroupsFilter[]|undefined),
     *   fields: (Models.GroupsFields[]|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetResponse>}
     */

  }, {
    key: "groupsGet",
    value: function groupsGet(params) {
      var _this141 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this141);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee141() {
        return _regeneratorRuntime.wrap(function _callee141$(_context141) {
          while (1) {
            switch (_context141.prev = _context141.next) {
              case 0:
                return _context141.abrupt("return", _super("call").call(this, "groups.get", params));

              case 1:
              case "end":
                return _context141.stop();
            }
          }
        }, _callee141, this);
      }));
    }
    /**
     * Returns a list of community members.
     *
     * @param {{
     *   group_id: (string|undefined),
     *   sort: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   filter: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetMembersResponse>}
     */

  }, {
    key: "groupsGetMembers",
    value: function groupsGetMembers(params) {
      var _this142 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this142);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee142() {
        return _regeneratorRuntime.wrap(function _callee142$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                return _context142.abrupt("return", _super("call").call(this, "groups.getMembers", params));

              case 1:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee142, this);
      }));
    }
    /**
     * With this method you can join the group or public page, and also confirm your participation in an event.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   not_sure: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsJoin",
    value: function groupsJoin(params) {
      var _this143 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this143);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee143() {
        return _regeneratorRuntime.wrap(function _callee143$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                return _context143.abrupt("return", _super("call").call(this, "groups.join", params));

              case 1:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee143, this);
      }));
    }
    /**
     * With this method you can leave a group, public page, or event.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsLeave",
    value: function groupsLeave(params) {
      var _this144 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this144);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee144() {
        return _regeneratorRuntime.wrap(function _callee144$(_context144) {
          while (1) {
            switch (_context144.prev = _context144.next) {
              case 0:
                return _context144.abrupt("return", _super("call").call(this, "groups.leave", params));

              case 1:
              case "end":
                return _context144.stop();
            }
          }
        }, _callee144, this);
      }));
    }
    /**
     * Returns a list of communities matching the search criteria.
     *
     * @param {{
     *   q: (string),
     *   type: (string|undefined),
     *   country_id: (number|undefined),
     *   city_id: (number|undefined),
     *   future: (boolean|undefined),
     *   market: (boolean|undefined),
     *   sort: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsSearchResponse>}
     */

  }, {
    key: "groupsSearch",
    value: function groupsSearch(params) {
      var _this145 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this145);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee145() {
        return _regeneratorRuntime.wrap(function _callee145$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                return _context145.abrupt("return", _super("call").call(this, "groups.search", params));

              case 1:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee145, this);
      }));
    }
    /**
     * Returns communities list for a catalog category.
     *
     * @param {{
     *   category_id: (number|undefined),
     *   subcategory_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetCatalogResponse>}
     */

  }, {
    key: "groupsGetCatalog",
    value: function groupsGetCatalog(params) {
      var _this146 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this146);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee146() {
        return _regeneratorRuntime.wrap(function _callee146$(_context146) {
          while (1) {
            switch (_context146.prev = _context146.next) {
              case 0:
                return _context146.abrupt("return", _super("call").call(this, "groups.getCatalog", params));

              case 1:
              case "end":
                return _context146.stop();
            }
          }
        }, _callee146, this);
      }));
    }
    /**
     * Returns categories list for communities catalog
     *
     * @param {{
     *   extended: (boolean|undefined),
     *   subcategories: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetCatalogInfoResponse>}
     */

  }, {
    key: "groupsGetCatalogInfo",
    value: function groupsGetCatalogInfo(params) {
      var _this147 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this147);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee147() {
        return _regeneratorRuntime.wrap(function _callee147$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                return _context147.abrupt("return", _super("call").call(this, "groups.getCatalogInfo", params));

              case 1:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee147, this);
      }));
    }
    /**
     * Returns a list of invitations to join communities and events.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetInvitesResponse>}
     */

  }, {
    key: "groupsGetInvites",
    value: function groupsGetInvites(params) {
      var _this148 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this148);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee148() {
        return _regeneratorRuntime.wrap(function _callee148$(_context148) {
          while (1) {
            switch (_context148.prev = _context148.next) {
              case 0:
                return _context148.abrupt("return", _super("call").call(this, "groups.getInvites", params));

              case 1:
              case "end":
                return _context148.stop();
            }
          }
        }, _callee148, this);
      }));
    }
    /**
     * Returns invited users list of a community
     *
     * @param {{
     *   group_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetInvitedUsersResponse>}
     */

  }, {
    key: "groupsGetInvitedUsers",
    value: function groupsGetInvitedUsers(params) {
      var _this149 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this149);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee149() {
        return _regeneratorRuntime.wrap(function _callee149$(_context149) {
          while (1) {
            switch (_context149.prev = _context149.next) {
              case 0:
                return _context149.abrupt("return", _super("call").call(this, "groups.getInvitedUsers", params));

              case 1:
              case "end":
                return _context149.stop();
            }
          }
        }, _callee149, this);
      }));
    }
    /**
     * Returns a list of users on a community blacklist.
     *
     * @param {{
     *   group_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetBannedResponse>}
     */

  }, {
    key: "groupsGetBanned",
    value: function groupsGetBanned(params) {
      var _this150 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this150);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee150() {
        return _regeneratorRuntime.wrap(function _callee150$(_context150) {
          while (1) {
            switch (_context150.prev = _context150.next) {
              case 0:
                return _context150.abrupt("return", _super("call").call(this, "groups.getBanned", params));

              case 1:
              case "end":
                return _context150.stop();
            }
          }
        }, _callee150, this);
      }));
    }
    /**
     * Creates a new community.
     *
     * @param {{
     *   title: (string),
     *   description: (string|undefined),
     *   type: (string|undefined),
     *   public_category: (number|undefined),
     *   subtype: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsCreateResponse>}
     */

  }, {
    key: "groupsCreate",
    value: function groupsCreate(params) {
      var _this151 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this151);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee151() {
        return _regeneratorRuntime.wrap(function _callee151$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                return _context151.abrupt("return", _super("call").call(this, "groups.create", params));

              case 1:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee151, this);
      }));
    }
    /**
     * Edits a community.
     *
     * @param {{
     *   group_id: (number),
     *   title: (string|undefined),
     *   description: (string|undefined),
     *   screen_name: (string|undefined),
     *   access: (number|undefined),
     *   website: (string|undefined),
     *   subject: (string|undefined),
     *   email: (string|undefined),
     *   phone: (string|undefined),
     *   rss: (string|undefined),
     *   event_start_date: (number|undefined),
     *   event_finish_date: (number|undefined),
     *   event_group_id: (number|undefined),
     *   public_category: (number|undefined),
     *   public_subcategory: (number|undefined),
     *   public_date: (string|undefined),
     *   wall: (number|undefined),
     *   topics: (number|undefined),
     *   photos: (number|undefined),
     *   video: (number|undefined),
     *   audio: (number|undefined),
     *   links: (boolean|undefined),
     *   events: (boolean|undefined),
     *   places: (boolean|undefined),
     *   contacts: (boolean|undefined),
     *   docs: (number|undefined),
     *   wiki: (number|undefined),
     *   messages: (boolean|undefined),
     *   articles: (boolean|undefined),
     *   addresses: (boolean|undefined),
     *   age_limits: (number|undefined),
     *   market: (boolean|undefined),
     *   market_comments: (boolean|undefined),
     *   market_country: (number[]|undefined),
     *   market_city: (number[]|undefined),
     *   market_currency: (number|undefined),
     *   market_contact: (number|undefined),
     *   market_wiki: (number|undefined),
     *   obscene_filter: (boolean|undefined),
     *   obscene_stopwords: (boolean|undefined),
     *   obscene_words: (string[]|undefined),
     *   main_section: (number|undefined),
     *   secondary_section: (number|undefined),
     *   country: (number|undefined),
     *   city: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsEdit",
    value: function groupsEdit(params) {
      var _this152 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this152);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee152() {
        return _regeneratorRuntime.wrap(function _callee152$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                return _context152.abrupt("return", _super("call").call(this, "groups.edit", params));

              case 1:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee152, this);
      }));
    }
    /**
     * Returns community settings.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetSettingsResponse>}
     */

  }, {
    key: "groupsGetSettings",
    value: function groupsGetSettings(params) {
      var _this153 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this153);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee153() {
        return _regeneratorRuntime.wrap(function _callee153$(_context153) {
          while (1) {
            switch (_context153.prev = _context153.next) {
              case 0:
                return _context153.abrupt("return", _super("call").call(this, "groups.getSettings", params));

              case 1:
              case "end":
                return _context153.stop();
            }
          }
        }, _callee153, this);
      }));
    }
    /**
     * Returns a list of requests to the community.
     *
     * @param {{
     *   group_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetRequestsResponse>}
     */

  }, {
    key: "groupsGetRequests",
    value: function groupsGetRequests(params) {
      var _this154 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this154);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee154() {
        return _regeneratorRuntime.wrap(function _callee154$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                return _context154.abrupt("return", _super("call").call(this, "groups.getRequests", params));

              case 1:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee154, this);
      }));
    }
    /**
     * Allows to add, remove or edit the community manager.
     *
     * @param {{
     *   group_id: (number),
     *   user_id: (number),
     *   role: (string|undefined),
     *   is_contact: (boolean|undefined),
     *   contact_position: (string|undefined),
     *   contact_phone: (string|undefined),
     *   contact_email: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsEditManager",
    value: function groupsEditManager(params) {
      var _this155 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this155);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee155() {
        return _regeneratorRuntime.wrap(function _callee155$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                return _context155.abrupt("return", _super("call").call(this, "groups.editManager", params));

              case 1:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee155, this);
      }));
    }
    /**
     * Allows to invite friends to the community.
     *
     * @param {{
     *   group_id: (number),
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsInvite",
    value: function groupsInvite(params) {
      var _this156 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this156);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee156() {
        return _regeneratorRuntime.wrap(function _callee156$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                return _context156.abrupt("return", _super("call").call(this, "groups.invite", params));

              case 1:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee156, this);
      }));
    }
    /**
     * Allows to add a link to the community.
     *
     * @param {{
     *   group_id: (number),
     *   link: (string),
     *   text: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsAddLinkResponse>}
     */

  }, {
    key: "groupsAddLink",
    value: function groupsAddLink(params) {
      var _this157 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this157);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee157() {
        return _regeneratorRuntime.wrap(function _callee157$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                return _context157.abrupt("return", _super("call").call(this, "groups.addLink", params));

              case 1:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee157, this);
      }));
    }
    /**
     * Allows to delete a link from the community.
     *
     * @param {{
     *   group_id: (number),
     *   link_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsDeleteLink",
    value: function groupsDeleteLink(params) {
      var _this158 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this158);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee158() {
        return _regeneratorRuntime.wrap(function _callee158$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                return _context158.abrupt("return", _super("call").call(this, "groups.deleteLink", params));

              case 1:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee158, this);
      }));
    }
    /**
     * Allows to edit a link in the community.
     *
     * @param {{
     *   group_id: (number),
     *   link_id: (number),
     *   text: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsEditLink",
    value: function groupsEditLink(params) {
      var _this159 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this159);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee159() {
        return _regeneratorRuntime.wrap(function _callee159$(_context159) {
          while (1) {
            switch (_context159.prev = _context159.next) {
              case 0:
                return _context159.abrupt("return", _super("call").call(this, "groups.editLink", params));

              case 1:
              case "end":
                return _context159.stop();
            }
          }
        }, _callee159, this);
      }));
    }
    /**
     * Allows to reorder links in the community.
     *
     * @param {{
     *   group_id: (number),
     *   link_id: (number),
     *   after: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsReorderLink",
    value: function groupsReorderLink(params) {
      var _this160 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this160);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee160() {
        return _regeneratorRuntime.wrap(function _callee160$(_context160) {
          while (1) {
            switch (_context160.prev = _context160.next) {
              case 0:
                return _context160.abrupt("return", _super("call").call(this, "groups.reorderLink", params));

              case 1:
              case "end":
                return _context160.stop();
            }
          }
        }, _callee160, this);
      }));
    }
    /**
     * Removes a user from the community.
     *
     * @param {{
     *   group_id: (number),
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsRemoveUser",
    value: function groupsRemoveUser(params) {
      var _this161 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this161);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee161() {
        return _regeneratorRuntime.wrap(function _callee161$(_context161) {
          while (1) {
            switch (_context161.prev = _context161.next) {
              case 0:
                return _context161.abrupt("return", _super("call").call(this, "groups.removeUser", params));

              case 1:
              case "end":
                return _context161.stop();
            }
          }
        }, _callee161, this);
      }));
    }
    /**
     * Allows to approve join request to the community.
     *
     * @param {{
     *   group_id: (number),
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsApproveRequest",
    value: function groupsApproveRequest(params) {
      var _this162 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this162);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee162() {
        return _regeneratorRuntime.wrap(function _callee162$(_context162) {
          while (1) {
            switch (_context162.prev = _context162.next) {
              case 0:
                return _context162.abrupt("return", _super("call").call(this, "groups.approveRequest", params));

              case 1:
              case "end":
                return _context162.stop();
            }
          }
        }, _callee162, this);
      }));
    }
    /**
     * Returns Callback API confirmation code for the community.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetCallbackConfirmationCodeResponse>}
     */

  }, {
    key: "groupsGetCallbackConfirmationCode",
    value: function groupsGetCallbackConfirmationCode(params) {
      var _this163 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this163);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee163() {
        return _regeneratorRuntime.wrap(function _callee163$(_context163) {
          while (1) {
            switch (_context163.prev = _context163.next) {
              case 0:
                return _context163.abrupt("return", _super("call").call(this, "groups.getCallbackConfirmationCode", params));

              case 1:
              case "end":
                return _context163.stop();
            }
          }
        }, _callee163, this);
      }));
    }
    /**
     * Returns [vk.com/dev/callback_api|Callback API] notifications settings.
     *
     * @param {{
     *   group_id: (number),
     *   server_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetCallbackSettingsResponse>}
     */

  }, {
    key: "groupsGetCallbackSettings",
    value: function groupsGetCallbackSettings(params) {
      var _this164 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this164);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee164() {
        return _regeneratorRuntime.wrap(function _callee164$(_context164) {
          while (1) {
            switch (_context164.prev = _context164.next) {
              case 0:
                return _context164.abrupt("return", _super("call").call(this, "groups.getCallbackSettings", params));

              case 1:
              case "end":
                return _context164.stop();
            }
          }
        }, _callee164, this);
      }));
    }
    /**
     * Allow to set notifications settings for group.
     *
     * @param {{
     *   group_id: (number),
     *   server_id: (number|undefined),
     *   api_version: (string|undefined),
     *   message_new: (boolean|undefined),
     *   message_reply: (boolean|undefined),
     *   message_allow: (boolean|undefined),
     *   message_deny: (boolean|undefined),
     *   message_typing_state: (boolean|undefined),
     *   photo_new: (boolean|undefined),
     *   audio_new: (boolean|undefined),
     *   video_new: (boolean|undefined),
     *   wall_reply_new: (boolean|undefined),
     *   wall_reply_edit: (boolean|undefined),
     *   wall_reply_delete: (boolean|undefined),
     *   wall_reply_restore: (boolean|undefined),
     *   wall_post_new: (boolean|undefined),
     *   wall_repost: (boolean|undefined),
     *   board_post_new: (boolean|undefined),
     *   board_post_edit: (boolean|undefined),
     *   board_post_restore: (boolean|undefined),
     *   board_post_delete: (boolean|undefined),
     *   photo_comment_new: (boolean|undefined),
     *   photo_comment_edit: (boolean|undefined),
     *   photo_comment_delete: (boolean|undefined),
     *   photo_comment_restore: (boolean|undefined),
     *   video_comment_new: (boolean|undefined),
     *   video_comment_edit: (boolean|undefined),
     *   video_comment_delete: (boolean|undefined),
     *   video_comment_restore: (boolean|undefined),
     *   market_comment_new: (boolean|undefined),
     *   market_comment_edit: (boolean|undefined),
     *   market_comment_delete: (boolean|undefined),
     *   market_comment_restore: (boolean|undefined),
     *   poll_vote_new: (boolean|undefined),
     *   group_join: (boolean|undefined),
     *   group_leave: (boolean|undefined),
     *   group_change_settings: (boolean|undefined),
     *   group_change_photo: (boolean|undefined),
     *   group_officers_edit: (boolean|undefined),
     *   user_block: (boolean|undefined),
     *   user_unblock: (boolean|undefined),
     *   lead_forms_new: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsSetCallbackSettings",
    value: function groupsSetCallbackSettings(params) {
      var _this165 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this165);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee165() {
        return _regeneratorRuntime.wrap(function _callee165$(_context165) {
          while (1) {
            switch (_context165.prev = _context165.next) {
              case 0:
                return _context165.abrupt("return", _super("call").call(this, "groups.setCallbackSettings", params));

              case 1:
              case "end":
                return _context165.stop();
            }
          }
        }, _callee165, this);
      }));
    }
    /**
     * Returns the data needed to query a Long Poll server for events
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetLongPollServerResponse>}
     */

  }, {
    key: "groupsGetLongPollServer",
    value: function groupsGetLongPollServer(params) {
      var _this166 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this166);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee166() {
        return _regeneratorRuntime.wrap(function _callee166$(_context166) {
          while (1) {
            switch (_context166.prev = _context166.next) {
              case 0:
                return _context166.abrupt("return", _super("call").call(this, "groups.getLongPollServer", params));

              case 1:
              case "end":
                return _context166.stop();
            }
          }
        }, _callee166, this);
      }));
    }
    /**
     * Returns Long Poll notification settings
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetLongPollSettingsResponse>}
     */

  }, {
    key: "groupsGetLongPollSettings",
    value: function groupsGetLongPollSettings(params) {
      var _this167 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this167);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee167() {
        return _regeneratorRuntime.wrap(function _callee167$(_context167) {
          while (1) {
            switch (_context167.prev = _context167.next) {
              case 0:
                return _context167.abrupt("return", _super("call").call(this, "groups.getLongPollSettings", params));

              case 1:
              case "end":
                return _context167.stop();
            }
          }
        }, _callee167, this);
      }));
    }
    /**
     * Sets Long Poll notification settings
     *
     * @param {{
     *   group_id: (number),
     *   enabled: (boolean|undefined),
     *   message_new: (boolean|undefined),
     *   message_reply: (boolean|undefined),
     *   message_allow: (boolean|undefined),
     *   message_deny: (boolean|undefined),
     *   message_edit: (boolean|undefined),
     *   message_typing_state: (boolean|undefined),
     *   photo_new: (boolean|undefined),
     *   audio_new: (boolean|undefined),
     *   video_new: (boolean|undefined),
     *   wall_reply_new: (boolean|undefined),
     *   wall_reply_edit: (boolean|undefined),
     *   wall_reply_delete: (boolean|undefined),
     *   wall_reply_restore: (boolean|undefined),
     *   wall_post_new: (boolean|undefined),
     *   wall_repost: (boolean|undefined),
     *   board_post_new: (boolean|undefined),
     *   board_post_edit: (boolean|undefined),
     *   board_post_restore: (boolean|undefined),
     *   board_post_delete: (boolean|undefined),
     *   photo_comment_new: (boolean|undefined),
     *   photo_comment_edit: (boolean|undefined),
     *   photo_comment_delete: (boolean|undefined),
     *   photo_comment_restore: (boolean|undefined),
     *   video_comment_new: (boolean|undefined),
     *   video_comment_edit: (boolean|undefined),
     *   video_comment_delete: (boolean|undefined),
     *   video_comment_restore: (boolean|undefined),
     *   market_comment_new: (boolean|undefined),
     *   market_comment_edit: (boolean|undefined),
     *   market_comment_delete: (boolean|undefined),
     *   market_comment_restore: (boolean|undefined),
     *   poll_vote_new: (boolean|undefined),
     *   group_join: (boolean|undefined),
     *   group_leave: (boolean|undefined),
     *   group_change_settings: (boolean|undefined),
     *   group_change_photo: (boolean|undefined),
     *   group_officers_edit: (boolean|undefined),
     *   user_block: (boolean|undefined),
     *   user_unblock: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsSetLongPollSettings",
    value: function groupsSetLongPollSettings(params) {
      var _this168 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this168);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee168() {
        return _regeneratorRuntime.wrap(function _callee168$(_context168) {
          while (1) {
            switch (_context168.prev = _context168.next) {
              case 0:
                return _context168.abrupt("return", _super("call").call(this, "groups.setLongPollSettings", params));

              case 1:
              case "end":
                return _context168.stop();
            }
          }
        }, _callee168, this);
      }));
    }
    /**
     * Returns a list of community addresses.
     *
     * @param {{
     *   group_id: (number),
     *   address_ids: (number[]|undefined),
     *   latitude: (number|undefined),
     *   longitude: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.AddressesFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsGetAddressesResponse>}
     */

  }, {
    key: "groupsGetAddresses",
    value: function groupsGetAddresses(params) {
      var _this169 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this169);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee169() {
        return _regeneratorRuntime.wrap(function _callee169$(_context169) {
          while (1) {
            switch (_context169.prev = _context169.next) {
              case 0:
                return _context169.abrupt("return", _super("call").call(this, "groups.getAddresses", params));

              case 1:
              case "end":
                return _context169.stop();
            }
          }
        }, _callee169, this);
      }));
    }
    /**
     * Returns a list of topics on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_ids: (number[]|undefined),
     *   order: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   preview: (number|undefined),
     *   preview_length: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BoardGetTopicsResponse>}
     */

  }, {
    key: "boardGetTopics",
    value: function boardGetTopics(params) {
      var _this170 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this170);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee170() {
        return _regeneratorRuntime.wrap(function _callee170$(_context170) {
          while (1) {
            switch (_context170.prev = _context170.next) {
              case 0:
                return _context170.abrupt("return", _super("call").call(this, "board.getTopics", params));

              case 1:
              case "end":
                return _context170.stop();
            }
          }
        }, _callee170, this);
      }));
    }
    /**
     * Returns a list of comments on a topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   need_likes: (boolean|undefined),
     *   start_comment_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   sort: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BoardGetCommentsResponse>}
     */

  }, {
    key: "boardGetComments",
    value: function boardGetComments(params) {
      var _this171 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this171);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee171() {
        return _regeneratorRuntime.wrap(function _callee171$(_context171) {
          while (1) {
            switch (_context171.prev = _context171.next) {
              case 0:
                return _context171.abrupt("return", _super("call").call(this, "board.getComments", params));

              case 1:
              case "end":
                return _context171.stop();
            }
          }
        }, _callee171, this);
      }));
    }
    /**
     * Creates a new topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   title: (string),
     *   text: (string|undefined),
     *   from_group: (boolean|undefined),
     *   attachments: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BoardAddTopicResponse>}
     */

  }, {
    key: "boardAddTopic",
    value: function boardAddTopic(params) {
      var _this172 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this172);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee172() {
        return _regeneratorRuntime.wrap(function _callee172$(_context172) {
          while (1) {
            switch (_context172.prev = _context172.next) {
              case 0:
                return _context172.abrupt("return", _super("call").call(this, "board.addTopic", params));

              case 1:
              case "end":
                return _context172.stop();
            }
          }
        }, _callee172, this);
      }));
    }
    /**
     * Adds a comment on a topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   from_group: (boolean|undefined),
     *   sticker_id: (number|undefined),
     *   guid: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BoardCreateCommentResponse>}
     */

  }, {
    key: "boardCreateComment",
    value: function boardCreateComment(params) {
      var _this173 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this173);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee173() {
        return _regeneratorRuntime.wrap(function _callee173$(_context173) {
          while (1) {
            switch (_context173.prev = _context173.next) {
              case 0:
                return _context173.abrupt("return", _super("call").call(this, "board.createComment", params));

              case 1:
              case "end":
                return _context173.stop();
            }
          }
        }, _callee173, this);
      }));
    }
    /**
     * Deletes a topic from a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardDeleteTopic",
    value: function boardDeleteTopic(params) {
      var _this174 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this174);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee174() {
        return _regeneratorRuntime.wrap(function _callee174$(_context174) {
          while (1) {
            switch (_context174.prev = _context174.next) {
              case 0:
                return _context174.abrupt("return", _super("call").call(this, "board.deleteTopic", params));

              case 1:
              case "end":
                return _context174.stop();
            }
          }
        }, _callee174, this);
      }));
    }
    /**
     * Edits the title of a topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   title: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardEditTopic",
    value: function boardEditTopic(params) {
      var _this175 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this175);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee175() {
        return _regeneratorRuntime.wrap(function _callee175$(_context175) {
          while (1) {
            switch (_context175.prev = _context175.next) {
              case 0:
                return _context175.abrupt("return", _super("call").call(this, "board.editTopic", params));

              case 1:
              case "end":
                return _context175.stop();
            }
          }
        }, _callee175, this);
      }));
    }
    /**
     * Edits a comment on a topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   comment_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardEditComment",
    value: function boardEditComment(params) {
      var _this176 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this176);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee176() {
        return _regeneratorRuntime.wrap(function _callee176$(_context176) {
          while (1) {
            switch (_context176.prev = _context176.next) {
              case 0:
                return _context176.abrupt("return", _super("call").call(this, "board.editComment", params));

              case 1:
              case "end":
                return _context176.stop();
            }
          }
        }, _callee176, this);
      }));
    }
    /**
     * Restores a comment deleted from a topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardRestoreComment",
    value: function boardRestoreComment(params) {
      var _this177 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this177);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee177() {
        return _regeneratorRuntime.wrap(function _callee177$(_context177) {
          while (1) {
            switch (_context177.prev = _context177.next) {
              case 0:
                return _context177.abrupt("return", _super("call").call(this, "board.restoreComment", params));

              case 1:
              case "end":
                return _context177.stop();
            }
          }
        }, _callee177, this);
      }));
    }
    /**
     * Deletes a comment on a topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardDeleteComment",
    value: function boardDeleteComment(params) {
      var _this178 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this178);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee178() {
        return _regeneratorRuntime.wrap(function _callee178$(_context178) {
          while (1) {
            switch (_context178.prev = _context178.next) {
              case 0:
                return _context178.abrupt("return", _super("call").call(this, "board.deleteComment", params));

              case 1:
              case "end":
                return _context178.stop();
            }
          }
        }, _callee178, this);
      }));
    }
    /**
     * Re-opens a previously closed topic on a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardOpenTopic",
    value: function boardOpenTopic(params) {
      var _this179 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this179);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee179() {
        return _regeneratorRuntime.wrap(function _callee179$(_context179) {
          while (1) {
            switch (_context179.prev = _context179.next) {
              case 0:
                return _context179.abrupt("return", _super("call").call(this, "board.openTopic", params));

              case 1:
              case "end":
                return _context179.stop();
            }
          }
        }, _callee179, this);
      }));
    }
    /**
     * Closes a topic on a community's discussion board so that comments cannot be posted.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardCloseTopic",
    value: function boardCloseTopic(params) {
      var _this180 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this180);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee180() {
        return _regeneratorRuntime.wrap(function _callee180$(_context180) {
          while (1) {
            switch (_context180.prev = _context180.next) {
              case 0:
                return _context180.abrupt("return", _super("call").call(this, "board.closeTopic", params));

              case 1:
              case "end":
                return _context180.stop();
            }
          }
        }, _callee180, this);
      }));
    }
    /**
     * Pins a topic (fixes its place) to the top of a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardFixTopic",
    value: function boardFixTopic(params) {
      var _this181 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this181);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee181() {
        return _regeneratorRuntime.wrap(function _callee181$(_context181) {
          while (1) {
            switch (_context181.prev = _context181.next) {
              case 0:
                return _context181.abrupt("return", _super("call").call(this, "board.fixTopic", params));

              case 1:
              case "end":
                return _context181.stop();
            }
          }
        }, _callee181, this);
      }));
    }
    /**
     * Unpins a pinned topic from the top of a community's discussion board.
     *
     * @param {{
     *   group_id: (number),
     *   topic_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "boardUnfixTopic",
    value: function boardUnfixTopic(params) {
      var _this182 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this182);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee182() {
        return _regeneratorRuntime.wrap(function _callee182$(_context182) {
          while (1) {
            switch (_context182.prev = _context182.next) {
              case 0:
                return _context182.abrupt("return", _super("call").call(this, "board.unfixTopic", params));

              case 1:
              case "end":
                return _context182.stop();
            }
          }
        }, _callee182, this);
      }));
    }
    /**
     * Returns detailed information about videos.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   videos: (string[]|undefined),
     *   album_id: (number|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoGetResponse>}
     */

  }, {
    key: "videoGet",
    value: function videoGet(params) {
      var _this183 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this183);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee183() {
        return _regeneratorRuntime.wrap(function _callee183$(_context183) {
          while (1) {
            switch (_context183.prev = _context183.next) {
              case 0:
                return _context183.abrupt("return", _super("call").call(this, "video.get", params));

              case 1:
              case "end":
                return _context183.stop();
            }
          }
        }, _callee183, this);
      }));
    }
    /**
     * Edits information about a video on a user or community page.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   video_id: (number),
     *   name: (string|undefined),
     *   desc: (string|undefined),
     *   privacy_view: (string[]|undefined),
     *   privacy_comment: (string[]|undefined),
     *   no_comments: (boolean|undefined),
     *   repeat: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoEdit",
    value: function videoEdit(params) {
      var _this184 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this184);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee184() {
        return _regeneratorRuntime.wrap(function _callee184$(_context184) {
          while (1) {
            switch (_context184.prev = _context184.next) {
              case 0:
                return _context184.abrupt("return", _super("call").call(this, "video.edit", params));

              case 1:
              case "end":
                return _context184.stop();
            }
          }
        }, _callee184, this);
      }));
    }
    /**
     * Adds a video to a user or community page.
     *
     * @param {{
     *   target_id: (number|undefined),
     *   video_id: (number),
     *   owner_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoAdd",
    value: function videoAdd(params) {
      var _this185 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this185);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee185() {
        return _regeneratorRuntime.wrap(function _callee185$(_context185) {
          while (1) {
            switch (_context185.prev = _context185.next) {
              case 0:
                return _context185.abrupt("return", _super("call").call(this, "video.add", params));

              case 1:
              case "end":
                return _context185.stop();
            }
          }
        }, _callee185, this);
      }));
    }
    /**
     * Returns a server address (required for upload) and video data.
     *
     * @param {{
     *   name: (string|undefined),
     *   description: (string|undefined),
     *   is_private: (boolean|undefined),
     *   wallpost: (boolean|undefined),
     *   link: (string|undefined),
     *   group_id: (number|undefined),
     *   album_id: (number|undefined),
     *   privacy_view: (string[]|undefined),
     *   privacy_comment: (string[]|undefined),
     *   no_comments: (boolean|undefined),
     *   repeat: (boolean|undefined),
     *   compression: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoSaveResponse>}
     */

  }, {
    key: "videoSave",
    value: function videoSave(params) {
      var _this186 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this186);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee186() {
        return _regeneratorRuntime.wrap(function _callee186$(_context186) {
          while (1) {
            switch (_context186.prev = _context186.next) {
              case 0:
                return _context186.abrupt("return", _super("call").call(this, "video.save", params));

              case 1:
              case "end":
                return _context186.stop();
            }
          }
        }, _callee186, this);
      }));
    }
    /**
     * Deletes a video from a user or community page.
     *
     * @param {{
     *   video_id: (number),
     *   owner_id: (number|undefined),
     *   target_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoDelete",
    value: function videoDelete(params) {
      var _this187 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this187);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee187() {
        return _regeneratorRuntime.wrap(function _callee187$(_context187) {
          while (1) {
            switch (_context187.prev = _context187.next) {
              case 0:
                return _context187.abrupt("return", _super("call").call(this, "video.delete", params));

              case 1:
              case "end":
                return _context187.stop();
            }
          }
        }, _callee187, this);
      }));
    }
    /**
     * Restores a previously deleted video.
     *
     * @param {{
     *   video_id: (number),
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoRestore",
    value: function videoRestore(params) {
      var _this188 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this188);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee188() {
        return _regeneratorRuntime.wrap(function _callee188$(_context188) {
          while (1) {
            switch (_context188.prev = _context188.next) {
              case 0:
                return _context188.abrupt("return", _super("call").call(this, "video.restore", params));

              case 1:
              case "end":
                return _context188.stop();
            }
          }
        }, _callee188, this);
      }));
    }
    /**
     * Returns a list of videos under the set search criterion.
     *
     * @param {{
     *   q: (string),
     *   sort: (number|undefined),
     *   hd: (number|undefined),
     *   adult: (boolean|undefined),
     *   filters: (string[]|undefined),
     *   search_own: (boolean|undefined),
     *   offset: (number|undefined),
     *   longer: (number|undefined),
     *   shorter: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoSearchResponse>}
     */

  }, {
    key: "videoSearch",
    value: function videoSearch(params) {
      var _this189 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this189);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee189() {
        return _regeneratorRuntime.wrap(function _callee189$(_context189) {
          while (1) {
            switch (_context189.prev = _context189.next) {
              case 0:
                return _context189.abrupt("return", _super("call").call(this, "video.search", params));

              case 1:
              case "end":
                return _context189.stop();
            }
          }
        }, _callee189, this);
      }));
    }
    /**
     * Returns a list of video albums owned by a user or community.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   need_system: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoGetAlbumsResponse>}
     */

  }, {
    key: "videoGetAlbums",
    value: function videoGetAlbums(params) {
      var _this190 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this190);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee190() {
        return _regeneratorRuntime.wrap(function _callee190$(_context190) {
          while (1) {
            switch (_context190.prev = _context190.next) {
              case 0:
                return _context190.abrupt("return", _super("call").call(this, "video.getAlbums", params));

              case 1:
              case "end":
                return _context190.stop();
            }
          }
        }, _callee190, this);
      }));
    }
    /**
     * Returns video album info
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   album_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoGetAlbumByIdResponse>}
     */

  }, {
    key: "videoGetAlbumById",
    value: function videoGetAlbumById(params) {
      var _this191 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this191);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee191() {
        return _regeneratorRuntime.wrap(function _callee191$(_context191) {
          while (1) {
            switch (_context191.prev = _context191.next) {
              case 0:
                return _context191.abrupt("return", _super("call").call(this, "video.getAlbumById", params));

              case 1:
              case "end":
                return _context191.stop();
            }
          }
        }, _callee191, this);
      }));
    }
    /**
     * Creates an empty album for videos.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   title: (string|undefined),
     *   privacy: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoAddAlbumResponse>}
     */

  }, {
    key: "videoAddAlbum",
    value: function videoAddAlbum(params) {
      var _this192 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this192);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee192() {
        return _regeneratorRuntime.wrap(function _callee192$(_context192) {
          while (1) {
            switch (_context192.prev = _context192.next) {
              case 0:
                return _context192.abrupt("return", _super("call").call(this, "video.addAlbum", params));

              case 1:
              case "end":
                return _context192.stop();
            }
          }
        }, _callee192, this);
      }));
    }
    /**
     * Edits the title of a video album.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   album_id: (number),
     *   title: (string),
     *   privacy: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoEditAlbum",
    value: function videoEditAlbum(params) {
      var _this193 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this193);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee193() {
        return _regeneratorRuntime.wrap(function _callee193$(_context193) {
          while (1) {
            switch (_context193.prev = _context193.next) {
              case 0:
                return _context193.abrupt("return", _super("call").call(this, "video.editAlbum", params));

              case 1:
              case "end":
                return _context193.stop();
            }
          }
        }, _callee193, this);
      }));
    }
    /**
     * Deletes a video album.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   album_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoDeleteAlbum",
    value: function videoDeleteAlbum(params) {
      var _this194 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this194);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee194() {
        return _regeneratorRuntime.wrap(function _callee194$(_context194) {
          while (1) {
            switch (_context194.prev = _context194.next) {
              case 0:
                return _context194.abrupt("return", _super("call").call(this, "video.deleteAlbum", params));

              case 1:
              case "end":
                return _context194.stop();
            }
          }
        }, _callee194, this);
      }));
    }
    /**
     * Reorders the album in the list of user video albums.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   album_id: (number),
     *   before: (number|undefined),
     *   after: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoReorderAlbums",
    value: function videoReorderAlbums(params) {
      var _this195 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this195);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee195() {
        return _regeneratorRuntime.wrap(function _callee195$(_context195) {
          while (1) {
            switch (_context195.prev = _context195.next) {
              case 0:
                return _context195.abrupt("return", _super("call").call(this, "video.reorderAlbums", params));

              case 1:
              case "end":
                return _context195.stop();
            }
          }
        }, _callee195, this);
      }));
    }
    /**
     * Reorders the video in the video album.
     *
     * @param {{
     *   target_id: (number|undefined),
     *   album_id: (number|undefined),
     *   owner_id: (number),
     *   video_id: (number),
     *   before_owner_id: (number|undefined),
     *   before_video_id: (number|undefined),
     *   after_owner_id: (number|undefined),
     *   after_video_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoReorderVideos",
    value: function videoReorderVideos(params) {
      var _this196 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this196);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee196() {
        return _regeneratorRuntime.wrap(function _callee196$(_context196) {
          while (1) {
            switch (_context196.prev = _context196.next) {
              case 0:
                return _context196.abrupt("return", _super("call").call(this, "video.reorderVideos", params));

              case 1:
              case "end":
                return _context196.stop();
            }
          }
        }, _callee196, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   target_id: (number|undefined),
     *   album_id: (number|undefined),
     *   album_ids: (number[]|undefined),
     *   owner_id: (number),
     *   video_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoAddToAlbum",
    value: function videoAddToAlbum(params) {
      var _this197 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this197);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee197() {
        return _regeneratorRuntime.wrap(function _callee197$(_context197) {
          while (1) {
            switch (_context197.prev = _context197.next) {
              case 0:
                return _context197.abrupt("return", _super("call").call(this, "video.addToAlbum", params));

              case 1:
              case "end":
                return _context197.stop();
            }
          }
        }, _callee197, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   target_id: (number|undefined),
     *   album_id: (number|undefined),
     *   album_ids: (number[]|undefined),
     *   owner_id: (number),
     *   video_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoRemoveFromAlbum",
    value: function videoRemoveFromAlbum(params) {
      var _this198 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this198);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee198() {
        return _regeneratorRuntime.wrap(function _callee198$(_context198) {
          while (1) {
            switch (_context198.prev = _context198.next) {
              case 0:
                return _context198.abrupt("return", _super("call").call(this, "video.removeFromAlbum", params));

              case 1:
              case "end":
                return _context198.stop();
            }
          }
        }, _callee198, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   target_id: (number|undefined),
     *   owner_id: (number),
     *   video_id: (number),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoGetAlbumsByVideoResponse>}
     */

  }, {
    key: "videoGetAlbumsByVideo",
    value: function videoGetAlbumsByVideo(params) {
      var _this199 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this199);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee199() {
        return _regeneratorRuntime.wrap(function _callee199$(_context199) {
          while (1) {
            switch (_context199.prev = _context199.next) {
              case 0:
                return _context199.abrupt("return", _super("call").call(this, "video.getAlbumsByVideo", params));

              case 1:
              case "end":
                return _context199.stop();
            }
          }
        }, _callee199, this);
      }));
    }
    /**
     * Returns a list of comments on a video.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   video_id: (number),
     *   need_likes: (boolean|undefined),
     *   start_comment_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   sort: (string|undefined),
     *   extended: (boolean|undefined),
     *   fields: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoGetCommentsResponse>}
     */

  }, {
    key: "videoGetComments",
    value: function videoGetComments(params) {
      var _this200 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this200);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee200() {
        return _regeneratorRuntime.wrap(function _callee200$(_context200) {
          while (1) {
            switch (_context200.prev = _context200.next) {
              case 0:
                return _context200.abrupt("return", _super("call").call(this, "video.getComments", params));

              case 1:
              case "end":
                return _context200.stop();
            }
          }
        }, _callee200, this);
      }));
    }
    /**
     * Adds a new comment on a video.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   video_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   from_group: (boolean|undefined),
     *   reply_to_comment: (number|undefined),
     *   sticker_id: (number|undefined),
     *   guid: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoCreateCommentResponse>}
     */

  }, {
    key: "videoCreateComment",
    value: function videoCreateComment(params) {
      var _this201 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this201);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee201() {
        return _regeneratorRuntime.wrap(function _callee201$(_context201) {
          while (1) {
            switch (_context201.prev = _context201.next) {
              case 0:
                return _context201.abrupt("return", _super("call").call(this, "video.createComment", params));

              case 1:
              case "end":
                return _context201.stop();
            }
          }
        }, _callee201, this);
      }));
    }
    /**
     * Deletes a comment on a video.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoDeleteComment",
    value: function videoDeleteComment(params) {
      var _this202 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this202);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee202() {
        return _regeneratorRuntime.wrap(function _callee202$(_context202) {
          while (1) {
            switch (_context202.prev = _context202.next) {
              case 0:
                return _context202.abrupt("return", _super("call").call(this, "video.deleteComment", params));

              case 1:
              case "end":
                return _context202.stop();
            }
          }
        }, _callee202, this);
      }));
    }
    /**
     * Restores a previously deleted comment on a video.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.VideoRestoreCommentResponse>}
     */

  }, {
    key: "videoRestoreComment",
    value: function videoRestoreComment(params) {
      var _this203 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this203);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee203() {
        return _regeneratorRuntime.wrap(function _callee203$(_context203) {
          while (1) {
            switch (_context203.prev = _context203.next) {
              case 0:
                return _context203.abrupt("return", _super("call").call(this, "video.restoreComment", params));

              case 1:
              case "end":
                return _context203.stop();
            }
          }
        }, _callee203, this);
      }));
    }
    /**
     * Edits the text of a comment on a video.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   comment_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoEditComment",
    value: function videoEditComment(params) {
      var _this204 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this204);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee204() {
        return _regeneratorRuntime.wrap(function _callee204$(_context204) {
          while (1) {
            switch (_context204.prev = _context204.next) {
              case 0:
                return _context204.abrupt("return", _super("call").call(this, "video.editComment", params));

              case 1:
              case "end":
                return _context204.stop();
            }
          }
        }, _callee204, this);
      }));
    }
    /**
     * Reports (submits a complaint about) a video.
     *
     * @param {{
     *   owner_id: (number),
     *   video_id: (number),
     *   reason: (number|undefined),
     *   comment: (string|undefined),
     *   search_query: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoReport",
    value: function videoReport(params) {
      var _this205 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this205);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee205() {
        return _regeneratorRuntime.wrap(function _callee205$(_context205) {
          while (1) {
            switch (_context205.prev = _context205.next) {
              case 0:
                return _context205.abrupt("return", _super("call").call(this, "video.report", params));

              case 1:
              case "end":
                return _context205.stop();
            }
          }
        }, _callee205, this);
      }));
    }
    /**
     * Reports (submits a complaint about) a comment on a video.
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   reason: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "videoReportComment",
    value: function videoReportComment(params) {
      var _this206 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this206);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee206() {
        return _regeneratorRuntime.wrap(function _callee206$(_context206) {
          while (1) {
            switch (_context206.prev = _context206.next) {
              case 0:
                return _context206.abrupt("return", _super("call").call(this, "video.reportComment", params));

              case 1:
              case "end":
                return _context206.stop();
            }
          }
        }, _callee206, this);
      }));
    }
    /**
     * Returns a list of notes created by a user.
     *
     * @param {{
     *   note_ids: (number[]|undefined),
     *   user_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   sort: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotesGetResponse>}
     */

  }, {
    key: "notesGet",
    value: function notesGet(params) {
      var _this207 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this207);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee207() {
        return _regeneratorRuntime.wrap(function _callee207$(_context207) {
          while (1) {
            switch (_context207.prev = _context207.next) {
              case 0:
                return _context207.abrupt("return", _super("call").call(this, "notes.get", params));

              case 1:
              case "end":
                return _context207.stop();
            }
          }
        }, _callee207, this);
      }));
    }
    /**
     * Returns a note by its ID.
     *
     * @param {{
     *   note_id: (number),
     *   owner_id: (number|undefined),
     *   need_wiki: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotesGetByIdResponse>}
     */

  }, {
    key: "notesGetById",
    value: function notesGetById(params) {
      var _this208 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this208);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee208() {
        return _regeneratorRuntime.wrap(function _callee208$(_context208) {
          while (1) {
            switch (_context208.prev = _context208.next) {
              case 0:
                return _context208.abrupt("return", _super("call").call(this, "notes.getById", params));

              case 1:
              case "end":
                return _context208.stop();
            }
          }
        }, _callee208, this);
      }));
    }
    /**
     * Creates a new note for the current user.
     *
     * @param {{
     *   title: (string),
     *   text: (string),
     *   privacy_view: (string[]|undefined),
     *   privacy_comment: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotesAddResponse>}
     */

  }, {
    key: "notesAdd",
    value: function notesAdd(params) {
      var _this209 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this209);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee209() {
        return _regeneratorRuntime.wrap(function _callee209$(_context209) {
          while (1) {
            switch (_context209.prev = _context209.next) {
              case 0:
                return _context209.abrupt("return", _super("call").call(this, "notes.add", params));

              case 1:
              case "end":
                return _context209.stop();
            }
          }
        }, _callee209, this);
      }));
    }
    /**
     * Edits a note of the current user.
     *
     * @param {{
     *   note_id: (number),
     *   title: (string),
     *   text: (string),
     *   privacy_view: (string[]|undefined),
     *   privacy_comment: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "notesEdit",
    value: function notesEdit(params) {
      var _this210 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this210);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee210() {
        return _regeneratorRuntime.wrap(function _callee210$(_context210) {
          while (1) {
            switch (_context210.prev = _context210.next) {
              case 0:
                return _context210.abrupt("return", _super("call").call(this, "notes.edit", params));

              case 1:
              case "end":
                return _context210.stop();
            }
          }
        }, _callee210, this);
      }));
    }
    /**
     * Deletes a note of the current user.
     *
     * @param {{
     *   note_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "notesDelete",
    value: function notesDelete(params) {
      var _this211 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this211);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee211() {
        return _regeneratorRuntime.wrap(function _callee211$(_context211) {
          while (1) {
            switch (_context211.prev = _context211.next) {
              case 0:
                return _context211.abrupt("return", _super("call").call(this, "notes.delete", params));

              case 1:
              case "end":
                return _context211.stop();
            }
          }
        }, _callee211, this);
      }));
    }
    /**
     * Returns a list of comments on a note.
     *
     * @param {{
     *   note_id: (number),
     *   owner_id: (number|undefined),
     *   sort: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotesGetCommentsResponse>}
     */

  }, {
    key: "notesGetComments",
    value: function notesGetComments(params) {
      var _this212 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this212);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee212() {
        return _regeneratorRuntime.wrap(function _callee212$(_context212) {
          while (1) {
            switch (_context212.prev = _context212.next) {
              case 0:
                return _context212.abrupt("return", _super("call").call(this, "notes.getComments", params));

              case 1:
              case "end":
                return _context212.stop();
            }
          }
        }, _callee212, this);
      }));
    }
    /**
     * Adds a new comment on a note.
     *
     * @param {{
     *   note_id: (number),
     *   owner_id: (number|undefined),
     *   reply_to: (number|undefined),
     *   message: (string),
     *   guid: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotesCreateCommentResponse>}
     */

  }, {
    key: "notesCreateComment",
    value: function notesCreateComment(params) {
      var _this213 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this213);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee213() {
        return _regeneratorRuntime.wrap(function _callee213$(_context213) {
          while (1) {
            switch (_context213.prev = _context213.next) {
              case 0:
                return _context213.abrupt("return", _super("call").call(this, "notes.createComment", params));

              case 1:
              case "end":
                return _context213.stop();
            }
          }
        }, _callee213, this);
      }));
    }
    /**
     * Edits a comment on a note.
     *
     * @param {{
     *   comment_id: (number),
     *   owner_id: (number|undefined),
     *   message: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "notesEditComment",
    value: function notesEditComment(params) {
      var _this214 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this214);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee214() {
        return _regeneratorRuntime.wrap(function _callee214$(_context214) {
          while (1) {
            switch (_context214.prev = _context214.next) {
              case 0:
                return _context214.abrupt("return", _super("call").call(this, "notes.editComment", params));

              case 1:
              case "end":
                return _context214.stop();
            }
          }
        }, _callee214, this);
      }));
    }
    /**
     * Deletes a comment on a note.
     *
     * @param {{
     *   comment_id: (number),
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "notesDeleteComment",
    value: function notesDeleteComment(params) {
      var _this215 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this215);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee215() {
        return _regeneratorRuntime.wrap(function _callee215$(_context215) {
          while (1) {
            switch (_context215.prev = _context215.next) {
              case 0:
                return _context215.abrupt("return", _super("call").call(this, "notes.deleteComment", params));

              case 1:
              case "end":
                return _context215.stop();
            }
          }
        }, _callee215, this);
      }));
    }
    /**
     * Restores a deleted comment on a note.
     *
     * @param {{
     *   comment_id: (number),
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "notesRestoreComment",
    value: function notesRestoreComment(params) {
      var _this216 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this216);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee216() {
        return _regeneratorRuntime.wrap(function _callee216$(_context216) {
          while (1) {
            switch (_context216.prev = _context216.next) {
              case 0:
                return _context216.abrupt("return", _super("call").call(this, "notes.restoreComment", params));

              case 1:
              case "end":
                return _context216.stop();
            }
          }
        }, _callee216, this);
      }));
    }
    /**
     * Returns non-null values of user counters.
     *
     * @param {{
     *   filter: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetCountersResponse>}
     */

  }, {
    key: "accountGetCounters",
    value: function accountGetCounters(params) {
      var _this217 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this217);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee217() {
        return _regeneratorRuntime.wrap(function _callee217$(_context217) {
          while (1) {
            switch (_context217.prev = _context217.next) {
              case 0:
                return _context217.abrupt("return", _super("call").call(this, "account.getCounters", params));

              case 1:
              case "end":
                return _context217.stop();
            }
          }
        }, _callee217, this);
      }));
    }
    /**
     * Sets an application screen name (up to 17 characters), that is shown to the user in the left menu.
     *
     * @param {{
     *   user_id: (number),
     *   name: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountSetNameInMenu",
    value: function accountSetNameInMenu(params) {
      var _this218 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this218);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee218() {
        return _regeneratorRuntime.wrap(function _callee218$(_context218) {
          while (1) {
            switch (_context218.prev = _context218.next) {
              case 0:
                return _context218.abrupt("return", _super("call").call(this, "account.setNameInMenu", params));

              case 1:
              case "end":
                return _context218.stop();
            }
          }
        }, _callee218, this);
      }));
    }
    /**
     * Marks the current user as online for 15 minutes.
     *
     * @param {{
     *   voip: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountSetOnline",
    value: function accountSetOnline(params) {
      var _this219 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this219);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee219() {
        return _regeneratorRuntime.wrap(function _callee219$(_context219) {
          while (1) {
            switch (_context219.prev = _context219.next) {
              case 0:
                return _context219.abrupt("return", _super("call").call(this, "account.setOnline", params));

              case 1:
              case "end":
                return _context219.stop();
            }
          }
        }, _callee219, this);
      }));
    }
    /**
     * Marks a current user as offline.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountSetOffline",
    value: function accountSetOffline(params) {
      var _this220 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this220);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee220() {
        return _regeneratorRuntime.wrap(function _callee220$(_context220) {
          while (1) {
            switch (_context220.prev = _context220.next) {
              case 0:
                return _context220.abrupt("return", _super("call").call(this, "account.setOffline", params));

              case 1:
              case "end":
                return _context220.stop();
            }
          }
        }, _callee220, this);
      }));
    }
    /**
     * Subscribes an iOS/Android/Windows Phone-based device to receive push notifications
     *
     * @param {{
     *   token: (string),
     *   device_model: (string|undefined),
     *   device_year: (number|undefined),
     *   device_id: (string),
     *   system_version: (string|undefined),
     *   settings: (string|undefined),
     *   sandbox: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountRegisterDevice",
    value: function accountRegisterDevice(params) {
      var _this221 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this221);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee221() {
        return _regeneratorRuntime.wrap(function _callee221$(_context221) {
          while (1) {
            switch (_context221.prev = _context221.next) {
              case 0:
                return _context221.abrupt("return", _super("call").call(this, "account.registerDevice", params));

              case 1:
              case "end":
                return _context221.stop();
            }
          }
        }, _callee221, this);
      }));
    }
    /**
     * Unsubscribes a device from push notifications.
     *
     * @param {{
     *   device_id: (string|undefined),
     *   sandbox: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountUnregisterDevice",
    value: function accountUnregisterDevice(params) {
      var _this222 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this222);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee222() {
        return _regeneratorRuntime.wrap(function _callee222$(_context222) {
          while (1) {
            switch (_context222.prev = _context222.next) {
              case 0:
                return _context222.abrupt("return", _super("call").call(this, "account.unregisterDevice", params));

              case 1:
              case "end":
                return _context222.stop();
            }
          }
        }, _callee222, this);
      }));
    }
    /**
     * Mutes push notifications for the set period of time.
     *
     * @param {{
     *   device_id: (string|undefined),
     *   time: (number|undefined),
     *   peer_id: (number|undefined),
     *   sound: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountSetSilenceMode",
    value: function accountSetSilenceMode(params) {
      var _this223 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this223);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee223() {
        return _regeneratorRuntime.wrap(function _callee223$(_context223) {
          while (1) {
            switch (_context223.prev = _context223.next) {
              case 0:
                return _context223.abrupt("return", _super("call").call(this, "account.setSilenceMode", params));

              case 1:
              case "end":
                return _context223.stop();
            }
          }
        }, _callee223, this);
      }));
    }
    /**
     * Gets settings of push notifications.
     *
     * @param {{
     *   device_id: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetPushSettingsResponse>}
     */

  }, {
    key: "accountGetPushSettings",
    value: function accountGetPushSettings(params) {
      var _this224 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this224);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee224() {
        return _regeneratorRuntime.wrap(function _callee224$(_context224) {
          while (1) {
            switch (_context224.prev = _context224.next) {
              case 0:
                return _context224.abrupt("return", _super("call").call(this, "account.getPushSettings", params));

              case 1:
              case "end":
                return _context224.stop();
            }
          }
        }, _callee224, this);
      }));
    }
    /**
     * Change push settings.
     *
     * @param {{
     *   device_id: (string),
     *   settings: (string|undefined),
     *   key: (string|undefined),
     *   value: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountSetPushSettings",
    value: function accountSetPushSettings(params) {
      var _this225 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this225);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee225() {
        return _regeneratorRuntime.wrap(function _callee225$(_context225) {
          while (1) {
            switch (_context225.prev = _context225.next) {
              case 0:
                return _context225.abrupt("return", _super("call").call(this, "account.setPushSettings", params));

              case 1:
              case "end":
                return _context225.stop();
            }
          }
        }, _callee225, this);
      }));
    }
    /**
     * Gets settings of the user in this application.
     *
     * @param {{
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetAppPermissionsResponse>}
     */

  }, {
    key: "accountGetAppPermissions",
    value: function accountGetAppPermissions(params) {
      var _this226 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this226);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee226() {
        return _regeneratorRuntime.wrap(function _callee226$(_context226) {
          while (1) {
            switch (_context226.prev = _context226.next) {
              case 0:
                return _context226.abrupt("return", _super("call").call(this, "account.getAppPermissions", params));

              case 1:
              case "end":
                return _context226.stop();
            }
          }
        }, _callee226, this);
      }));
    }
    /**
     * Returns a list of active ads (offers) which executed by the user will bring him/her respective number of votes to his balance in the application.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetActiveOffersResponse>}
     */

  }, {
    key: "accountGetActiveOffers",
    value: function accountGetActiveOffers(params) {
      var _this227 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this227);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee227() {
        return _regeneratorRuntime.wrap(function _callee227$(_context227) {
          while (1) {
            switch (_context227.prev = _context227.next) {
              case 0:
                return _context227.abrupt("return", _super("call").call(this, "account.getActiveOffers", params));

              case 1:
              case "end":
                return _context227.stop();
            }
          }
        }, _callee227, this);
      }));
    }
    /**
     * Returns a user's blacklist.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetBannedResponse>}
     */

  }, {
    key: "accountGetBanned",
    value: function accountGetBanned(params) {
      var _this228 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this228);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee228() {
        return _regeneratorRuntime.wrap(function _callee228$(_context228) {
          while (1) {
            switch (_context228.prev = _context228.next) {
              case 0:
                return _context228.abrupt("return", _super("call").call(this, "account.getBanned", params));

              case 1:
              case "end":
                return _context228.stop();
            }
          }
        }, _callee228, this);
      }));
    }
    /**
     * Returns current account info.
     *
     * @param {{
     *   fields: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetInfoResponse>}
     */

  }, {
    key: "accountGetInfo",
    value: function accountGetInfo(params) {
      var _this229 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this229);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee229() {
        return _regeneratorRuntime.wrap(function _callee229$(_context229) {
          while (1) {
            switch (_context229.prev = _context229.next) {
              case 0:
                return _context229.abrupt("return", _super("call").call(this, "account.getInfo", params));

              case 1:
              case "end":
                return _context229.stop();
            }
          }
        }, _callee229, this);
      }));
    }
    /**
     * Allows to edit the current account info.
     *
     * @param {{
     *   name: (string|undefined),
     *   value: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountSetInfo",
    value: function accountSetInfo(params) {
      var _this230 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this230);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee230() {
        return _regeneratorRuntime.wrap(function _callee230$(_context230) {
          while (1) {
            switch (_context230.prev = _context230.next) {
              case 0:
                return _context230.abrupt("return", _super("call").call(this, "account.setInfo", params));

              case 1:
              case "end":
                return _context230.stop();
            }
          }
        }, _callee230, this);
      }));
    }
    /**
     * Changes a user password after access is successfully restored with the [vk.com/dev/auth.restore|auth.restore] method.
     *
     * @param {{
     *   restore_sid: (string|undefined),
     *   change_password_hash: (string|undefined),
     *   old_password: (string|undefined),
     *   new_password: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountChangePasswordResponse>}
     */

  }, {
    key: "accountChangePassword",
    value: function accountChangePassword(params) {
      var _this231 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this231);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee231() {
        return _regeneratorRuntime.wrap(function _callee231$(_context231) {
          while (1) {
            switch (_context231.prev = _context231.next) {
              case 0:
                return _context231.abrupt("return", _super("call").call(this, "account.changePassword", params));

              case 1:
              case "end":
                return _context231.stop();
            }
          }
        }, _callee231, this);
      }));
    }
    /**
     * Returns the current account info.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountGetProfileInfoResponse>}
     */

  }, {
    key: "accountGetProfileInfo",
    value: function accountGetProfileInfo(params) {
      var _this232 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this232);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee232() {
        return _regeneratorRuntime.wrap(function _callee232$(_context232) {
          while (1) {
            switch (_context232.prev = _context232.next) {
              case 0:
                return _context232.abrupt("return", _super("call").call(this, "account.getProfileInfo", params));

              case 1:
              case "end":
                return _context232.stop();
            }
          }
        }, _callee232, this);
      }));
    }
    /**
     * Edits current profile info.
     *
     * @param {{
     *   first_name: (string|undefined),
     *   last_name: (string|undefined),
     *   maiden_name: (string|undefined),
     *   screen_name: (string|undefined),
     *   cancel_request_id: (number|undefined),
     *   sex: (number|undefined),
     *   relation: (number|undefined),
     *   relation_partner_id: (number|undefined),
     *   bdate: (string|undefined),
     *   bdate_visibility: (number|undefined),
     *   home_town: (string|undefined),
     *   country_id: (number|undefined),
     *   city_id: (number|undefined),
     *   status: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AccountSaveProfileInfoResponse>}
     */

  }, {
    key: "accountSaveProfileInfo",
    value: function accountSaveProfileInfo(params) {
      var _this233 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this233);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee233() {
        return _regeneratorRuntime.wrap(function _callee233$(_context233) {
          while (1) {
            switch (_context233.prev = _context233.next) {
              case 0:
                return _context233.abrupt("return", _super("call").call(this, "account.saveProfileInfo", params));

              case 1:
              case "end":
                return _context233.stop();
            }
          }
        }, _callee233, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   link: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesJoinChatByInviteLinkResponse>}
     */

  }, {
    key: "messagesJoinChatByInviteLink",
    value: function messagesJoinChatByInviteLink(params) {
      var _this234 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this234);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee234() {
        return _regeneratorRuntime.wrap(function _callee234$(_context234) {
          while (1) {
            switch (_context234.prev = _context234.next) {
              case 0:
                return _context234.abrupt("return", _super("call").call(this, "messages.joinChatByInviteLink", params));

              case 1:
              case "end":
                return _context234.stop();
            }
          }
        }, _callee234, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   peer_id: (number),
     *   reset: (boolean|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetInviteLinkResponse>}
     */

  }, {
    key: "messagesGetInviteLink",
    value: function messagesGetInviteLink(params) {
      var _this235 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this235);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee235() {
        return _regeneratorRuntime.wrap(function _callee235$(_context235) {
          while (1) {
            switch (_context235.prev = _context235.next) {
              case 0:
                return _context235.abrupt("return", _super("call").call(this, "messages.getInviteLink", params));

              case 1:
              case "end":
                return _context235.stop();
            }
          }
        }, _callee235, this);
      }));
    }
    /**
     * Returns a list of the current user's conversations.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   filter: (string|undefined),
     *   extended: (boolean|undefined),
     *   start_message_id: (number|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetConversationsResponse>}
     */

  }, {
    key: "messagesGetConversations",
    value: function messagesGetConversations(params) {
      var _this236 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this236);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee236() {
        return _regeneratorRuntime.wrap(function _callee236$(_context236) {
          while (1) {
            switch (_context236.prev = _context236.next) {
              case 0:
                return _context236.abrupt("return", _super("call").call(this, "messages.getConversations", params));

              case 1:
              case "end":
                return _context236.stop();
            }
          }
        }, _callee236, this);
      }));
    }
    /**
     * Returns conversations by their IDs
     *
     * @param {{
     *   peer_ids: (number[]),
     *   extended: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetConversationsByIdResponse>}
     */

  }, {
    key: "messagesGetConversationsById",
    value: function messagesGetConversationsById(params) {
      var _this237 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this237);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee237() {
        return _regeneratorRuntime.wrap(function _callee237$(_context237) {
          while (1) {
            switch (_context237.prev = _context237.next) {
              case 0:
                return _context237.abrupt("return", _super("call").call(this, "messages.getConversationsById", params));

              case 1:
              case "end":
                return _context237.stop();
            }
          }
        }, _callee237, this);
      }));
    }
    /**
     * Returns messages by their IDs.
     *
     * @param {{
     *   message_ids: (number[]),
     *   preview_length: (number|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetByIdResponse>}
     */

  }, {
    key: "messagesGetById",
    value: function messagesGetById(params) {
      var _this238 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this238);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee238() {
        return _regeneratorRuntime.wrap(function _callee238$(_context238) {
          while (1) {
            switch (_context238.prev = _context238.next) {
              case 0:
                return _context238.abrupt("return", _super("call").call(this, "messages.getById", params));

              case 1:
              case "end":
                return _context238.stop();
            }
          }
        }, _callee238, this);
      }));
    }
    /**
     * Returns messages by their IDs within the conversation.
     *
     * @param {{
     *   peer_id: (number),
     *   conversation_message_ids: (number[]),
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetByConversationMessageIdResponse>}
     */

  }, {
    key: "messagesGetByConversationMessageId",
    value: function messagesGetByConversationMessageId(params) {
      var _this239 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this239);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee239() {
        return _regeneratorRuntime.wrap(function _callee239$(_context239) {
          while (1) {
            switch (_context239.prev = _context239.next) {
              case 0:
                return _context239.abrupt("return", _super("call").call(this, "messages.getByConversationMessageId", params));

              case 1:
              case "end":
                return _context239.stop();
            }
          }
        }, _callee239, this);
      }));
    }
    /**
     * Returns a list of the current user's private messages that match search criteria.
     *
     * @param {{
     *   q: (string|undefined),
     *   peer_id: (number|undefined),
     *   date: (number|undefined),
     *   preview_length: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   fields: (string[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesSearchResponse>}
     */

  }, {
    key: "messagesSearch",
    value: function messagesSearch(params) {
      var _this240 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this240);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee240() {
        return _regeneratorRuntime.wrap(function _callee240$(_context240) {
          while (1) {
            switch (_context240.prev = _context240.next) {
              case 0:
                return _context240.abrupt("return", _super("call").call(this, "messages.search", params));

              case 1:
              case "end":
                return _context240.stop();
            }
          }
        }, _callee240, this);
      }));
    }
    /**
     * Returns message history for the specified user or group chat.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   user_id: (number|undefined),
     *   peer_id: (number|undefined),
     *   start_message_id: (number|undefined),
     *   rev: (number|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetHistoryResponse>}
     */

  }, {
    key: "messagesGetHistory",
    value: function messagesGetHistory(params) {
      var _this241 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this241);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee241() {
        return _regeneratorRuntime.wrap(function _callee241$(_context241) {
          while (1) {
            switch (_context241.prev = _context241.next) {
              case 0:
                return _context241.abrupt("return", _super("call").call(this, "messages.getHistory", params));

              case 1:
              case "end":
                return _context241.stop();
            }
          }
        }, _callee241, this);
      }));
    }
    /**
     * Returns media files from the dialog or group chat.
     *
     * @param {{
     *   peer_id: (number),
     *   media_type: (string|undefined),
     *   start_from: (string|undefined),
     *   count: (number|undefined),
     *   photo_sizes: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetHistoryAttachmentsResponse>}
     */

  }, {
    key: "messagesGetHistoryAttachments",
    value: function messagesGetHistoryAttachments(params) {
      var _this242 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this242);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee242() {
        return _regeneratorRuntime.wrap(function _callee242$(_context242) {
          while (1) {
            switch (_context242.prev = _context242.next) {
              case 0:
                return _context242.abrupt("return", _super("call").call(this, "messages.getHistoryAttachments", params));

              case 1:
              case "end":
                return _context242.stop();
            }
          }
        }, _callee242, this);
      }));
    }
    /**
     * Sends a message.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   random_id: (number|undefined),
     *   peer_id: (number|undefined),
     *   domain: (string|undefined),
     *   chat_id: (number|undefined),
     *   user_ids: (number[]|undefined),
     *   message: (string|undefined),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   attachment: (string|undefined),
     *   reply_to: (number|undefined),
     *   forward_messages: (string|undefined),
     *   sticker_id: (number|undefined),
     *   group_id: (number|undefined),
     *   keyboard: (string|undefined),
     *   payload: (string|undefined),
     *   dont_parse_links: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesSendResponse>}
     */

  }, {
    key: "messagesSend",
    value: function messagesSend(params) {
      var _this243 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this243);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee243() {
        return _regeneratorRuntime.wrap(function _callee243$(_context243) {
          while (1) {
            switch (_context243.prev = _context243.next) {
              case 0:
                return _context243.abrupt("return", _super("call").call(this, "messages.send", params));

              case 1:
              case "end":
                return _context243.stop();
            }
          }
        }, _callee243, this);
      }));
    }
    /**
     * Edits the message.
     *
     * @param {{
     *   peer_id: (number),
     *   message: (string|undefined),
     *   message_id: (number),
     *   lat: (number|undefined),
     *   long: (number|undefined),
     *   attachment: (string|undefined),
     *   keep_forward_messages: (boolean|undefined),
     *   keep_snippets: (boolean|undefined),
     *   group_id: (number|undefined),
     *   dont_parse_links: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesEditResponse>}
     */

  }, {
    key: "messagesEdit",
    value: function messagesEdit(params) {
      var _this244 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this244);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee244() {
        return _regeneratorRuntime.wrap(function _callee244$(_context244) {
          while (1) {
            switch (_context244.prev = _context244.next) {
              case 0:
                return _context244.abrupt("return", _super("call").call(this, "messages.edit", params));

              case 1:
              case "end":
                return _context244.stop();
            }
          }
        }, _callee244, this);
      }));
    }
    /**
     * Deletes one or more messages.
     *
     * @param {{
     *   message_ids: (number[]|undefined),
     *   spam: (boolean|undefined),
     *   group_id: (number|undefined),
     *   delete_for_all: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesDeleteResponse>}
     */

  }, {
    key: "messagesDelete",
    value: function messagesDelete(params) {
      var _this245 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this245);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee245() {
        return _regeneratorRuntime.wrap(function _callee245$(_context245) {
          while (1) {
            switch (_context245.prev = _context245.next) {
              case 0:
                return _context245.abrupt("return", _super("call").call(this, "messages.delete", params));

              case 1:
              case "end":
                return _context245.stop();
            }
          }
        }, _callee245, this);
      }));
    }
    /**
     * Deletes all private messages in a conversation.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   peer_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesDeleteConversationResponse>}
     */

  }, {
    key: "messagesDeleteConversation",
    value: function messagesDeleteConversation(params) {
      var _this246 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this246);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee246() {
        return _regeneratorRuntime.wrap(function _callee246$(_context246) {
          while (1) {
            switch (_context246.prev = _context246.next) {
              case 0:
                return _context246.abrupt("return", _super("call").call(this, "messages.deleteConversation", params));

              case 1:
              case "end":
                return _context246.stop();
            }
          }
        }, _callee246, this);
      }));
    }
    /**
     * Pin a message.
     *
     * @param {{
     *   peer_id: (number),
     *   message_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesPinResponse>}
     */

  }, {
    key: "messagesPin",
    value: function messagesPin(params) {
      var _this247 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this247);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee247() {
        return _regeneratorRuntime.wrap(function _callee247$(_context247) {
          while (1) {
            switch (_context247.prev = _context247.next) {
              case 0:
                return _context247.abrupt("return", _super("call").call(this, "messages.pin", params));

              case 1:
              case "end":
                return _context247.stop();
            }
          }
        }, _callee247, this);
      }));
    }
    /**
     * Restores a deleted message.
     *
     * @param {{
     *   message_id: (number),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesRestore",
    value: function messagesRestore(params) {
      var _this248 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this248);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee248() {
        return _regeneratorRuntime.wrap(function _callee248$(_context248) {
          while (1) {
            switch (_context248.prev = _context248.next) {
              case 0:
                return _context248.abrupt("return", _super("call").call(this, "messages.restore", params));

              case 1:
              case "end":
                return _context248.stop();
            }
          }
        }, _callee248, this);
      }));
    }
    /**
     * Marks messages as read.
     *
     * @param {{
     *   peer_id: (number|undefined),
     *   start_message_id: (number|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesMarkAsRead",
    value: function messagesMarkAsRead(params) {
      var _this249 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this249);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee249() {
        return _regeneratorRuntime.wrap(function _callee249$(_context249) {
          while (1) {
            switch (_context249.prev = _context249.next) {
              case 0:
                return _context249.abrupt("return", _super("call").call(this, "messages.markAsRead", params));

              case 1:
              case "end":
                return _context249.stop();
            }
          }
        }, _callee249, this);
      }));
    }
    /**
     * Marks and unmarks messages as important (starred).
     *
     * @param {{
     *   message_ids: (number[]|undefined),
     *   important: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesMarkAsImportantResponse>}
     */

  }, {
    key: "messagesMarkAsImportant",
    value: function messagesMarkAsImportant(params) {
      var _this250 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this250);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee250() {
        return _regeneratorRuntime.wrap(function _callee250$(_context250) {
          while (1) {
            switch (_context250.prev = _context250.next) {
              case 0:
                return _context250.abrupt("return", _super("call").call(this, "messages.markAsImportant", params));

              case 1:
              case "end":
                return _context250.stop();
            }
          }
        }, _callee250, this);
      }));
    }
    /**
     * Marks and unmarks conversations as important.
     *
     * @param {{
     *   peer_id: (number),
     *   important: (boolean|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesMarkAsImportantConversation",
    value: function messagesMarkAsImportantConversation(params) {
      var _this251 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this251);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee251() {
        return _regeneratorRuntime.wrap(function _callee251$(_context251) {
          while (1) {
            switch (_context251.prev = _context251.next) {
              case 0:
                return _context251.abrupt("return", _super("call").call(this, "messages.markAsImportantConversation", params));

              case 1:
              case "end":
                return _context251.stop();
            }
          }
        }, _callee251, this);
      }));
    }
    /**
     * Marks and unmarks conversations as unanswered.
     *
     * @param {{
     *   peer_id: (number),
     *   answered: (boolean|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesMarkAsAnsweredConversation",
    value: function messagesMarkAsAnsweredConversation(params) {
      var _this252 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this252);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee252() {
        return _regeneratorRuntime.wrap(function _callee252$(_context252) {
          while (1) {
            switch (_context252.prev = _context252.next) {
              case 0:
                return _context252.abrupt("return", _super("call").call(this, "messages.markAsAnsweredConversation", params));

              case 1:
              case "end":
                return _context252.stop();
            }
          }
        }, _callee252, this);
      }));
    }
    /**
     * Returns data required for connection to a Long Poll server.
     *
     * @param {{
     *   need_pts: (boolean|undefined),
     *   group_id: (number|undefined),
     *   lp_version: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetLongPollServerResponse>}
     */

  }, {
    key: "messagesGetLongPollServer",
    value: function messagesGetLongPollServer(params) {
      var _this253 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this253);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee253() {
        return _regeneratorRuntime.wrap(function _callee253$(_context253) {
          while (1) {
            switch (_context253.prev = _context253.next) {
              case 0:
                return _context253.abrupt("return", _super("call").call(this, "messages.getLongPollServer", params));

              case 1:
              case "end":
                return _context253.stop();
            }
          }
        }, _callee253, this);
      }));
    }
    /**
     * Returns updates in user's private messages.
     *
     * @param {{
     *   ts: (number|undefined),
     *   pts: (number|undefined),
     *   preview_length: (number|undefined),
     *   onlines: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   events_limit: (number|undefined),
     *   msgs_limit: (number|undefined),
     *   max_msg_id: (number|undefined),
     *   group_id: (number|undefined),
     *   lp_version: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetLongPollHistoryResponse>}
     */

  }, {
    key: "messagesGetLongPollHistory",
    value: function messagesGetLongPollHistory(params) {
      var _this254 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this254);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee254() {
        return _regeneratorRuntime.wrap(function _callee254$(_context254) {
          while (1) {
            switch (_context254.prev = _context254.next) {
              case 0:
                return _context254.abrupt("return", _super("call").call(this, "messages.getLongPollHistory", params));

              case 1:
              case "end":
                return _context254.stop();
            }
          }
        }, _callee254, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   link: (string),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetChatPreviewResponse>}
     */

  }, {
    key: "messagesGetChatPreview",
    value: function messagesGetChatPreview(params) {
      var _this255 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this255);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee255() {
        return _regeneratorRuntime.wrap(function _callee255$(_context255) {
          while (1) {
            switch (_context255.prev = _context255.next) {
              case 0:
                return _context255.abrupt("return", _super("call").call(this, "messages.getChatPreview", params));

              case 1:
              case "end":
                return _context255.stop();
            }
          }
        }, _callee255, this);
      }));
    }
    /**
     * Creates a chat with several participants.
     *
     * @param {{
     *   user_ids: (number[]|undefined),
     *   title: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesCreateChatResponse>}
     */

  }, {
    key: "messagesCreateChat",
    value: function messagesCreateChat(params) {
      var _this256 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this256);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee256() {
        return _regeneratorRuntime.wrap(function _callee256$(_context256) {
          while (1) {
            switch (_context256.prev = _context256.next) {
              case 0:
                return _context256.abrupt("return", _super("call").call(this, "messages.createChat", params));

              case 1:
              case "end":
                return _context256.stop();
            }
          }
        }, _callee256, this);
      }));
    }
    /**
     * Edits the title of a chat.
     *
     * @param {{
     *   chat_id: (number),
     *   title: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesEditChat",
    value: function messagesEditChat(params) {
      var _this257 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this257);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee257() {
        return _regeneratorRuntime.wrap(function _callee257$(_context257) {
          while (1) {
            switch (_context257.prev = _context257.next) {
              case 0:
                return _context257.abrupt("return", _super("call").call(this, "messages.editChat", params));

              case 1:
              case "end":
                return _context257.stop();
            }
          }
        }, _callee257, this);
      }));
    }
    /**
     * Returns a list of IDs of users participating in a chat.
     *
     * @param {{
     *   peer_id: (number),
     *   fields: (Models.UsersFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetConversationMembersResponse>}
     */

  }, {
    key: "messagesGetConversationMembers",
    value: function messagesGetConversationMembers(params) {
      var _this258 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this258);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee258() {
        return _regeneratorRuntime.wrap(function _callee258$(_context258) {
          while (1) {
            switch (_context258.prev = _context258.next) {
              case 0:
                return _context258.abrupt("return", _super("call").call(this, "messages.getConversationMembers", params));

              case 1:
              case "end":
                return _context258.stop();
            }
          }
        }, _callee258, this);
      }));
    }
    /**
     * Changes the status of a user as typing in a conversation.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   type: (string|undefined),
     *   peer_id: (number|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesSetActivity",
    value: function messagesSetActivity(params) {
      var _this259 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this259);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee259() {
        return _regeneratorRuntime.wrap(function _callee259$(_context259) {
          while (1) {
            switch (_context259.prev = _context259.next) {
              case 0:
                return _context259.abrupt("return", _super("call").call(this, "messages.setActivity", params));

              case 1:
              case "end":
                return _context259.stop();
            }
          }
        }, _callee259, this);
      }));
    }
    /**
     * Returns a list of the current user's conversations that match search criteria.
     *
     * @param {{
     *   q: (string|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesSearchConversationsResponse>}
     */

  }, {
    key: "messagesSearchConversations",
    value: function messagesSearchConversations(params) {
      var _this260 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this260);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee260() {
        return _regeneratorRuntime.wrap(function _callee260$(_context260) {
          while (1) {
            switch (_context260.prev = _context260.next) {
              case 0:
                return _context260.abrupt("return", _super("call").call(this, "messages.searchConversations", params));

              case 1:
              case "end":
                return _context260.stop();
            }
          }
        }, _callee260, this);
      }));
    }
    /**
     * Adds a new user to a chat.
     *
     * @param {{
     *   chat_id: (number),
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesAddChatUser",
    value: function messagesAddChatUser(params) {
      var _this261 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this261);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee261() {
        return _regeneratorRuntime.wrap(function _callee261$(_context261) {
          while (1) {
            switch (_context261.prev = _context261.next) {
              case 0:
                return _context261.abrupt("return", _super("call").call(this, "messages.addChatUser", params));

              case 1:
              case "end":
                return _context261.stop();
            }
          }
        }, _callee261, this);
      }));
    }
    /**
     * Allows the current user to leave a chat or, if the current user started the chat, allows the user to remove another user from the chat.
     *
     * @param {{
     *   chat_id: (number),
     *   user_id: (number|undefined),
     *   member_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesRemoveChatUser",
    value: function messagesRemoveChatUser(params) {
      var _this262 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this262);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee262() {
        return _regeneratorRuntime.wrap(function _callee262$(_context262) {
          while (1) {
            switch (_context262.prev = _context262.next) {
              case 0:
                return _context262.abrupt("return", _super("call").call(this, "messages.removeChatUser", params));

              case 1:
              case "end":
                return _context262.stop();
            }
          }
        }, _callee262, this);
      }));
    }
    /**
     * Returns a user's current status and date of last activity.
     *
     * @param {{
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesGetLastActivityResponse>}
     */

  }, {
    key: "messagesGetLastActivity",
    value: function messagesGetLastActivity(params) {
      var _this263 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this263);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee263() {
        return _regeneratorRuntime.wrap(function _callee263$(_context263) {
          while (1) {
            switch (_context263.prev = _context263.next) {
              case 0:
                return _context263.abrupt("return", _super("call").call(this, "messages.getLastActivity", params));

              case 1:
              case "end":
                return _context263.stop();
            }
          }
        }, _callee263, this);
      }));
    }
    /**
     * Sets a previously-uploaded picture as the cover picture of a chat.
     *
     * @param {{
     *   file: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesSetChatPhotoResponse>}
     */

  }, {
    key: "messagesSetChatPhoto",
    value: function messagesSetChatPhoto(params) {
      var _this264 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this264);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee264() {
        return _regeneratorRuntime.wrap(function _callee264$(_context264) {
          while (1) {
            switch (_context264.prev = _context264.next) {
              case 0:
                return _context264.abrupt("return", _super("call").call(this, "messages.setChatPhoto", params));

              case 1:
              case "end":
                return _context264.stop();
            }
          }
        }, _callee264, this);
      }));
    }
    /**
     * Deletes a chat's cover picture.
     *
     * @param {{
     *   chat_id: (number),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesDeleteChatPhotoResponse>}
     */

  }, {
    key: "messagesDeleteChatPhoto",
    value: function messagesDeleteChatPhoto(params) {
      var _this265 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this265);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee265() {
        return _regeneratorRuntime.wrap(function _callee265$(_context265) {
          while (1) {
            switch (_context265.prev = _context265.next) {
              case 0:
                return _context265.abrupt("return", _super("call").call(this, "messages.deleteChatPhoto", params));

              case 1:
              case "end":
                return _context265.stop();
            }
          }
        }, _callee265, this);
      }));
    }
    /**
     * Denies sending message from community to the current user.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesDenyMessagesFromGroup",
    value: function messagesDenyMessagesFromGroup(params) {
      var _this266 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this266);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee266() {
        return _regeneratorRuntime.wrap(function _callee266$(_context266) {
          while (1) {
            switch (_context266.prev = _context266.next) {
              case 0:
                return _context266.abrupt("return", _super("call").call(this, "messages.denyMessagesFromGroup", params));

              case 1:
              case "end":
                return _context266.stop();
            }
          }
        }, _callee266, this);
      }));
    }
    /**
     * Allows sending messages from community to the current user.
     *
     * @param {{
     *   group_id: (number),
     *   key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesAllowMessagesFromGroup",
    value: function messagesAllowMessagesFromGroup(params) {
      var _this267 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this267);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee267() {
        return _regeneratorRuntime.wrap(function _callee267$(_context267) {
          while (1) {
            switch (_context267.prev = _context267.next) {
              case 0:
                return _context267.abrupt("return", _super("call").call(this, "messages.allowMessagesFromGroup", params));

              case 1:
              case "end":
                return _context267.stop();
            }
          }
        }, _callee267, this);
      }));
    }
    /**
     * Returns information whether sending messages from the community to current user is allowed.
     *
     * @param {{
     *   group_id: (number),
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MessagesIsMessagesFromGroupAllowedResponse>}
     */

  }, {
    key: "messagesIsMessagesFromGroupAllowed",
    value: function messagesIsMessagesFromGroupAllowed(params) {
      var _this268 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this268);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee268() {
        return _regeneratorRuntime.wrap(function _callee268$(_context268) {
          while (1) {
            switch (_context268.prev = _context268.next) {
              case 0:
                return _context268.abrupt("return", _super("call").call(this, "messages.isMessagesFromGroupAllowed", params));

              case 1:
              case "end":
                return _context268.stop();
            }
          }
        }, _callee268, this);
      }));
    }
    /**
     * Returns data required to show newsfeed for the current user.
     *
     * @param {{
     *   filters: (Models.NewsfeedFilters[]|undefined),
     *   return_banned: (boolean|undefined),
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   max_photos: (number|undefined),
     *   source_ids: (string|undefined),
     *   start_from: (string|undefined),
     *   count: (number|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   section: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetResponse>}
     */

  }, {
    key: "newsfeedGet",
    value: function newsfeedGet(params) {
      var _this269 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this269);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee269() {
        return _regeneratorRuntime.wrap(function _callee269$(_context269) {
          while (1) {
            switch (_context269.prev = _context269.next) {
              case 0:
                return _context269.abrupt("return", _super("call").call(this, "newsfeed.get", params));

              case 1:
              case "end":
                return _context269.stop();
            }
          }
        }, _callee269, this);
      }));
    }
    /**
     * , Returns a list of newsfeeds recommended to the current user.
     *
     * @param {{
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   max_photos: (number|undefined),
     *   start_from: (string|undefined),
     *   count: (number|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetRecommendedResponse>}
     */

  }, {
    key: "newsfeedGetRecommended",
    value: function newsfeedGetRecommended(params) {
      var _this270 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this270);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee270() {
        return _regeneratorRuntime.wrap(function _callee270$(_context270) {
          while (1) {
            switch (_context270.prev = _context270.next) {
              case 0:
                return _context270.abrupt("return", _super("call").call(this, "newsfeed.getRecommended", params));

              case 1:
              case "end":
                return _context270.stop();
            }
          }
        }, _callee270, this);
      }));
    }
    /**
     * Returns a list of comments in the current user's newsfeed.
     *
     * @param {{
     *   count: (number|undefined),
     *   filters: (Models.NewsfeedCommentsFilters[]|undefined),
     *   reposts: (string|undefined),
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   last_comments_count: (number|undefined),
     *   start_from: (string|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetCommentsResponse>}
     */

  }, {
    key: "newsfeedGetComments",
    value: function newsfeedGetComments(params) {
      var _this271 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this271);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee271() {
        return _regeneratorRuntime.wrap(function _callee271$(_context271) {
          while (1) {
            switch (_context271.prev = _context271.next) {
              case 0:
                return _context271.abrupt("return", _super("call").call(this, "newsfeed.getComments", params));

              case 1:
              case "end":
                return _context271.stop();
            }
          }
        }, _callee271, this);
      }));
    }
    /**
     * Returns a list of posts on user walls in which the current user is mentioned.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetMentionsResponse>}
     */

  }, {
    key: "newsfeedGetMentions",
    value: function newsfeedGetMentions(params) {
      var _this272 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this272);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee272() {
        return _regeneratorRuntime.wrap(function _callee272$(_context272) {
          while (1) {
            switch (_context272.prev = _context272.next) {
              case 0:
                return _context272.abrupt("return", _super("call").call(this, "newsfeed.getMentions", params));

              case 1:
              case "end":
                return _context272.stop();
            }
          }
        }, _callee272, this);
      }));
    }
    /**
     * Returns a list of users and communities banned from the current user's newsfeed.
     *
     * @param {{
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetBannedResponse>}
     */

  }, {
    key: "newsfeedGetBanned",
    value: function newsfeedGetBanned(params) {
      var _this273 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this273);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee273() {
        return _regeneratorRuntime.wrap(function _callee273$(_context273) {
          while (1) {
            switch (_context273.prev = _context273.next) {
              case 0:
                return _context273.abrupt("return", _super("call").call(this, "newsfeed.getBanned", params));

              case 1:
              case "end":
                return _context273.stop();
            }
          }
        }, _callee273, this);
      }));
    }
    /**
     * Prevents news from specified users and communities from appearing in the current user's newsfeed.
     *
     * @param {{
     *   user_ids: (number[]|undefined),
     *   group_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "newsfeedAddBan",
    value: function newsfeedAddBan(params) {
      var _this274 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this274);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee274() {
        return _regeneratorRuntime.wrap(function _callee274$(_context274) {
          while (1) {
            switch (_context274.prev = _context274.next) {
              case 0:
                return _context274.abrupt("return", _super("call").call(this, "newsfeed.addBan", params));

              case 1:
              case "end":
                return _context274.stop();
            }
          }
        }, _callee274, this);
      }));
    }
    /**
     * Allows news from previously banned users and communities to be shown in the current user's newsfeed.
     *
     * @param {{
     *   user_ids: (number[]|undefined),
     *   group_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "newsfeedDeleteBan",
    value: function newsfeedDeleteBan(params) {
      var _this275 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this275);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee275() {
        return _regeneratorRuntime.wrap(function _callee275$(_context275) {
          while (1) {
            switch (_context275.prev = _context275.next) {
              case 0:
                return _context275.abrupt("return", _super("call").call(this, "newsfeed.deleteBan", params));

              case 1:
              case "end":
                return _context275.stop();
            }
          }
        }, _callee275, this);
      }));
    }
    /**
     * Hides an item from the newsfeed.
     *
     * @param {{
     *   type: (string),
     *   owner_id: (number),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "newsfeedIgnoreItem",
    value: function newsfeedIgnoreItem(params) {
      var _this276 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this276);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee276() {
        return _regeneratorRuntime.wrap(function _callee276$(_context276) {
          while (1) {
            switch (_context276.prev = _context276.next) {
              case 0:
                return _context276.abrupt("return", _super("call").call(this, "newsfeed.ignoreItem", params));

              case 1:
              case "end":
                return _context276.stop();
            }
          }
        }, _callee276, this);
      }));
    }
    /**
     * Returns a hidden item to the newsfeed.
     *
     * @param {{
     *   type: (string),
     *   owner_id: (number),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "newsfeedUnignoreItem",
    value: function newsfeedUnignoreItem(params) {
      var _this277 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this277);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee277() {
        return _regeneratorRuntime.wrap(function _callee277$(_context277) {
          while (1) {
            switch (_context277.prev = _context277.next) {
              case 0:
                return _context277.abrupt("return", _super("call").call(this, "newsfeed.unignoreItem", params));

              case 1:
              case "end":
                return _context277.stop();
            }
          }
        }, _callee277, this);
      }));
    }
    /**
     * Returns search results by statuses.
     *
     * @param {{
     *   q: (string|undefined),
     *   extended: (boolean|undefined),
     *   count: (number|undefined),
     *   latitude: (number|undefined),
     *   longitude: (number|undefined),
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   start_from: (string|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedSearchResponse>}
     */

  }, {
    key: "newsfeedSearch",
    value: function newsfeedSearch(params) {
      var _this278 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this278);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee278() {
        return _regeneratorRuntime.wrap(function _callee278$(_context278) {
          while (1) {
            switch (_context278.prev = _context278.next) {
              case 0:
                return _context278.abrupt("return", _super("call").call(this, "newsfeed.search", params));

              case 1:
              case "end":
                return _context278.stop();
            }
          }
        }, _callee278, this);
      }));
    }
    /**
     * Returns a list of newsfeeds followed by the current user.
     *
     * @param {{
     *   list_ids: (number[]|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetListsResponse>}
     */

  }, {
    key: "newsfeedGetLists",
    value: function newsfeedGetLists(params) {
      var _this279 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this279);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee279() {
        return _regeneratorRuntime.wrap(function _callee279$(_context279) {
          while (1) {
            switch (_context279.prev = _context279.next) {
              case 0:
                return _context279.abrupt("return", _super("call").call(this, "newsfeed.getLists", params));

              case 1:
              case "end":
                return _context279.stop();
            }
          }
        }, _callee279, this);
      }));
    }
    /**
     * Creates and edits user newsfeed lists
     *
     * @param {{
     *   list_id: (number|undefined),
     *   title: (string),
     *   source_ids: (number[]|undefined),
     *   no_reposts: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedSaveListResponse>}
     */

  }, {
    key: "newsfeedSaveList",
    value: function newsfeedSaveList(params) {
      var _this280 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this280);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee280() {
        return _regeneratorRuntime.wrap(function _callee280$(_context280) {
          while (1) {
            switch (_context280.prev = _context280.next) {
              case 0:
                return _context280.abrupt("return", _super("call").call(this, "newsfeed.saveList", params));

              case 1:
              case "end":
                return _context280.stop();
            }
          }
        }, _callee280, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   list_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "newsfeedDeleteList",
    value: function newsfeedDeleteList(params) {
      var _this281 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this281);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee281() {
        return _regeneratorRuntime.wrap(function _callee281$(_context281) {
          while (1) {
            switch (_context281.prev = _context281.next) {
              case 0:
                return _context281.abrupt("return", _super("call").call(this, "newsfeed.deleteList", params));

              case 1:
              case "end":
                return _context281.stop();
            }
          }
        }, _callee281, this);
      }));
    }
    /**
     * Unsubscribes the current user from specified newsfeeds.
     *
     * @param {{
     *   type: (string),
     *   owner_id: (number|undefined),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "newsfeedUnsubscribe",
    value: function newsfeedUnsubscribe(params) {
      var _this282 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this282);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee282() {
        return _regeneratorRuntime.wrap(function _callee282$(_context282) {
          while (1) {
            switch (_context282.prev = _context282.next) {
              case 0:
                return _context282.abrupt("return", _super("call").call(this, "newsfeed.unsubscribe", params));

              case 1:
              case "end":
                return _context282.stop();
            }
          }
        }, _callee282, this);
      }));
    }
    /**
     * Returns communities and users that current user is suggested to follow.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   shuffle: (boolean|undefined),
     *   fields: (Models.BaseUserGroupFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NewsfeedGetSuggestedSourcesResponse>}
     */

  }, {
    key: "newsfeedGetSuggestedSources",
    value: function newsfeedGetSuggestedSources(params) {
      var _this283 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this283);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee283() {
        return _regeneratorRuntime.wrap(function _callee283$(_context283) {
          while (1) {
            switch (_context283.prev = _context283.next) {
              case 0:
                return _context283.abrupt("return", _super("call").call(this, "newsfeed.getSuggestedSources", params));

              case 1:
              case "end":
                return _context283.stop();
            }
          }
        }, _callee283, this);
      }));
    }
    /**
     * Returns a list of IDs of users who added the specified object to their 'Likes' list.
     *
     * @param {{
     *   type: (string),
     *   owner_id: (number|undefined),
     *   item_id: (number|undefined),
     *   page_url: (string|undefined),
     *   filter: (string|undefined),
     *   friends_only: (number|undefined),
     *   extended: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   skip_own: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LikesGetListResponse>}
     */

  }, {
    key: "likesGetList",
    value: function likesGetList(params) {
      var _this284 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this284);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee284() {
        return _regeneratorRuntime.wrap(function _callee284$(_context284) {
          while (1) {
            switch (_context284.prev = _context284.next) {
              case 0:
                return _context284.abrupt("return", _super("call").call(this, "likes.getList", params));

              case 1:
              case "end":
                return _context284.stop();
            }
          }
        }, _callee284, this);
      }));
    }
    /**
     * Adds the specified object to the 'Likes' list of the current user.
     *
     * @param {{
     *   type: (string),
     *   owner_id: (number|undefined),
     *   item_id: (number),
     *   access_key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LikesAddResponse>}
     */

  }, {
    key: "likesAdd",
    value: function likesAdd(params) {
      var _this285 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this285);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee285() {
        return _regeneratorRuntime.wrap(function _callee285$(_context285) {
          while (1) {
            switch (_context285.prev = _context285.next) {
              case 0:
                return _context285.abrupt("return", _super("call").call(this, "likes.add", params));

              case 1:
              case "end":
                return _context285.stop();
            }
          }
        }, _callee285, this);
      }));
    }
    /**
     * Deletes the specified object from the 'Likes' list of the current user.
     *
     * @param {{
     *   type: (string),
     *   owner_id: (number|undefined),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LikesDeleteResponse>}
     */

  }, {
    key: "likesDelete",
    value: function likesDelete(params) {
      var _this286 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this286);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee286() {
        return _regeneratorRuntime.wrap(function _callee286$(_context286) {
          while (1) {
            switch (_context286.prev = _context286.next) {
              case 0:
                return _context286.abrupt("return", _super("call").call(this, "likes.delete", params));

              case 1:
              case "end":
                return _context286.stop();
            }
          }
        }, _callee286, this);
      }));
    }
    /**
     * Checks for the object in the 'Likes' list of the specified user.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   type: (string),
     *   owner_id: (number|undefined),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.LikesIsLikedResponse>}
     */

  }, {
    key: "likesIsLiked",
    value: function likesIsLiked(params) {
      var _this287 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this287);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee287() {
        return _regeneratorRuntime.wrap(function _callee287$(_context287) {
          while (1) {
            switch (_context287.prev = _context287.next) {
              case 0:
                return _context287.abrupt("return", _super("call").call(this, "likes.isLiked", params));

              case 1:
              case "end":
                return _context287.stop();
            }
          }
        }, _callee287, this);
      }));
    }
    /**
     * Returns detailed information about a poll by its ID.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   is_board: (boolean|undefined),
     *   poll_id: (number),
     *   extended: (boolean|undefined),
     *   friends_count: (number|undefined),
     *   fields: (string[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PollsGetByIdResponse>}
     */

  }, {
    key: "pollsGetById",
    value: function pollsGetById(params) {
      var _this288 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this288);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee288() {
        return _regeneratorRuntime.wrap(function _callee288$(_context288) {
          while (1) {
            switch (_context288.prev = _context288.next) {
              case 0:
                return _context288.abrupt("return", _super("call").call(this, "polls.getById", params));

              case 1:
              case "end":
                return _context288.stop();
            }
          }
        }, _callee288, this);
      }));
    }
    /**
     * Adds the current user's vote to the selected answer in the poll.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   poll_id: (number),
     *   answer_ids: (number[]),
     *   is_board: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PollsAddVoteResponse>}
     */

  }, {
    key: "pollsAddVote",
    value: function pollsAddVote(params) {
      var _this289 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this289);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee289() {
        return _regeneratorRuntime.wrap(function _callee289$(_context289) {
          while (1) {
            switch (_context289.prev = _context289.next) {
              case 0:
                return _context289.abrupt("return", _super("call").call(this, "polls.addVote", params));

              case 1:
              case "end":
                return _context289.stop();
            }
          }
        }, _callee289, this);
      }));
    }
    /**
     * Deletes the current user's vote from the selected answer in the poll.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   poll_id: (number),
     *   answer_id: (number),
     *   is_board: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PollsDeleteVoteResponse>}
     */

  }, {
    key: "pollsDeleteVote",
    value: function pollsDeleteVote(params) {
      var _this290 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this290);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee290() {
        return _regeneratorRuntime.wrap(function _callee290$(_context290) {
          while (1) {
            switch (_context290.prev = _context290.next) {
              case 0:
                return _context290.abrupt("return", _super("call").call(this, "polls.deleteVote", params));

              case 1:
              case "end":
                return _context290.stop();
            }
          }
        }, _callee290, this);
      }));
    }
    /**
     * Returns a list of IDs of users who selected specific answers in the poll.
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   poll_id: (number),
     *   answer_ids: (number[]),
     *   is_board: (boolean|undefined),
     *   friends_only: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PollsGetVotersResponse>}
     */

  }, {
    key: "pollsGetVoters",
    value: function pollsGetVoters(params) {
      var _this291 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this291);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee291() {
        return _regeneratorRuntime.wrap(function _callee291$(_context291) {
          while (1) {
            switch (_context291.prev = _context291.next) {
              case 0:
                return _context291.abrupt("return", _super("call").call(this, "polls.getVoters", params));

              case 1:
              case "end":
                return _context291.stop();
            }
          }
        }, _callee291, this);
      }));
    }
    /**
     * Creates polls that can be attached to the users' or communities' posts.
     *
     * @param {{
     *   question: (string|undefined),
     *   is_anonymous: (boolean|undefined),
     *   is_multiple: (boolean|undefined),
     *   end_date: (number|undefined),
     *   owner_id: (number|undefined),
     *   add_answers: (string|undefined),
     *   photo_id: (number|undefined),
     *   background_id: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.PollsCreateResponse>}
     */

  }, {
    key: "pollsCreate",
    value: function pollsCreate(params) {
      var _this292 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this292);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee292() {
        return _regeneratorRuntime.wrap(function _callee292$(_context292) {
          while (1) {
            switch (_context292.prev = _context292.next) {
              case 0:
                return _context292.abrupt("return", _super("call").call(this, "polls.create", params));

              case 1:
              case "end":
                return _context292.stop();
            }
          }
        }, _callee292, this);
      }));
    }
    /**
     * Edits created polls
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   poll_id: (number),
     *   question: (string|undefined),
     *   add_answers: (string|undefined),
     *   edit_answers: (string|undefined),
     *   delete_answers: (string|undefined),
     *   end_date: (number|undefined),
     *   photo_id: (number|undefined),
     *   background_id: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "pollsEdit",
    value: function pollsEdit(params) {
      var _this293 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this293);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee293() {
        return _regeneratorRuntime.wrap(function _callee293$(_context293) {
          while (1) {
            switch (_context293.prev = _context293.next) {
              case 0:
                return _context293.abrupt("return", _super("call").call(this, "polls.edit", params));

              case 1:
              case "end":
                return _context293.stop();
            }
          }
        }, _callee293, this);
      }));
    }
    /**
     * Returns detailed information about user or community documents.
     *
     * @param {{
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   type: (number|undefined),
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsGetResponse>}
     */

  }, {
    key: "docsGet",
    value: function docsGet(params) {
      var _this294 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this294);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee294() {
        return _regeneratorRuntime.wrap(function _callee294$(_context294) {
          while (1) {
            switch (_context294.prev = _context294.next) {
              case 0:
                return _context294.abrupt("return", _super("call").call(this, "docs.get", params));

              case 1:
              case "end":
                return _context294.stop();
            }
          }
        }, _callee294, this);
      }));
    }
    /**
     * Returns information about documents by their IDs.
     *
     * @param {{
     *   docs: (string[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsGetByIdResponse>}
     */

  }, {
    key: "docsGetById",
    value: function docsGetById(params) {
      var _this295 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this295);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee295() {
        return _regeneratorRuntime.wrap(function _callee295$(_context295) {
          while (1) {
            switch (_context295.prev = _context295.next) {
              case 0:
                return _context295.abrupt("return", _super("call").call(this, "docs.getById", params));

              case 1:
              case "end":
                return _context295.stop();
            }
          }
        }, _callee295, this);
      }));
    }
    /**
     * Returns the server address for document upload.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsGetUploadServer>}
     */

  }, {
    key: "docsGetUploadServer",
    value: function docsGetUploadServer(params) {
      var _this296 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this296);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee296() {
        return _regeneratorRuntime.wrap(function _callee296$(_context296) {
          while (1) {
            switch (_context296.prev = _context296.next) {
              case 0:
                return _context296.abrupt("return", _super("call").call(this, "docs.getUploadServer", params));

              case 1:
              case "end":
                return _context296.stop();
            }
          }
        }, _callee296, this);
      }));
    }
    /**
     * Returns the server address for document upload onto a user's or community's wall.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BaseGetUploadServerResponse>}
     */

  }, {
    key: "docsGetWallUploadServer",
    value: function docsGetWallUploadServer(params) {
      var _this297 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this297);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee297() {
        return _regeneratorRuntime.wrap(function _callee297$(_context297) {
          while (1) {
            switch (_context297.prev = _context297.next) {
              case 0:
                return _context297.abrupt("return", _super("call").call(this, "docs.getWallUploadServer", params));

              case 1:
              case "end":
                return _context297.stop();
            }
          }
        }, _callee297, this);
      }));
    }
    /**
     * Returns the server address for document upload.
     *
     * @param {{
     *   type: (string|undefined),
     *   peer_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BaseGetUploadServerResponse>}
     */

  }, {
    key: "docsGetMessagesUploadServer",
    value: function docsGetMessagesUploadServer(params) {
      var _this298 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this298);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee298() {
        return _regeneratorRuntime.wrap(function _callee298$(_context298) {
          while (1) {
            switch (_context298.prev = _context298.next) {
              case 0:
                return _context298.abrupt("return", _super("call").call(this, "docs.getMessagesUploadServer", params));

              case 1:
              case "end":
                return _context298.stop();
            }
          }
        }, _callee298, this);
      }));
    }
    /**
     * Saves a document after [vk.com/dev/upload_files_2|uploading it to a server].
     *
     * @param {{
     *   file: (string),
     *   title: (string|undefined),
     *   tags: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsSaveResponse>}
     */

  }, {
    key: "docsSave",
    value: function docsSave(params) {
      var _this299 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this299);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee299() {
        return _regeneratorRuntime.wrap(function _callee299$(_context299) {
          while (1) {
            switch (_context299.prev = _context299.next) {
              case 0:
                return _context299.abrupt("return", _super("call").call(this, "docs.save", params));

              case 1:
              case "end":
                return _context299.stop();
            }
          }
        }, _callee299, this);
      }));
    }
    /**
     * Deletes a user or community document.
     *
     * @param {{
     *   owner_id: (number),
     *   doc_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "docsDelete",
    value: function docsDelete(params) {
      var _this300 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this300);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee300() {
        return _regeneratorRuntime.wrap(function _callee300$(_context300) {
          while (1) {
            switch (_context300.prev = _context300.next) {
              case 0:
                return _context300.abrupt("return", _super("call").call(this, "docs.delete", params));

              case 1:
              case "end":
                return _context300.stop();
            }
          }
        }, _callee300, this);
      }));
    }
    /**
     * Copies a document to a user's or community's document list.
     *
     * @param {{
     *   owner_id: (number),
     *   doc_id: (number),
     *   access_key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsAddResponse>}
     */

  }, {
    key: "docsAdd",
    value: function docsAdd(params) {
      var _this301 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this301);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee301() {
        return _regeneratorRuntime.wrap(function _callee301$(_context301) {
          while (1) {
            switch (_context301.prev = _context301.next) {
              case 0:
                return _context301.abrupt("return", _super("call").call(this, "docs.add", params));

              case 1:
              case "end":
                return _context301.stop();
            }
          }
        }, _callee301, this);
      }));
    }
    /**
     * Returns documents types available for current user.
     *
     * @param {{
     *   owner_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsGetTypesResponse>}
     */

  }, {
    key: "docsGetTypes",
    value: function docsGetTypes(params) {
      var _this302 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this302);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee302() {
        return _regeneratorRuntime.wrap(function _callee302$(_context302) {
          while (1) {
            switch (_context302.prev = _context302.next) {
              case 0:
                return _context302.abrupt("return", _super("call").call(this, "docs.getTypes", params));

              case 1:
              case "end":
                return _context302.stop();
            }
          }
        }, _callee302, this);
      }));
    }
    /**
     * Returns a list of documents matching the search criteria.
     *
     * @param {{
     *   q: (string),
     *   search_own: (boolean|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DocsSearchResponse>}
     */

  }, {
    key: "docsSearch",
    value: function docsSearch(params) {
      var _this303 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this303);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee303() {
        return _regeneratorRuntime.wrap(function _callee303$(_context303) {
          while (1) {
            switch (_context303.prev = _context303.next) {
              case 0:
                return _context303.abrupt("return", _super("call").call(this, "docs.search", params));

              case 1:
              case "end":
                return _context303.stop();
            }
          }
        }, _callee303, this);
      }));
    }
    /**
     * Edits a document.
     *
     * @param {{
     *   owner_id: (number),
     *   doc_id: (number),
     *   title: (string|undefined),
     *   tags: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "docsEdit",
    value: function docsEdit(params) {
      var _this304 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this304);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee304() {
        return _regeneratorRuntime.wrap(function _callee304$(_context304) {
          while (1) {
            switch (_context304.prev = _context304.next) {
              case 0:
                return _context304.abrupt("return", _super("call").call(this, "docs.edit", params));

              case 1:
              case "end":
                return _context304.stop();
            }
          }
        }, _callee304, this);
      }));
    }
    /**
     * Returns a list of users whom the current user has bookmarked.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FaveGetUsersResponse>}
     */

  }, {
    key: "faveGetUsers",
    value: function faveGetUsers(params) {
      var _this305 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this305);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee305() {
        return _regeneratorRuntime.wrap(function _callee305$(_context305) {
          while (1) {
            switch (_context305.prev = _context305.next) {
              case 0:
                return _context305.abrupt("return", _super("call").call(this, "fave.getUsers", params));

              case 1:
              case "end":
                return _context305.stop();
            }
          }
        }, _callee305, this);
      }));
    }
    /**
     * Returns a list of photos that the current user has liked.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FaveGetPhotosResponse>}
     */

  }, {
    key: "faveGetPhotos",
    value: function faveGetPhotos(params) {
      var _this306 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this306);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee306() {
        return _regeneratorRuntime.wrap(function _callee306$(_context306) {
          while (1) {
            switch (_context306.prev = _context306.next) {
              case 0:
                return _context306.abrupt("return", _super("call").call(this, "fave.getPhotos", params));

              case 1:
              case "end":
                return _context306.stop();
            }
          }
        }, _callee306, this);
      }));
    }
    /**
     * Returns a list of wall posts that the current user has liked.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FaveGetPostsResponse>}
     */

  }, {
    key: "faveGetPosts",
    value: function faveGetPosts(params) {
      var _this307 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this307);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee307() {
        return _regeneratorRuntime.wrap(function _callee307$(_context307) {
          while (1) {
            switch (_context307.prev = _context307.next) {
              case 0:
                return _context307.abrupt("return", _super("call").call(this, "fave.getPosts", params));

              case 1:
              case "end":
                return _context307.stop();
            }
          }
        }, _callee307, this);
      }));
    }
    /**
     * Returns a list of videos that the current user has liked.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FaveGetVideosResponse>}
     */

  }, {
    key: "faveGetVideos",
    value: function faveGetVideos(params) {
      var _this308 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this308);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee308() {
        return _regeneratorRuntime.wrap(function _callee308$(_context308) {
          while (1) {
            switch (_context308.prev = _context308.next) {
              case 0:
                return _context308.abrupt("return", _super("call").call(this, "fave.getVideos", params));

              case 1:
              case "end":
                return _context308.stop();
            }
          }
        }, _callee308, this);
      }));
    }
    /**
     * Returns a list of links that the current user has bookmarked.
     *
     * @param {{
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FaveGetLinksResponse>}
     */

  }, {
    key: "faveGetLinks",
    value: function faveGetLinks(params) {
      var _this309 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this309);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee309() {
        return _regeneratorRuntime.wrap(function _callee309$(_context309) {
          while (1) {
            switch (_context309.prev = _context309.next) {
              case 0:
                return _context309.abrupt("return", _super("call").call(this, "fave.getLinks", params));

              case 1:
              case "end":
                return _context309.stop();
            }
          }
        }, _callee309, this);
      }));
    }
    /**
     * Returns market items bookmarked by current user.
     *
     * @param {{
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.FaveGetMarketItemsResponse>}
     */

  }, {
    key: "faveGetMarketItems",
    value: function faveGetMarketItems(params) {
      var _this310 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this310);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee310() {
        return _regeneratorRuntime.wrap(function _callee310$(_context310) {
          while (1) {
            switch (_context310.prev = _context310.next) {
              case 0:
                return _context310.abrupt("return", _super("call").call(this, "fave.getMarketItems", params));

              case 1:
              case "end":
                return _context310.stop();
            }
          }
        }, _callee310, this);
      }));
    }
    /**
     * Adds a profile to user faves.
     *
     * @param {{
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "faveAddUser",
    value: function faveAddUser(params) {
      var _this311 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this311);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee311() {
        return _regeneratorRuntime.wrap(function _callee311$(_context311) {
          while (1) {
            switch (_context311.prev = _context311.next) {
              case 0:
                return _context311.abrupt("return", _super("call").call(this, "fave.addUser", params));

              case 1:
              case "end":
                return _context311.stop();
            }
          }
        }, _callee311, this);
      }));
    }
    /**
     * Removes a profile from user faves.
     *
     * @param {{
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "faveRemoveUser",
    value: function faveRemoveUser(params) {
      var _this312 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this312);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee312() {
        return _regeneratorRuntime.wrap(function _callee312$(_context312) {
          while (1) {
            switch (_context312.prev = _context312.next) {
              case 0:
                return _context312.abrupt("return", _super("call").call(this, "fave.removeUser", params));

              case 1:
              case "end":
                return _context312.stop();
            }
          }
        }, _callee312, this);
      }));
    }
    /**
     * Adds a community to user faves.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "faveAddGroup",
    value: function faveAddGroup(params) {
      var _this313 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this313);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee313() {
        return _regeneratorRuntime.wrap(function _callee313$(_context313) {
          while (1) {
            switch (_context313.prev = _context313.next) {
              case 0:
                return _context313.abrupt("return", _super("call").call(this, "fave.addGroup", params));

              case 1:
              case "end":
                return _context313.stop();
            }
          }
        }, _callee313, this);
      }));
    }
    /**
     * Removes a community from user faves.
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "faveRemoveGroup",
    value: function faveRemoveGroup(params) {
      var _this314 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this314);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee314() {
        return _regeneratorRuntime.wrap(function _callee314$(_context314) {
          while (1) {
            switch (_context314.prev = _context314.next) {
              case 0:
                return _context314.abrupt("return", _super("call").call(this, "fave.removeGroup", params));

              case 1:
              case "end":
                return _context314.stop();
            }
          }
        }, _callee314, this);
      }));
    }
    /**
     * Adds a link to user faves.
     *
     * @param {{
     *   link: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "faveAddLink",
    value: function faveAddLink(params) {
      var _this315 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this315);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee315() {
        return _regeneratorRuntime.wrap(function _callee315$(_context315) {
          while (1) {
            switch (_context315.prev = _context315.next) {
              case 0:
                return _context315.abrupt("return", _super("call").call(this, "fave.addLink", params));

              case 1:
              case "end":
                return _context315.stop();
            }
          }
        }, _callee315, this);
      }));
    }
    /**
     * Removes link from the user's faves.
     *
     * @param {{
     *   link_id: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "faveRemoveLink",
    value: function faveRemoveLink(params) {
      var _this316 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this316);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee316() {
        return _regeneratorRuntime.wrap(function _callee316$(_context316) {
          while (1) {
            switch (_context316.prev = _context316.next) {
              case 0:
                return _context316.abrupt("return", _super("call").call(this, "fave.removeLink", params));

              case 1:
              case "end":
                return _context316.stop();
            }
          }
        }, _callee316, this);
      }));
    }
    /**
     * Returns a list of notifications about other users' feedback to the current user's wall posts.
     *
     * @param {{
     *   count: (number|undefined),
     *   start_from: (string|undefined),
     *   filters: (string[]|undefined),
     *   start_time: (number|undefined),
     *   end_time: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotificationsGetResponse>}
     */

  }, {
    key: "notificationsGet",
    value: function notificationsGet(params) {
      var _this317 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this317);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee317() {
        return _regeneratorRuntime.wrap(function _callee317$(_context317) {
          while (1) {
            switch (_context317.prev = _context317.next) {
              case 0:
                return _context317.abrupt("return", _super("call").call(this, "notifications.get", params));

              case 1:
              case "end":
                return _context317.stop();
            }
          }
        }, _callee317, this);
      }));
    }
    /**
     * Resets the counter of new notifications about other users' feedback to the current user's wall posts.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.NotificationsMarkAsViewedResponse>}
     */

  }, {
    key: "notificationsMarkAsViewed",
    value: function notificationsMarkAsViewed(params) {
      var _this318 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this318);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee318() {
        return _regeneratorRuntime.wrap(function _callee318$(_context318) {
          while (1) {
            switch (_context318.prev = _context318.next) {
              case 0:
                return _context318.abrupt("return", _super("call").call(this, "notifications.markAsViewed", params));

              case 1:
              case "end":
                return _context318.stop();
            }
          }
        }, _callee318, this);
      }));
    }
    /**
     * Returns statistics of a community or an application.
     *
     * @param {{
     *   group_id: (number|undefined),
     *   app_id: (number|undefined),
     *   timestamp_from: (number|undefined),
     *   timestamp_to: (number|undefined),
     *   interval: (string|undefined),
     *   intervals_count: (number|undefined),
     *   filters: (string[]|undefined),
     *   stats_groups: (string[]|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StatsGetResponse>}
     */

  }, {
    key: "statsGet",
    value: function statsGet(params) {
      var _this319 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this319);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee319() {
        return _regeneratorRuntime.wrap(function _callee319$(_context319) {
          while (1) {
            switch (_context319.prev = _context319.next) {
              case 0:
                return _context319.abrupt("return", _super("call").call(this, "stats.get", params));

              case 1:
              case "end":
                return _context319.stop();
            }
          }
        }, _callee319, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   id: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "statsTrackVisitor",
    value: function statsTrackVisitor(params) {
      var _this320 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this320);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee320() {
        return _regeneratorRuntime.wrap(function _callee320$(_context320) {
          while (1) {
            switch (_context320.prev = _context320.next) {
              case 0:
                return _context320.abrupt("return", _super("call").call(this, "stats.trackVisitor", params));

              case 1:
              case "end":
                return _context320.stop();
            }
          }
        }, _callee320, this);
      }));
    }
    /**
     * Returns stats for a wall post.
     *
     * @param {{
     *   owner_id: (string),
     *   post_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.StatsGetPostReachResponse>}
     */

  }, {
    key: "statsGetPostReach",
    value: function statsGetPostReach(params) {
      var _this321 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this321);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee321() {
        return _regeneratorRuntime.wrap(function _callee321$(_context321) {
          while (1) {
            switch (_context321.prev = _context321.next) {
              case 0:
                return _context321.abrupt("return", _super("call").call(this, "stats.getPostReach", params));

              case 1:
              case "end":
                return _context321.stop();
            }
          }
        }, _callee321, this);
      }));
    }
    /**
     * Allows the programmer to do a quick search for any substring.
     *
     * @param {{
     *   q: (string|undefined),
     *   offset: (number|undefined),
     *   limit: (number|undefined),
     *   filters: (string[]|undefined),
     *   fields: (string[]|undefined),
     *   search_global: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SearchGetHintsResponse>}
     */

  }, {
    key: "searchGetHints",
    value: function searchGetHints(params) {
      var _this322 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this322);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee322() {
        return _regeneratorRuntime.wrap(function _callee322$(_context322) {
          while (1) {
            switch (_context322.prev = _context322.next) {
              case 0:
                return _context322.abrupt("return", _super("call").call(this, "search.getHints", params));

              case 1:
              case "end":
                return _context322.stop();
            }
          }
        }, _callee322, this);
      }));
    }
    /**
     * Returns a list of applications (apps) available to users in the App Catalog.
     *
     * @param {{
     *   sort: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number),
     *   platform: (string|undefined),
     *   extended: (boolean|undefined),
     *   return_friends: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   q: (string|undefined),
     *   genre_id: (number|undefined),
     *   filter: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsGetCatalogResponse>}
     */

  }, {
    key: "appsGetCatalog",
    value: function appsGetCatalog(params) {
      var _this323 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this323);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee323() {
        return _regeneratorRuntime.wrap(function _callee323$(_context323) {
          while (1) {
            switch (_context323.prev = _context323.next) {
              case 0:
                return _context323.abrupt("return", _super("call").call(this, "apps.getCatalog", params));

              case 1:
              case "end":
                return _context323.stop();
            }
          }
        }, _callee323, this);
      }));
    }
    /**
     * Returns applications data.
     *
     * @param {{
     *   app_id: (number|undefined),
     *   app_ids: (string[]|undefined),
     *   platform: (string|undefined),
     *   extended: (boolean|undefined),
     *   return_friends: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   name_case: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsGetResponse>}
     */

  }, {
    key: "appsGet",
    value: function appsGet(params) {
      var _this324 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this324);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee324() {
        return _regeneratorRuntime.wrap(function _callee324$(_context324) {
          while (1) {
            switch (_context324.prev = _context324.next) {
              case 0:
                return _context324.abrupt("return", _super("call").call(this, "apps.get", params));

              case 1:
              case "end":
                return _context324.stop();
            }
          }
        }, _callee324, this);
      }));
    }
    /**
     * Sends a request to another user in an app that uses VK authorization.
     *
     * @param {{
     *   user_id: (number),
     *   text: (string|undefined),
     *   type: (string|undefined),
     *   name: (string|undefined),
     *   key: (string|undefined),
     *   separate: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsSendRequestResponse>}
     */

  }, {
    key: "appsSendRequest",
    value: function appsSendRequest(params) {
      var _this325 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this325);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee325() {
        return _regeneratorRuntime.wrap(function _callee325$(_context325) {
          while (1) {
            switch (_context325.prev = _context325.next) {
              case 0:
                return _context325.abrupt("return", _super("call").call(this, "apps.sendRequest", params));

              case 1:
              case "end":
                return _context325.stop();
            }
          }
        }, _callee325, this);
      }));
    }
    /**
     * Deletes all request notifications from the current app.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "appsDeleteAppRequests",
    value: function appsDeleteAppRequests(params) {
      var _this326 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this326);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee326() {
        return _regeneratorRuntime.wrap(function _callee326$(_context326) {
          while (1) {
            switch (_context326.prev = _context326.next) {
              case 0:
                return _context326.abrupt("return", _super("call").call(this, "apps.deleteAppRequests", params));

              case 1:
              case "end":
                return _context326.stop();
            }
          }
        }, _callee326, this);
      }));
    }
    /**
     * Creates friends list for requests and invites in current app.
     *
     * @param {{
     *   extended: (boolean|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   type: (string|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsGetFriendsListResponse>}
     */

  }, {
    key: "appsGetFriendsList",
    value: function appsGetFriendsList(params) {
      var _this327 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this327);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee327() {
        return _regeneratorRuntime.wrap(function _callee327$(_context327) {
          while (1) {
            switch (_context327.prev = _context327.next) {
              case 0:
                return _context327.abrupt("return", _super("call").call(this, "apps.getFriendsList", params));

              case 1:
              case "end":
                return _context327.stop();
            }
          }
        }, _callee327, this);
      }));
    }
    /**
     * Returns players rating in the game.
     *
     * @param {{
     *   type: (string),
     *   global: (boolean|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsGetLeaderboardResponse>}
     */

  }, {
    key: "appsGetLeaderboard",
    value: function appsGetLeaderboard(params) {
      var _this328 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this328);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee328() {
        return _regeneratorRuntime.wrap(function _callee328$(_context328) {
          while (1) {
            switch (_context328.prev = _context328.next) {
              case 0:
                return _context328.abrupt("return", _super("call").call(this, "apps.getLeaderboard", params));

              case 1:
              case "end":
                return _context328.stop();
            }
          }
        }, _callee328, this);
      }));
    }
    /**
     * Adds user activity information to an application
     *
     * @param {{
     *   user_id: (number),
     *   activity_id: (number),
     *   value: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "secureAddAppEvent",
    value: function secureAddAppEvent(params) {
      var _this329 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this329);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee329() {
        return _regeneratorRuntime.wrap(function _callee329$(_context329) {
          while (1) {
            switch (_context329.prev = _context329.next) {
              case 0:
                return _context329.abrupt("return", _super("call").call(this, "secure.addAppEvent", params));

              case 1:
              case "end":
                return _context329.stop();
            }
          }
        }, _callee329, this);
      }));
    }
    /**
     * Returns user score in app
     *
     * @param {{
     *   user_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsGetScoreResponse>}
     */

  }, {
    key: "appsGetScore",
    value: function appsGetScore(params) {
      var _this330 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this330);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee330() {
        return _regeneratorRuntime.wrap(function _callee330$(_context330) {
          while (1) {
            switch (_context330.prev = _context330.next) {
              case 0:
                return _context330.abrupt("return", _super("call").call(this, "apps.getScore", params));

              case 1:
              case "end":
                return _context330.stop();
            }
          }
        }, _callee330, this);
      }));
    }
    /**
     * Returns scopes for auth
     *
     * @param {{
     *   type: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AppsGetScopesResponse>}
     */

  }, {
    key: "appsGetScopes",
    value: function appsGetScopes(params) {
      var _this331 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this331);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee331() {
        return _regeneratorRuntime.wrap(function _callee331$(_context331) {
          while (1) {
            switch (_context331.prev = _context331.next) {
              case 0:
                return _context331.abrupt("return", _super("call").call(this, "apps.getScopes", params));

              case 1:
              case "end":
                return _context331.stop();
            }
          }
        }, _callee331, this);
      }));
    }
    /**
     * Checks whether a link is blocked in VK.
     *
     * @param {{
     *   url: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UtilsCheckLinkResponse>}
     */

  }, {
    key: "utilsCheckLink",
    value: function utilsCheckLink(params) {
      var _this332 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this332);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee332() {
        return _regeneratorRuntime.wrap(function _callee332$(_context332) {
          while (1) {
            switch (_context332.prev = _context332.next) {
              case 0:
                return _context332.abrupt("return", _super("call").call(this, "utils.checkLink", params));

              case 1:
              case "end":
                return _context332.stop();
            }
          }
        }, _callee332, this);
      }));
    }
    /**
     * Deletes shortened link from user's list.
     *
     * @param {{
     *   key: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "utilsDeleteFromLastShortened",
    value: function utilsDeleteFromLastShortened(params) {
      var _this333 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this333);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee333() {
        return _regeneratorRuntime.wrap(function _callee333$(_context333) {
          while (1) {
            switch (_context333.prev = _context333.next) {
              case 0:
                return _context333.abrupt("return", _super("call").call(this, "utils.deleteFromLastShortened", params));

              case 1:
              case "end":
                return _context333.stop();
            }
          }
        }, _callee333, this);
      }));
    }
    /**
     * Returns a list of user's shortened links.
     *
     * @param {{
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UtilsGetLastShortenedLinksResponse>}
     */

  }, {
    key: "utilsGetLastShortenedLinks",
    value: function utilsGetLastShortenedLinks(params) {
      var _this334 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this334);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee334() {
        return _regeneratorRuntime.wrap(function _callee334$(_context334) {
          while (1) {
            switch (_context334.prev = _context334.next) {
              case 0:
                return _context334.abrupt("return", _super("call").call(this, "utils.getLastShortenedLinks", params));

              case 1:
              case "end":
                return _context334.stop();
            }
          }
        }, _callee334, this);
      }));
    }
    /**
     * Returns stats data for shortened link.
     *
     * @param {{
     *   key: (string),
     *   access_key: (string|undefined),
     *   interval: (string|undefined),
     *   intervals_count: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UtilsGetLinkStatsResponse>}
     */

  }, {
    key: "utilsGetLinkStats",
    value: function utilsGetLinkStats(params) {
      var _this335 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this335);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee335() {
        return _regeneratorRuntime.wrap(function _callee335$(_context335) {
          while (1) {
            switch (_context335.prev = _context335.next) {
              case 0:
                return _context335.abrupt("return", _super("call").call(this, "utils.getLinkStats", params));

              case 1:
              case "end":
                return _context335.stop();
            }
          }
        }, _callee335, this);
      }));
    }
    /**
     * Allows to receive a link shortened via vk.cc.
     *
     * @param {{
     *   url: (string),
     *   private: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UtilsGetShortLinkResponse>}
     */

  }, {
    key: "utilsGetShortLink",
    value: function utilsGetShortLink(params) {
      var _this336 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this336);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee336() {
        return _regeneratorRuntime.wrap(function _callee336$(_context336) {
          while (1) {
            switch (_context336.prev = _context336.next) {
              case 0:
                return _context336.abrupt("return", _super("call").call(this, "utils.getShortLink", params));

              case 1:
              case "end":
                return _context336.stop();
            }
          }
        }, _callee336, this);
      }));
    }
    /**
     * Detects a type of object (e.g., user, community, application) and its ID by screen name.
     *
     * @param {{
     *   screen_name: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UtilsResolveScreenNameResponse>}
     */

  }, {
    key: "utilsResolveScreenName",
    value: function utilsResolveScreenName(params) {
      var _this337 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this337);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee337() {
        return _regeneratorRuntime.wrap(function _callee337$(_context337) {
          while (1) {
            switch (_context337.prev = _context337.next) {
              case 0:
                return _context337.abrupt("return", _super("call").call(this, "utils.resolveScreenName", params));

              case 1:
              case "end":
                return _context337.stop();
            }
          }
        }, _callee337, this);
      }));
    }
    /**
     * Returns the current time of the VK server.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.UtilsGetServerTimeResponse>}
     */

  }, {
    key: "utilsGetServerTime",
    value: function utilsGetServerTime(params) {
      var _this338 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this338);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee338() {
        return _regeneratorRuntime.wrap(function _callee338$(_context338) {
          while (1) {
            switch (_context338.prev = _context338.next) {
              case 0:
                return _context338.abrupt("return", _super("call").call(this, "utils.getServerTime", params));

              case 1:
              case "end":
                return _context338.stop();
            }
          }
        }, _callee338, this);
      }));
    }
    /**
     * Returns a list of countries.
     *
     * @param {{
     *   need_all: (boolean|undefined),
     *   code: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetCountriesResponse>}
     */

  }, {
    key: "databaseGetCountries",
    value: function databaseGetCountries(params) {
      var _this339 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this339);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee339() {
        return _regeneratorRuntime.wrap(function _callee339$(_context339) {
          while (1) {
            switch (_context339.prev = _context339.next) {
              case 0:
                return _context339.abrupt("return", _super("call").call(this, "database.getCountries", params));

              case 1:
              case "end":
                return _context339.stop();
            }
          }
        }, _callee339, this);
      }));
    }
    /**
     * Returns a list of regions.
     *
     * @param {{
     *   country_id: (number),
     *   q: (string|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetRegionsResponse>}
     */

  }, {
    key: "databaseGetRegions",
    value: function databaseGetRegions(params) {
      var _this340 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this340);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee340() {
        return _regeneratorRuntime.wrap(function _callee340$(_context340) {
          while (1) {
            switch (_context340.prev = _context340.next) {
              case 0:
                return _context340.abrupt("return", _super("call").call(this, "database.getRegions", params));

              case 1:
              case "end":
                return _context340.stop();
            }
          }
        }, _callee340, this);
      }));
    }
    /**
     * Returns information about countries by their IDs.
     *
     * @param {{
     *   country_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetCountriesByIdResponse>}
     */

  }, {
    key: "databaseGetCountriesById",
    value: function databaseGetCountriesById(params) {
      var _this341 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this341);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee341() {
        return _regeneratorRuntime.wrap(function _callee341$(_context341) {
          while (1) {
            switch (_context341.prev = _context341.next) {
              case 0:
                return _context341.abrupt("return", _super("call").call(this, "database.getCountriesById", params));

              case 1:
              case "end":
                return _context341.stop();
            }
          }
        }, _callee341, this);
      }));
    }
    /**
     * Returns a list of cities.
     *
     * @param {{
     *   country_id: (number),
     *   region_id: (number|undefined),
     *   q: (string|undefined),
     *   need_all: (boolean|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetCitiesResponse>}
     */

  }, {
    key: "databaseGetCities",
    value: function databaseGetCities(params) {
      var _this342 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this342);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee342() {
        return _regeneratorRuntime.wrap(function _callee342$(_context342) {
          while (1) {
            switch (_context342.prev = _context342.next) {
              case 0:
                return _context342.abrupt("return", _super("call").call(this, "database.getCities", params));

              case 1:
              case "end":
                return _context342.stop();
            }
          }
        }, _callee342, this);
      }));
    }
    /**
     * Returns information about cities by their IDs.
     *
     * @param {{
     *   city_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetCitiesByIdResponse>}
     */

  }, {
    key: "databaseGetCitiesById",
    value: function databaseGetCitiesById(params) {
      var _this343 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this343);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee343() {
        return _regeneratorRuntime.wrap(function _callee343$(_context343) {
          while (1) {
            switch (_context343.prev = _context343.next) {
              case 0:
                return _context343.abrupt("return", _super("call").call(this, "database.getCitiesById", params));

              case 1:
              case "end":
                return _context343.stop();
            }
          }
        }, _callee343, this);
      }));
    }
    /**
     * Returns a list of higher education institutions.
     *
     * @param {{
     *   q: (string|undefined),
     *   country_id: (number|undefined),
     *   city_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetUniversitiesResponse>}
     */

  }, {
    key: "databaseGetUniversities",
    value: function databaseGetUniversities(params) {
      var _this344 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this344);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee344() {
        return _regeneratorRuntime.wrap(function _callee344$(_context344) {
          while (1) {
            switch (_context344.prev = _context344.next) {
              case 0:
                return _context344.abrupt("return", _super("call").call(this, "database.getUniversities", params));

              case 1:
              case "end":
                return _context344.stop();
            }
          }
        }, _callee344, this);
      }));
    }
    /**
     * Returns a list of schools.
     *
     * @param {{
     *   q: (string|undefined),
     *   city_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetSchoolsResponse>}
     */

  }, {
    key: "databaseGetSchools",
    value: function databaseGetSchools(params) {
      var _this345 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this345);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee345() {
        return _regeneratorRuntime.wrap(function _callee345$(_context345) {
          while (1) {
            switch (_context345.prev = _context345.next) {
              case 0:
                return _context345.abrupt("return", _super("call").call(this, "database.getSchools", params));

              case 1:
              case "end":
                return _context345.stop();
            }
          }
        }, _callee345, this);
      }));
    }
    /**
     * Returns a list of school classes specified for the country.
     *
     * @param {{
     *   country_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetSchoolClassesResponse>}
     */

  }, {
    key: "databaseGetSchoolClasses",
    value: function databaseGetSchoolClasses(params) {
      var _this346 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this346);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee346() {
        return _regeneratorRuntime.wrap(function _callee346$(_context346) {
          while (1) {
            switch (_context346.prev = _context346.next) {
              case 0:
                return _context346.abrupt("return", _super("call").call(this, "database.getSchoolClasses", params));

              case 1:
              case "end":
                return _context346.stop();
            }
          }
        }, _callee346, this);
      }));
    }
    /**
     * Returns a list of faculties (i.e., university departments).
     *
     * @param {{
     *   university_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetFacultiesResponse>}
     */

  }, {
    key: "databaseGetFaculties",
    value: function databaseGetFaculties(params) {
      var _this347 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this347);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee347() {
        return _regeneratorRuntime.wrap(function _callee347$(_context347) {
          while (1) {
            switch (_context347.prev = _context347.next) {
              case 0:
                return _context347.abrupt("return", _super("call").call(this, "database.getFaculties", params));

              case 1:
              case "end":
                return _context347.stop();
            }
          }
        }, _callee347, this);
      }));
    }
    /**
     * Returns list of chairs on a specified faculty.
     *
     * @param {{
     *   faculty_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetChairsResponse>}
     */

  }, {
    key: "databaseGetChairs",
    value: function databaseGetChairs(params) {
      var _this348 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this348);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee348() {
        return _regeneratorRuntime.wrap(function _callee348$(_context348) {
          while (1) {
            switch (_context348.prev = _context348.next) {
              case 0:
                return _context348.abrupt("return", _super("call").call(this, "database.getChairs", params));

              case 1:
              case "end":
                return _context348.stop();
            }
          }
        }, _callee348, this);
      }));
    }
    /**
     * Returns a list of user gifts.
     *
     * @param {{
     *   user_id: (number|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GiftsGetResponse>}
     */

  }, {
    key: "giftsGet",
    value: function giftsGet(params) {
      var _this349 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this349);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee349() {
        return _regeneratorRuntime.wrap(function _callee349$(_context349) {
          while (1) {
            switch (_context349.prev = _context349.next) {
              case 0:
                return _context349.abrupt("return", _super("call").call(this, "gifts.get", params));

              case 1:
              case "end":
                return _context349.stop();
            }
          }
        }, _callee349, this);
      }));
    }
    /**
     * Returns a list of advertising accounts.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetAccountsResponse>}
     */

  }, {
    key: "adsGetAccounts",
    value: function adsGetAccounts(params) {
      var _this350 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this350);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee350() {
        return _regeneratorRuntime.wrap(function _callee350$(_context350) {
          while (1) {
            switch (_context350.prev = _context350.next) {
              case 0:
                return _context350.abrupt("return", _super("call").call(this, "ads.getAccounts", params));

              case 1:
              case "end":
                return _context350.stop();
            }
          }
        }, _callee350, this);
      }));
    }
    /**
     * Returns a list of advertising agency's clients.
     *
     * @param {{
     *   account_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetClientsResponse>}
     */

  }, {
    key: "adsGetClients",
    value: function adsGetClients(params) {
      var _this351 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this351);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee351() {
        return _regeneratorRuntime.wrap(function _callee351$(_context351) {
          while (1) {
            switch (_context351.prev = _context351.next) {
              case 0:
                return _context351.abrupt("return", _super("call").call(this, "ads.getClients", params));

              case 1:
              case "end":
                return _context351.stop();
            }
          }
        }, _callee351, this);
      }));
    }
    /**
     * Creates clients of an advertising agency.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsCreateClientsResponse>}
     */

  }, {
    key: "adsCreateClients",
    value: function adsCreateClients(params) {
      var _this352 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this352);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee352() {
        return _regeneratorRuntime.wrap(function _callee352$(_context352) {
          while (1) {
            switch (_context352.prev = _context352.next) {
              case 0:
                return _context352.abrupt("return", _super("call").call(this, "ads.createClients", params));

              case 1:
              case "end":
                return _context352.stop();
            }
          }
        }, _callee352, this);
      }));
    }
    /**
     * Edits clients of an advertising agency.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsUpdateClientsResponse>}
     */

  }, {
    key: "adsUpdateClients",
    value: function adsUpdateClients(params) {
      var _this353 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this353);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee353() {
        return _regeneratorRuntime.wrap(function _callee353$(_context353) {
          while (1) {
            switch (_context353.prev = _context353.next) {
              case 0:
                return _context353.abrupt("return", _super("call").call(this, "ads.updateClients", params));

              case 1:
              case "end":
                return _context353.stop();
            }
          }
        }, _callee353, this);
      }));
    }
    /**
     * Archives clients of an advertising agency.
     *
     * @param {{
     *   account_id: (number),
     *   ids: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsDeleteClientsResponse>}
     */

  }, {
    key: "adsDeleteClients",
    value: function adsDeleteClients(params) {
      var _this354 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this354);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee354() {
        return _regeneratorRuntime.wrap(function _callee354$(_context354) {
          while (1) {
            switch (_context354.prev = _context354.next) {
              case 0:
                return _context354.abrupt("return", _super("call").call(this, "ads.deleteClients", params));

              case 1:
              case "end":
                return _context354.stop();
            }
          }
        }, _callee354, this);
      }));
    }
    /**
     * Returns a list of campaigns in an advertising account.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   include_deleted: (boolean|undefined),
     *   campaign_ids: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetCampaignsResponse>}
     */

  }, {
    key: "adsGetCampaigns",
    value: function adsGetCampaigns(params) {
      var _this355 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this355);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee355() {
        return _regeneratorRuntime.wrap(function _callee355$(_context355) {
          while (1) {
            switch (_context355.prev = _context355.next) {
              case 0:
                return _context355.abrupt("return", _super("call").call(this, "ads.getCampaigns", params));

              case 1:
              case "end":
                return _context355.stop();
            }
          }
        }, _callee355, this);
      }));
    }
    /**
     * Creates advertising campaigns.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsCreateCampaignsResponse>}
     */

  }, {
    key: "adsCreateCampaigns",
    value: function adsCreateCampaigns(params) {
      var _this356 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this356);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee356() {
        return _regeneratorRuntime.wrap(function _callee356$(_context356) {
          while (1) {
            switch (_context356.prev = _context356.next) {
              case 0:
                return _context356.abrupt("return", _super("call").call(this, "ads.createCampaigns", params));

              case 1:
              case "end":
                return _context356.stop();
            }
          }
        }, _callee356, this);
      }));
    }
    /**
     * Edits advertising campaigns.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsUpdateCampaignsResponse>}
     */

  }, {
    key: "adsUpdateCampaigns",
    value: function adsUpdateCampaigns(params) {
      var _this357 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this357);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee357() {
        return _regeneratorRuntime.wrap(function _callee357$(_context357) {
          while (1) {
            switch (_context357.prev = _context357.next) {
              case 0:
                return _context357.abrupt("return", _super("call").call(this, "ads.updateCampaigns", params));

              case 1:
              case "end":
                return _context357.stop();
            }
          }
        }, _callee357, this);
      }));
    }
    /**
     * Archives advertising campaigns.
     *
     * @param {{
     *   account_id: (number),
     *   ids: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsDeleteCampaignsResponse>}
     */

  }, {
    key: "adsDeleteCampaigns",
    value: function adsDeleteCampaigns(params) {
      var _this358 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this358);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee358() {
        return _regeneratorRuntime.wrap(function _callee358$(_context358) {
          while (1) {
            switch (_context358.prev = _context358.next) {
              case 0:
                return _context358.abrupt("return", _super("call").call(this, "ads.deleteCampaigns", params));

              case 1:
              case "end":
                return _context358.stop();
            }
          }
        }, _callee358, this);
      }));
    }
    /**
     * Returns number of ads.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   include_deleted: (boolean|undefined),
     *   campaign_ids: (string|undefined),
     *   ad_ids: (string|undefined),
     *   limit: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetAdsResponse>}
     */

  }, {
    key: "adsGetAds",
    value: function adsGetAds(params) {
      var _this359 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this359);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee359() {
        return _regeneratorRuntime.wrap(function _callee359$(_context359) {
          while (1) {
            switch (_context359.prev = _context359.next) {
              case 0:
                return _context359.abrupt("return", _super("call").call(this, "ads.getAds", params));

              case 1:
              case "end":
                return _context359.stop();
            }
          }
        }, _callee359, this);
      }));
    }
    /**
     * Returns descriptions of ad layouts.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   include_deleted: (boolean|undefined),
     *   campaign_ids: (string|undefined),
     *   ad_ids: (string|undefined),
     *   limit: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetAdsLayoutResponse>}
     */

  }, {
    key: "adsGetAdsLayout",
    value: function adsGetAdsLayout(params) {
      var _this360 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this360);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee360() {
        return _regeneratorRuntime.wrap(function _callee360$(_context360) {
          while (1) {
            switch (_context360.prev = _context360.next) {
              case 0:
                return _context360.abrupt("return", _super("call").call(this, "ads.getAdsLayout", params));

              case 1:
              case "end":
                return _context360.stop();
            }
          }
        }, _callee360, this);
      }));
    }
    /**
     * Returns ad targeting parameters.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   include_deleted: (boolean|undefined),
     *   campaign_ids: (string|undefined),
     *   ad_ids: (string|undefined),
     *   limit: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetAdsTargetingResponse>}
     */

  }, {
    key: "adsGetAdsTargeting",
    value: function adsGetAdsTargeting(params) {
      var _this361 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this361);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee361() {
        return _regeneratorRuntime.wrap(function _callee361$(_context361) {
          while (1) {
            switch (_context361.prev = _context361.next) {
              case 0:
                return _context361.abrupt("return", _super("call").call(this, "ads.getAdsTargeting", params));

              case 1:
              case "end":
                return _context361.stop();
            }
          }
        }, _callee361, this);
      }));
    }
    /**
     * Creates ads.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsCreateAdsResponse>}
     */

  }, {
    key: "adsCreateAds",
    value: function adsCreateAds(params) {
      var _this362 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this362);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee362() {
        return _regeneratorRuntime.wrap(function _callee362$(_context362) {
          while (1) {
            switch (_context362.prev = _context362.next) {
              case 0:
                return _context362.abrupt("return", _super("call").call(this, "ads.createAds", params));

              case 1:
              case "end":
                return _context362.stop();
            }
          }
        }, _callee362, this);
      }));
    }
    /**
     * Edits ads.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsUpdateAdsResponse>}
     */

  }, {
    key: "adsUpdateAds",
    value: function adsUpdateAds(params) {
      var _this363 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this363);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee363() {
        return _regeneratorRuntime.wrap(function _callee363$(_context363) {
          while (1) {
            switch (_context363.prev = _context363.next) {
              case 0:
                return _context363.abrupt("return", _super("call").call(this, "ads.updateAds", params));

              case 1:
              case "end":
                return _context363.stop();
            }
          }
        }, _callee363, this);
      }));
    }
    /**
     * Archives ads.
     *
     * @param {{
     *   account_id: (number),
     *   ids: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsDeleteAdsResponse>}
     */

  }, {
    key: "adsDeleteAds",
    value: function adsDeleteAds(params) {
      var _this364 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this364);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee364() {
        return _regeneratorRuntime.wrap(function _callee364$(_context364) {
          while (1) {
            switch (_context364.prev = _context364.next) {
              case 0:
                return _context364.abrupt("return", _super("call").call(this, "ads.deleteAds", params));

              case 1:
              case "end":
                return _context364.stop();
            }
          }
        }, _callee364, this);
      }));
    }
    /**
     * Allows to check the ad link.
     *
     * @param {{
     *   account_id: (number),
     *   link_type: (string),
     *   link_url: (string),
     *   campaign_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsCheckLinkResponse>}
     */

  }, {
    key: "adsCheckLink",
    value: function adsCheckLink(params) {
      var _this365 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this365);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee365() {
        return _regeneratorRuntime.wrap(function _callee365$(_context365) {
          while (1) {
            switch (_context365.prev = _context365.next) {
              case 0:
                return _context365.abrupt("return", _super("call").call(this, "ads.checkLink", params));

              case 1:
              case "end":
                return _context365.stop();
            }
          }
        }, _callee365, this);
      }));
    }
    /**
     * Returns statistics of performance indicators for ads, campaigns, clients or the whole account.
     *
     * @param {{
     *   account_id: (number),
     *   ids_type: (string),
     *   ids: (string),
     *   period: (string),
     *   date_from: (string),
     *   date_to: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetStatisticsResponse>}
     */

  }, {
    key: "adsGetStatistics",
    value: function adsGetStatistics(params) {
      var _this366 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this366);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee366() {
        return _regeneratorRuntime.wrap(function _callee366$(_context366) {
          while (1) {
            switch (_context366.prev = _context366.next) {
              case 0:
                return _context366.abrupt("return", _super("call").call(this, "ads.getStatistics", params));

              case 1:
              case "end":
                return _context366.stop();
            }
          }
        }, _callee366, this);
      }));
    }
    /**
     * Returns demographics for ads or campaigns.
     *
     * @param {{
     *   account_id: (number),
     *   ids_type: (string),
     *   ids: (string),
     *   period: (string),
     *   date_from: (string),
     *   date_to: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetDemographicsResponse>}
     */

  }, {
    key: "adsGetDemographics",
    value: function adsGetDemographics(params) {
      var _this367 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this367);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee367() {
        return _regeneratorRuntime.wrap(function _callee367$(_context367) {
          while (1) {
            switch (_context367.prev = _context367.next) {
              case 0:
                return _context367.abrupt("return", _super("call").call(this, "ads.getDemographics", params));

              case 1:
              case "end":
                return _context367.stop();
            }
          }
        }, _callee367, this);
      }));
    }
    /**
     * Returns current budget of the advertising account.
     *
     * @param {{
     *   account_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetBudgetResponse>}
     */

  }, {
    key: "adsGetBudget",
    value: function adsGetBudget(params) {
      var _this368 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this368);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee368() {
        return _regeneratorRuntime.wrap(function _callee368$(_context368) {
          while (1) {
            switch (_context368.prev = _context368.next) {
              case 0:
                return _context368.abrupt("return", _super("call").call(this, "ads.getBudget", params));

              case 1:
              case "end":
                return _context368.stop();
            }
          }
        }, _callee368, this);
      }));
    }
    /**
     * Returns a list of managers and supervisors of advertising account.
     *
     * @param {{
     *   account_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetOfficeUsersResponse>}
     */

  }, {
    key: "adsGetOfficeUsers",
    value: function adsGetOfficeUsers(params) {
      var _this369 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this369);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee369() {
        return _regeneratorRuntime.wrap(function _callee369$(_context369) {
          while (1) {
            switch (_context369.prev = _context369.next) {
              case 0:
                return _context369.abrupt("return", _super("call").call(this, "ads.getOfficeUsers", params));

              case 1:
              case "end":
                return _context369.stop();
            }
          }
        }, _callee369, this);
      }));
    }
    /**
     * Adds managers and/or supervisors to advertising account.
     *
     * @param {{
     *   account_id: (number),
     *   data: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsAddOfficeUsersResponse>}
     */

  }, {
    key: "adsAddOfficeUsers",
    value: function adsAddOfficeUsers(params) {
      var _this370 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this370);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee370() {
        return _regeneratorRuntime.wrap(function _callee370$(_context370) {
          while (1) {
            switch (_context370.prev = _context370.next) {
              case 0:
                return _context370.abrupt("return", _super("call").call(this, "ads.addOfficeUsers", params));

              case 1:
              case "end":
                return _context370.stop();
            }
          }
        }, _callee370, this);
      }));
    }
    /**
     * Removes managers and/or supervisors from advertising account.
     *
     * @param {{
     *   account_id: (number),
     *   ids: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsRemoveOfficeUsersResponse>}
     */

  }, {
    key: "adsRemoveOfficeUsers",
    value: function adsRemoveOfficeUsers(params) {
      var _this371 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this371);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee371() {
        return _regeneratorRuntime.wrap(function _callee371$(_context371) {
          while (1) {
            switch (_context371.prev = _context371.next) {
              case 0:
                return _context371.abrupt("return", _super("call").call(this, "ads.removeOfficeUsers", params));

              case 1:
              case "end":
                return _context371.stop();
            }
          }
        }, _callee371, this);
      }));
    }
    /**
     * Returns the size of targeting audience, and also recommended values for CPC and CPM.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   criteria: (string|undefined),
     *   ad_id: (number|undefined),
     *   ad_format: (number|undefined),
     *   ad_platform: (string|undefined),
     *   ad_platform_no_wall: (string|undefined),
     *   ad_platform_no_ad_network: (string|undefined),
     *   link_url: (string),
     *   link_domain: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetTargetingStatsResponse>}
     */

  }, {
    key: "adsGetTargetingStats",
    value: function adsGetTargetingStats(params) {
      var _this372 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this372);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee372() {
        return _regeneratorRuntime.wrap(function _callee372$(_context372) {
          while (1) {
            switch (_context372.prev = _context372.next) {
              case 0:
                return _context372.abrupt("return", _super("call").call(this, "ads.getTargetingStats", params));

              case 1:
              case "end":
                return _context372.stop();
            }
          }
        }, _callee372, this);
      }));
    }
    /**
     * Returns a set of auto-suggestions for various targeting parameters.
     *
     * @param {{
     *   section: (string),
     *   ids: (string|undefined),
     *   q: (string|undefined),
     *   country: (number|undefined),
     *   cities: (string|undefined),
     *   lang: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetSuggestionsResponse>}
     */

  }, {
    key: "adsGetSuggestions",
    value: function adsGetSuggestions(params) {
      var _this373 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this373);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee373() {
        return _regeneratorRuntime.wrap(function _callee373$(_context373) {
          while (1) {
            switch (_context373.prev = _context373.next) {
              case 0:
                return _context373.abrupt("return", _super("call").call(this, "ads.getSuggestions", params));

              case 1:
              case "end":
                return _context373.stop();
            }
          }
        }, _callee373, this);
      }));
    }
    /**
     * Returns a list of possible ad categories.
     *
     * @param {{
     *   lang: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetCategoriesResponse>}
     */

  }, {
    key: "adsGetCategories",
    value: function adsGetCategories(params) {
      var _this374 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this374);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee374() {
        return _regeneratorRuntime.wrap(function _callee374$(_context374) {
          while (1) {
            switch (_context374.prev = _context374.next) {
              case 0:
                return _context374.abrupt("return", _super("call").call(this, "ads.getCategories", params));

              case 1:
              case "end":
                return _context374.stop();
            }
          }
        }, _callee374, this);
      }));
    }
    /**
     * Returns URL to upload an ad photo to.
     *
     * @param {{
     *   ad_format: (number),
     *   icon: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetUploadURLResponse>}
     */

  }, {
    key: "adsGetUploadURL",
    value: function adsGetUploadURL(params) {
      var _this375 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this375);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee375() {
        return _regeneratorRuntime.wrap(function _callee375$(_context375) {
          while (1) {
            switch (_context375.prev = _context375.next) {
              case 0:
                return _context375.abrupt("return", _super("call").call(this, "ads.getUploadURL", params));

              case 1:
              case "end":
                return _context375.stop();
            }
          }
        }, _callee375, this);
      }));
    }
    /**
     * Returns URL to upload an ad video to.
     *
     * @param {{
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetVideoUploadURLResponse>}
     */

  }, {
    key: "adsGetVideoUploadURL",
    value: function adsGetVideoUploadURL(params) {
      var _this376 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this376);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee376() {
        return _regeneratorRuntime.wrap(function _callee376$(_context376) {
          while (1) {
            switch (_context376.prev = _context376.next) {
              case 0:
                return _context376.abrupt("return", _super("call").call(this, "ads.getVideoUploadURL", params));

              case 1:
              case "end":
                return _context376.stop();
            }
          }
        }, _callee376, this);
      }));
    }
    /**
     * Returns information about current state of a counter — number of remaining runs of methods and time to the next counter nulling in seconds.
     *
     * @param {{
     *   account_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetFloodStatsResponse>}
     */

  }, {
    key: "adsGetFloodStats",
    value: function adsGetFloodStats(params) {
      var _this377 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this377);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee377() {
        return _regeneratorRuntime.wrap(function _callee377$(_context377) {
          while (1) {
            switch (_context377.prev = _context377.next) {
              case 0:
                return _context377.abrupt("return", _super("call").call(this, "ads.getFloodStats", params));

              case 1:
              case "end":
                return _context377.stop();
            }
          }
        }, _callee377, this);
      }));
    }
    /**
     * Returns a reason of ad rejection for pre-moderation.
     *
     * @param {{
     *   account_id: (number),
     *   ad_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetRejectionReasonResponse>}
     */

  }, {
    key: "adsGetRejectionReason",
    value: function adsGetRejectionReason(params) {
      var _this378 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this378);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee378() {
        return _regeneratorRuntime.wrap(function _callee378$(_context378) {
          while (1) {
            switch (_context378.prev = _context378.next) {
              case 0:
                return _context378.abrupt("return", _super("call").call(this, "ads.getRejectionReason", params));

              case 1:
              case "end":
                return _context378.stop();
            }
          }
        }, _callee378, this);
      }));
    }
    /**
     * Creates a group to re-target ads for users who visited advertiser's site (viewed information about the product, registered, etc.).
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   name: (string),
     *   lifetime: (number|undefined),
     *   target_pixel_id: (number|undefined),
     *   target_pixel_rules: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsCreateTargetGroupResponse>}
     */

  }, {
    key: "adsCreateTargetGroup",
    value: function adsCreateTargetGroup(params) {
      var _this379 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this379);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee379() {
        return _regeneratorRuntime.wrap(function _callee379$(_context379) {
          while (1) {
            switch (_context379.prev = _context379.next) {
              case 0:
                return _context379.abrupt("return", _super("call").call(this, "ads.createTargetGroup", params));

              case 1:
              case "end":
                return _context379.stop();
            }
          }
        }, _callee379, this);
      }));
    }
    /**
     * Edits a retarget group.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   target_group_id: (number),
     *   name: (string),
     *   domain: (string|undefined),
     *   lifetime: (number|undefined),
     *   target_pixel_id: (number|undefined),
     *   target_pixel_rules: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "adsUpdateTargetGroup",
    value: function adsUpdateTargetGroup(params) {
      var _this380 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this380);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee380() {
        return _regeneratorRuntime.wrap(function _callee380$(_context380) {
          while (1) {
            switch (_context380.prev = _context380.next) {
              case 0:
                return _context380.abrupt("return", _super("call").call(this, "ads.updateTargetGroup", params));

              case 1:
              case "end":
                return _context380.stop();
            }
          }
        }, _callee380, this);
      }));
    }
    /**
     * Deletes a retarget group.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   target_group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "adsDeleteTargetGroup",
    value: function adsDeleteTargetGroup(params) {
      var _this381 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this381);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee381() {
        return _regeneratorRuntime.wrap(function _callee381$(_context381) {
          while (1) {
            switch (_context381.prev = _context381.next) {
              case 0:
                return _context381.abrupt("return", _super("call").call(this, "ads.deleteTargetGroup", params));

              case 1:
              case "end":
                return _context381.stop();
            }
          }
        }, _callee381, this);
      }));
    }
    /**
     * Returns a list of target groups.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsGetTargetGroupsResponse>}
     */

  }, {
    key: "adsGetTargetGroups",
    value: function adsGetTargetGroups(params) {
      var _this382 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this382);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee382() {
        return _regeneratorRuntime.wrap(function _callee382$(_context382) {
          while (1) {
            switch (_context382.prev = _context382.next) {
              case 0:
                return _context382.abrupt("return", _super("call").call(this, "ads.getTargetGroups", params));

              case 1:
              case "end":
                return _context382.stop();
            }
          }
        }, _callee382, this);
      }));
    }
    /**
     * Imports a list of advertiser's contacts to count VK registered users against the target group.
     *
     * @param {{
     *   account_id: (number),
     *   client_id: (number|undefined),
     *   target_group_id: (number),
     *   contacts: (string),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.AdsImportTargetContactsResponse>}
     */

  }, {
    key: "adsImportTargetContacts",
    value: function adsImportTargetContacts(params) {
      var _this383 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this383);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee383() {
        return _regeneratorRuntime.wrap(function _callee383$(_context383) {
          while (1) {
            switch (_context383.prev = _context383.next) {
              case 0:
                return _context383.abrupt("return", _super("call").call(this, "ads.importTargetContacts", params));

              case 1:
              case "end":
                return _context383.stop();
            }
          }
        }, _callee383, this);
      }));
    }
    /**
     * Checks the user authentication in 'IFrame' and 'Flash' apps using the 'access_token' parameter.
     *
     * @param {{
     *   token: (string|undefined),
     *   ip: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.SecureCheckTokenResponse>}
     */

  }, {
    key: "secureCheckToken",
    value: function secureCheckToken(params) {
      var _this384 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this384);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee384() {
        return _regeneratorRuntime.wrap(function _callee384$(_context384) {
          while (1) {
            switch (_context384.prev = _context384.next) {
              case 0:
                return _context384.abrupt("return", _super("call").call(this, "secure.checkToken", params));

              case 1:
              case "end":
                return _context384.stop();
            }
          }
        }, _callee384, this);
      }));
    }
    /**
     * Returns items list for a community.
     *
     * @param {{
     *   owner_id: (number),
     *   album_id: (number|undefined),
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketGetResponse>}
     */

  }, {
    key: "marketGet",
    value: function marketGet(params) {
      var _this385 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this385);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee385() {
        return _regeneratorRuntime.wrap(function _callee385$(_context385) {
          while (1) {
            switch (_context385.prev = _context385.next) {
              case 0:
                return _context385.abrupt("return", _super("call").call(this, "market.get", params));

              case 1:
              case "end":
                return _context385.stop();
            }
          }
        }, _callee385, this);
      }));
    }
    /**
     * Returns information about market items by their ids.
     *
     * @param {{
     *   item_ids: (string[]),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketGetByIdResponse>}
     */

  }, {
    key: "marketGetById",
    value: function marketGetById(params) {
      var _this386 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this386);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee386() {
        return _regeneratorRuntime.wrap(function _callee386$(_context386) {
          while (1) {
            switch (_context386.prev = _context386.next) {
              case 0:
                return _context386.abrupt("return", _super("call").call(this, "market.getById", params));

              case 1:
              case "end":
                return _context386.stop();
            }
          }
        }, _callee386, this);
      }));
    }
    /**
     * Searches market items in a community's catalog
     *
     * @param {{
     *   owner_id: (number),
     *   album_id: (number|undefined),
     *   q: (string|undefined),
     *   price_from: (number|undefined),
     *   price_to: (number|undefined),
     *   tags: (number[]|undefined),
     *   sort: (number|undefined),
     *   rev: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   status: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketSearchResponse>}
     */

  }, {
    key: "marketSearch",
    value: function marketSearch(params) {
      var _this387 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this387);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee387() {
        return _regeneratorRuntime.wrap(function _callee387$(_context387) {
          while (1) {
            switch (_context387.prev = _context387.next) {
              case 0:
                return _context387.abrupt("return", _super("call").call(this, "market.search", params));

              case 1:
              case "end":
                return _context387.stop();
            }
          }
        }, _callee387, this);
      }));
    }
    /**
     * Returns community's collections list.
     *
     * @param {{
     *   owner_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketGetAlbumsResponse>}
     */

  }, {
    key: "marketGetAlbums",
    value: function marketGetAlbums(params) {
      var _this388 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this388);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee388() {
        return _regeneratorRuntime.wrap(function _callee388$(_context388) {
          while (1) {
            switch (_context388.prev = _context388.next) {
              case 0:
                return _context388.abrupt("return", _super("call").call(this, "market.getAlbums", params));

              case 1:
              case "end":
                return _context388.stop();
            }
          }
        }, _callee388, this);
      }));
    }
    /**
     * Returns items album's data
     *
     * @param {{
     *   owner_id: (number),
     *   album_ids: (number[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketGetAlbumByIdResponse>}
     */

  }, {
    key: "marketGetAlbumById",
    value: function marketGetAlbumById(params) {
      var _this389 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this389);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee389() {
        return _regeneratorRuntime.wrap(function _callee389$(_context389) {
          while (1) {
            switch (_context389.prev = _context389.next) {
              case 0:
                return _context389.abrupt("return", _super("call").call(this, "market.getAlbumById", params));

              case 1:
              case "end":
                return _context389.stop();
            }
          }
        }, _callee389, this);
      }));
    }
    /**
     * Creates a new comment for an item.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   from_group: (boolean|undefined),
     *   reply_to_comment: (number|undefined),
     *   sticker_id: (number|undefined),
     *   guid: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketCreateCommentResponse>}
     */

  }, {
    key: "marketCreateComment",
    value: function marketCreateComment(params) {
      var _this390 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this390);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee390() {
        return _regeneratorRuntime.wrap(function _callee390$(_context390) {
          while (1) {
            switch (_context390.prev = _context390.next) {
              case 0:
                return _context390.abrupt("return", _super("call").call(this, "market.createComment", params));

              case 1:
              case "end":
                return _context390.stop();
            }
          }
        }, _callee390, this);
      }));
    }
    /**
     * Returns comments list for an item.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   need_likes: (boolean|undefined),
     *   start_comment_id: (number|undefined),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   sort: (string|undefined),
     *   extended: (boolean|undefined),
     *   fields: (Models.UsersFields[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketGetCommentsResponse>}
     */

  }, {
    key: "marketGetComments",
    value: function marketGetComments(params) {
      var _this391 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this391);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee391() {
        return _regeneratorRuntime.wrap(function _callee391$(_context391) {
          while (1) {
            switch (_context391.prev = _context391.next) {
              case 0:
                return _context391.abrupt("return", _super("call").call(this, "market.getComments", params));

              case 1:
              case "end":
                return _context391.stop();
            }
          }
        }, _callee391, this);
      }));
    }
    /**
     * Deletes an item's comment
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketDeleteCommentResponse>}
     */

  }, {
    key: "marketDeleteComment",
    value: function marketDeleteComment(params) {
      var _this392 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this392);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee392() {
        return _regeneratorRuntime.wrap(function _callee392$(_context392) {
          while (1) {
            switch (_context392.prev = _context392.next) {
              case 0:
                return _context392.abrupt("return", _super("call").call(this, "market.deleteComment", params));

              case 1:
              case "end":
                return _context392.stop();
            }
          }
        }, _callee392, this);
      }));
    }
    /**
     * Restores a recently deleted comment
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketRestoreCommentResponse>}
     */

  }, {
    key: "marketRestoreComment",
    value: function marketRestoreComment(params) {
      var _this393 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this393);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee393() {
        return _regeneratorRuntime.wrap(function _callee393$(_context393) {
          while (1) {
            switch (_context393.prev = _context393.next) {
              case 0:
                return _context393.abrupt("return", _super("call").call(this, "market.restoreComment", params));

              case 1:
              case "end":
                return _context393.stop();
            }
          }
        }, _callee393, this);
      }));
    }
    /**
     * Chages item comment's text
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   message: (string|undefined),
     *   attachments: (string[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketEditComment",
    value: function marketEditComment(params) {
      var _this394 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this394);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee394() {
        return _regeneratorRuntime.wrap(function _callee394$(_context394) {
          while (1) {
            switch (_context394.prev = _context394.next) {
              case 0:
                return _context394.abrupt("return", _super("call").call(this, "market.editComment", params));

              case 1:
              case "end":
                return _context394.stop();
            }
          }
        }, _callee394, this);
      }));
    }
    /**
     * Sends a complaint to the item's comment.
     *
     * @param {{
     *   owner_id: (number),
     *   comment_id: (number),
     *   reason: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketReportComment",
    value: function marketReportComment(params) {
      var _this395 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this395);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee395() {
        return _regeneratorRuntime.wrap(function _callee395$(_context395) {
          while (1) {
            switch (_context395.prev = _context395.next) {
              case 0:
                return _context395.abrupt("return", _super("call").call(this, "market.reportComment", params));

              case 1:
              case "end":
                return _context395.stop();
            }
          }
        }, _callee395, this);
      }));
    }
    /**
     * Returns a list of market categories.
     *
     * @param {{
     *   count: (number|undefined),
     *   offset: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketGetCategoriesResponse>}
     */

  }, {
    key: "marketGetCategories",
    value: function marketGetCategories(params) {
      var _this396 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this396);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee396() {
        return _regeneratorRuntime.wrap(function _callee396$(_context396) {
          while (1) {
            switch (_context396.prev = _context396.next) {
              case 0:
                return _context396.abrupt("return", _super("call").call(this, "market.getCategories", params));

              case 1:
              case "end":
                return _context396.stop();
            }
          }
        }, _callee396, this);
      }));
    }
    /**
     * Sends a complaint to the item.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   reason: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketReport",
    value: function marketReport(params) {
      var _this397 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this397);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee397() {
        return _regeneratorRuntime.wrap(function _callee397$(_context397) {
          while (1) {
            switch (_context397.prev = _context397.next) {
              case 0:
                return _context397.abrupt("return", _super("call").call(this, "market.report", params));

              case 1:
              case "end":
                return _context397.stop();
            }
          }
        }, _callee397, this);
      }));
    }
    /**
     * Ads a new item to the market.
     *
     * @param {{
     *   owner_id: (number),
     *   name: (string),
     *   description: (string),
     *   category_id: (number),
     *   price: (number),
     *   deleted: (boolean|undefined),
     *   main_photo_id: (number),
     *   photo_ids: (number[]|undefined),
     *   url: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketAddResponse>}
     */

  }, {
    key: "marketAdd",
    value: function marketAdd(params) {
      var _this398 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this398);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee398() {
        return _regeneratorRuntime.wrap(function _callee398$(_context398) {
          while (1) {
            switch (_context398.prev = _context398.next) {
              case 0:
                return _context398.abrupt("return", _super("call").call(this, "market.add", params));

              case 1:
              case "end":
                return _context398.stop();
            }
          }
        }, _callee398, this);
      }));
    }
    /**
     * Edits an item.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   name: (string),
     *   description: (string),
     *   category_id: (number),
     *   price: (number),
     *   deleted: (boolean|undefined),
     *   main_photo_id: (number),
     *   photo_ids: (number[]|undefined),
     *   url: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketEdit",
    value: function marketEdit(params) {
      var _this399 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this399);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee399() {
        return _regeneratorRuntime.wrap(function _callee399$(_context399) {
          while (1) {
            switch (_context399.prev = _context399.next) {
              case 0:
                return _context399.abrupt("return", _super("call").call(this, "market.edit", params));

              case 1:
              case "end":
                return _context399.stop();
            }
          }
        }, _callee399, this);
      }));
    }
    /**
     * Deletes an item.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketDelete",
    value: function marketDelete(params) {
      var _this400 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this400);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee400() {
        return _regeneratorRuntime.wrap(function _callee400$(_context400) {
          while (1) {
            switch (_context400.prev = _context400.next) {
              case 0:
                return _context400.abrupt("return", _super("call").call(this, "market.delete", params));

              case 1:
              case "end":
                return _context400.stop();
            }
          }
        }, _callee400, this);
      }));
    }
    /**
     * Restores recently deleted item
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketRestore",
    value: function marketRestore(params) {
      var _this401 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this401);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee401() {
        return _regeneratorRuntime.wrap(function _callee401$(_context401) {
          while (1) {
            switch (_context401.prev = _context401.next) {
              case 0:
                return _context401.abrupt("return", _super("call").call(this, "market.restore", params));

              case 1:
              case "end":
                return _context401.stop();
            }
          }
        }, _callee401, this);
      }));
    }
    /**
     * Changes item place in a collection.
     *
     * @param {{
     *   owner_id: (number),
     *   album_id: (number|undefined),
     *   item_id: (number),
     *   before: (number|undefined),
     *   after: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketReorderItems",
    value: function marketReorderItems(params) {
      var _this402 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this402);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee402() {
        return _regeneratorRuntime.wrap(function _callee402$(_context402) {
          while (1) {
            switch (_context402.prev = _context402.next) {
              case 0:
                return _context402.abrupt("return", _super("call").call(this, "market.reorderItems", params));

              case 1:
              case "end":
                return _context402.stop();
            }
          }
        }, _callee402, this);
      }));
    }
    /**
     * Reorders the collections list.
     *
     * @param {{
     *   owner_id: (number),
     *   album_id: (number),
     *   before: (number|undefined),
     *   after: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketReorderAlbums",
    value: function marketReorderAlbums(params) {
      var _this403 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this403);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee403() {
        return _regeneratorRuntime.wrap(function _callee403$(_context403) {
          while (1) {
            switch (_context403.prev = _context403.next) {
              case 0:
                return _context403.abrupt("return", _super("call").call(this, "market.reorderAlbums", params));

              case 1:
              case "end":
                return _context403.stop();
            }
          }
        }, _callee403, this);
      }));
    }
    /**
     * Creates new collection of items
     *
     * @param {{
     *   owner_id: (number),
     *   title: (string),
     *   photo_id: (number|undefined),
     *   main_album: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.MarketAddAlbumResponse>}
     */

  }, {
    key: "marketAddAlbum",
    value: function marketAddAlbum(params) {
      var _this404 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this404);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee404() {
        return _regeneratorRuntime.wrap(function _callee404$(_context404) {
          while (1) {
            switch (_context404.prev = _context404.next) {
              case 0:
                return _context404.abrupt("return", _super("call").call(this, "market.addAlbum", params));

              case 1:
              case "end":
                return _context404.stop();
            }
          }
        }, _callee404, this);
      }));
    }
    /**
     * Edits a collection of items
     *
     * @param {{
     *   owner_id: (number),
     *   album_id: (number),
     *   title: (string),
     *   photo_id: (number|undefined),
     *   main_album: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketEditAlbum",
    value: function marketEditAlbum(params) {
      var _this405 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this405);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee405() {
        return _regeneratorRuntime.wrap(function _callee405$(_context405) {
          while (1) {
            switch (_context405.prev = _context405.next) {
              case 0:
                return _context405.abrupt("return", _super("call").call(this, "market.editAlbum", params));

              case 1:
              case "end":
                return _context405.stop();
            }
          }
        }, _callee405, this);
      }));
    }
    /**
     * Deletes a collection of items.
     *
     * @param {{
     *   owner_id: (number),
     *   album_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketDeleteAlbum",
    value: function marketDeleteAlbum(params) {
      var _this406 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this406);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee406() {
        return _regeneratorRuntime.wrap(function _callee406$(_context406) {
          while (1) {
            switch (_context406.prev = _context406.next) {
              case 0:
                return _context406.abrupt("return", _super("call").call(this, "market.deleteAlbum", params));

              case 1:
              case "end":
                return _context406.stop();
            }
          }
        }, _callee406, this);
      }));
    }
    /**
     * Removes an item from one or multiple collections.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   album_ids: (number[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketRemoveFromAlbum",
    value: function marketRemoveFromAlbum(params) {
      var _this407 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this407);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee407() {
        return _regeneratorRuntime.wrap(function _callee407$(_context407) {
          while (1) {
            switch (_context407.prev = _context407.next) {
              case 0:
                return _context407.abrupt("return", _super("call").call(this, "market.removeFromAlbum", params));

              case 1:
              case "end":
                return _context407.stop();
            }
          }
        }, _callee407, this);
      }));
    }
    /**
     * Adds an item to one or multiple collections.
     *
     * @param {{
     *   owner_id: (number),
     *   item_id: (number),
     *   album_ids: (number[]),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "marketAddToAlbum",
    value: function marketAddToAlbum(params) {
      var _this408 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this408);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee408() {
        return _regeneratorRuntime.wrap(function _callee408$(_context408) {
          while (1) {
            switch (_context408.prev = _context408.next) {
              case 0:
                return _context408.abrupt("return", _super("call").call(this, "market.addToAlbum", params));

              case 1:
              case "end":
                return _context408.stop();
            }
          }
        }, _callee408, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountBan",
    value: function accountBan(params) {
      var _this409 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this409);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee409() {
        return _regeneratorRuntime.wrap(function _callee409$(_context409) {
          while (1) {
            switch (_context409.prev = _context409.next) {
              case 0:
                return _context409.abrupt("return", _super("call").call(this, "account.ban", params));

              case 1:
              case "end":
                return _context409.stop();
            }
          }
        }, _callee409, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "accountUnban",
    value: function accountUnban(params) {
      var _this410 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this410);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee410() {
        return _regeneratorRuntime.wrap(function _callee410$(_context410) {
          while (1) {
            switch (_context410.prev = _context410.next) {
              case 0:
                return _context410.abrupt("return", _super("call").call(this, "account.unban", params));

              case 1:
              case "end":
                return _context410.stop();
            }
          }
        }, _callee410, this);
      }));
    }
    /**
     * Get metro stations by city
     *
     * @param {{
     *   city_id: (number),
     *   offset: (number|undefined),
     *   count: (number|undefined),
     *   extended: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetMetroStationsResponse>}
     */

  }, {
    key: "databaseGetMetroStations",
    value: function databaseGetMetroStations(params) {
      var _this411 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this411);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee411() {
        return _regeneratorRuntime.wrap(function _callee411$(_context411) {
          while (1) {
            switch (_context411.prev = _context411.next) {
              case 0:
                return _context411.abrupt("return", _super("call").call(this, "database.getMetroStations", params));

              case 1:
              case "end":
                return _context411.stop();
            }
          }
        }, _callee411, this);
      }));
    }
    /**
     * Get metro station by his id
     *
     * @param {{
     *   station_ids: (number[]|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.DatabaseGetMetroStationsByIdResponse>}
     */

  }, {
    key: "databaseGetMetroStationsById",
    value: function databaseGetMetroStationsById(params) {
      var _this412 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this412);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee412() {
        return _regeneratorRuntime.wrap(function _callee412$(_context412) {
          while (1) {
            switch (_context412.prev = _context412.next) {
              case 0:
                return _context412.abrupt("return", _super("call").call(this, "database.getMetroStationsById", params));

              case 1:
              case "end":
                return _context412.stop();
            }
          }
        }, _callee412, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   owner_id: (number|undefined),
     *   end_date: (number|undefined),
     *   reason: (number|undefined),
     *   comment: (string|undefined),
     *   comment_visible: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsBan",
    value: function groupsBan(params) {
      var _this413 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this413);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee413() {
        return _regeneratorRuntime.wrap(function _callee413$(_context413) {
          while (1) {
            switch (_context413.prev = _context413.next) {
              case 0:
                return _context413.abrupt("return", _super("call").call(this, "groups.ban", params));

              case 1:
              case "end":
                return _context413.stop();
            }
          }
        }, _callee413, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   server_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsDeleteCallbackServer",
    value: function groupsDeleteCallbackServer(params) {
      var _this414 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this414);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee414() {
        return _regeneratorRuntime.wrap(function _callee414$(_context414) {
          while (1) {
            switch (_context414.prev = _context414.next) {
              case 0:
                return _context414.abrupt("return", _super("call").call(this, "groups.deleteCallbackServer", params));

              case 1:
              case "end":
                return _context414.stop();
            }
          }
        }, _callee414, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsDisableOnline",
    value: function groupsDisableOnline(params) {
      var _this415 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this415);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee415() {
        return _regeneratorRuntime.wrap(function _callee415$(_context415) {
          while (1) {
            switch (_context415.prev = _context415.next) {
              case 0:
                return _context415.abrupt("return", _super("call").call(this, "groups.disableOnline", params));

              case 1:
              case "end":
                return _context415.stop();
            }
          }
        }, _callee415, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   server_id: (number),
     *   url: (string),
     *   title: (string),
     *   secret_key: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsEditCallbackServer",
    value: function groupsEditCallbackServer(params) {
      var _this416 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this416);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee416() {
        return _regeneratorRuntime.wrap(function _callee416$(_context416) {
          while (1) {
            switch (_context416.prev = _context416.next) {
              case 0:
                return _context416.abrupt("return", _super("call").call(this, "groups.editCallbackServer", params));

              case 1:
              case "end":
                return _context416.stop();
            }
          }
        }, _callee416, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsEnableOnline",
    value: function groupsEnableOnline(params) {
      var _this417 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this417);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee417() {
        return _regeneratorRuntime.wrap(function _callee417$(_context417) {
          while (1) {
            switch (_context417.prev = _context417.next) {
              case 0:
                return _context417.abrupt("return", _super("call").call(this, "groups.enableOnline", params));

              case 1:
              case "end":
                return _context417.stop();
            }
          }
        }, _callee417, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   owner_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "groupsUnban",
    value: function groupsUnban(params) {
      var _this418 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this418);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee418() {
        return _regeneratorRuntime.wrap(function _callee418$(_context418) {
          while (1) {
            switch (_context418.prev = _context418.next) {
              case 0:
                return _context418.abrupt("return", _super("call").call(this, "groups.unban", params));

              case 1:
              case "end":
                return _context418.stop();
            }
          }
        }, _callee418, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   title: (string),
     *   address: (string),
     *   additional_address: (string|undefined),
     *   country_id: (number),
     *   city_id: (number),
     *   metro_id: (number|undefined),
     *   latitude: (number),
     *   longitude: (number),
     *   phone: (string|undefined),
     *   work_info_status: (string|undefined),
     *   timetable: (string|undefined),
     *   is_main_address: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsAddAddressResponse>}
     */

  }, {
    key: "groupsAddAddress",
    value: function groupsAddAddress(params) {
      var _this419 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this419);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee419() {
        return _regeneratorRuntime.wrap(function _callee419$(_context419) {
          while (1) {
            switch (_context419.prev = _context419.next) {
              case 0:
                return _context419.abrupt("return", _super("call").call(this, "groups.addAddress", params));

              case 1:
              case "end":
                return _context419.stop();
            }
          }
        }, _callee419, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   group_id: (number),
     *   address_id: (number),
     *   title: (string|undefined),
     *   address: (string|undefined),
     *   additional_address: (string|undefined),
     *   country_id: (number|undefined),
     *   city_id: (number|undefined),
     *   metro_id: (number|undefined),
     *   latitude: (number|undefined),
     *   longitude: (number|undefined),
     *   phone: (string|undefined),
     *   work_info_status: (string|undefined),
     *   timetable: (string|undefined),
     *   is_main_address: (boolean|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.GroupsEditAddressResponse>}
     */

  }, {
    key: "groupsEditAddress",
    value: function groupsEditAddress(params) {
      var _this420 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this420);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee420() {
        return _regeneratorRuntime.wrap(function _callee420$(_context420) {
          while (1) {
            switch (_context420.prev = _context420.next) {
              case 0:
                return _context420.abrupt("return", _super("call").call(this, "groups.editAddress", params));

              case 1:
              case "end":
                return _context420.stop();
            }
          }
        }, _callee420, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   peer_id: (number),
     *   group_id: (number|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "messagesUnpin",
    value: function messagesUnpin(params) {
      var _this421 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this421);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee421() {
        return _regeneratorRuntime.wrap(function _callee421$(_context421) {
          while (1) {
            switch (_context421.prev = _context421.next) {
              case 0:
                return _context421.abrupt("return", _super("call").call(this, "messages.unpin", params));

              case 1:
              case "end":
                return _context421.stop();
            }
          }
        }, _callee421, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   monthly_tier: (string|undefined),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.OkResponse>}
     */

  }, {
    key: "streamingSetSettings",
    value: function streamingSetSettings(params) {
      var _this422 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this422);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee422() {
        return _regeneratorRuntime.wrap(function _callee422$(_context422) {
          while (1) {
            switch (_context422.prev = _context422.next) {
              case 0:
                return _context422.abrupt("return", _super("call").call(this, "streaming.setSettings", params));

              case 1:
              case "end":
                return _context422.stop();
            }
          }
        }, _callee422, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   owner_id: (number),
     *   post_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BaseBoolResponse>}
     */

  }, {
    key: "wallCloseComments",
    value: function wallCloseComments(params) {
      var _this423 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this423);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee423() {
        return _regeneratorRuntime.wrap(function _callee423$(_context423) {
          while (1) {
            switch (_context423.prev = _context423.next) {
              case 0:
                return _context423.abrupt("return", _super("call").call(this, "wall.closeComments", params));

              case 1:
              case "end":
                return _context423.stop();
            }
          }
        }, _callee423, this);
      }));
    }
    /**
     * undefined
     *
     * @param {{
     *   owner_id: (number),
     *   post_id: (number),
     *   access_token: (string|undefined)
     * }} params
     *
     * @returns {Promise<Responses.BaseBoolResponse>}
     */

  }, {
    key: "wallOpenComments",
    value: function wallOpenComments(params) {
      var _this424 = this;

      var _super = function _super(name) {
        return _get(_getPrototypeOf(VKApi.prototype), name, _this424);
      };

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee424() {
        return _regeneratorRuntime.wrap(function _callee424$(_context424) {
          while (1) {
            switch (_context424.prev = _context424.next) {
              case 0:
                return _context424.abrupt("return", _super("call").call(this, "wall.openComments", params));

              case 1:
              case "end":
                return _context424.stop();
            }
          }
        }, _callee424, this);
      }));
    }
  }]);

  return VKApi;
}(BaseVKApi_1.BaseVKApi);

exports.VKApi = VKApi;